msgid ""
msgstr ""
"POT-Creation-Date: 2025-06-21 23:16+0200\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: hr\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#. placeholder {0}: call.name
#. placeholder {1}: call.summary
#: src/share/components/chat/ChatMessage.tsx
msgid "{0} — {1}"
msgstr "{0} — {1}"

#. placeholder {0}: fixedFormat(item.volume ?? 0)
#. placeholder {1}: item.count ?? 0
#. placeholder {2}: displayDate(new Date(item.since ?? '')) ?? ''
#: src/timber/components/provider/ProviderDetail/ProviderAttentionList.tsx
msgid "{0} m³ in {1} pieces has been standing since {2}."
msgstr "{0} m³ u {1} komada stoji od {2}."

#. placeholder {0}: file.row_count
#: src/share/components/chat/ChatFileList.tsx
msgid "{0} row(s)"
msgstr "{0} redaka"

#. placeholder {0}: call.name
#: src/share/components/chat/ChatMessage.tsx
msgid "{0} running…"
msgstr "{0} se izvodi…"

#: src/share/components/layout/Layout/Layout.tsx
msgid "+ Add column"
msgstr "+ Dodaj stupac"

#: src/share/components/gdpr/CookieConsent.tsx
msgid "Accept"
msgstr "Prihvati"

#: src/pages/ActivationPage.tsx
msgid "Access token is valid"
msgstr "Pristupni token je valjan"

#: src/timber/components/accountingUser/AccountingUserDetail/AccountingUserDetail.tsx
#: src/timber/pages/accountingUser/AccountingUserEntityPage.tsx
msgid "Accounting User"
msgstr "Računovođa"

#: src/timber/hooks/useAccountingUser.ts
msgid "Accounting User add error: "
msgstr "Pogreška pri dodavanju računovođe: "

#: src/timber/hooks/useAccountingUser.ts
msgid "Accounting User delete error: "
msgstr "Pogreška pri brisanju računovođe: "

#: src/timber/hooks/useAccountingUser.ts
msgid "Accounting User deleted"
msgstr "Računovođa je obrisan"

#: src/timber/hooks/useAccountingUser.ts
msgid "Accounting User update error: "
msgstr "Pogreška pri ažuriranju računovođe: "

#: src/timber/hooks/useAccountingUser.ts
msgid "Accounting User updated"
msgstr "Računovođa je ažuriran"

#: src/app/mappers.tsx
#: src/auth/components/user/UserDetail/UserTabs.tsx
#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListHeader.tsx
#: src/timber/pages/listItems.tsx
msgid "Accounting Users"
msgstr "Računovođe"

#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryAddForm.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
#: src/timber/components/history/HistoryList/HistoryListItem.tsx
#: src/timber/components/history/HistoryList/HistoryListSearch.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryAddForm.tsx
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryUpdateForm.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryAddForm.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx
msgid "Action"
msgstr "Radnja"

#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryAddForm.tsx
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryAddForm.tsx
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryUpdateForm.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryAddForm.tsx
msgid "Action is required"
msgstr "Radnja je obavezna"

#: src/pages/ActivationPage.tsx
msgid "Activate"
msgstr "Aktiviraj"

#: src/auth/components/user/UserDetail/UserDetail.tsx
#: src/auth/components/user/UserForm/UserAddForm.tsx
#: src/auth/components/user/UserForm/UserUpdateForm.tsx
#: src/auth/components/user/UserList/UserListItem.tsx
msgid "Activated"
msgstr "Aktivirano"

#: src/pages/ActivationPage.tsx
msgid "Activation"
msgstr "Aktivacija"

#: src/pages/ActivationPage.tsx
msgid "Activation code is required"
msgstr "Kod za aktivaciju je obavezan"

#: src/pages/ActivationPage.tsx
msgid "Activation Token"
msgstr "Token za aktivaciju"

#: src/timber/components/cutting/CuttingList/ActiveCuttings.tsx
#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
#: src/timber/components/provider/ProviderList/ProviderListItem.tsx
msgid "Active cuttings"
msgstr "Aktivni sječe"

#: src/address/components/address/AddressForm/AddressAddFormProvider.tsx
#: src/address/components/address/AddressList/AddressListHeader.tsx
#: src/address/components/userAddress/UserAddressForm/UserAddressAddFormProvider.tsx
#: src/address/components/userAddress/UserAddressList/UserAddressListHeader.tsx
#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupAddFormProvider.tsx
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListHeader.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserAddFormProvider.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListHeader.tsx
#: src/auth/components/role/RoleForm/RoleAddFormProvider.tsx
#: src/auth/components/role/RoleList/RoleListHeader.tsx
#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddFormProvider.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListHeader.tsx
#: src/auth/components/rolePermission/RolePermissionForm/RolePermissionAddFormProvider.tsx
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListHeader.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddFormProvider.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListHeader.tsx
#: src/auth/components/user/UserForm/UserAddFormProvider.tsx
#: src/auth/components/user/UserList/UserListHeader.tsx
#: src/auth/components/userSession/UserSessionForm/UserSessionAddFormProvider.tsx
#: src/auth/components/userSession/UserSessionList/UserSessionListHeader.tsx
#: src/location/components/location/LocationForm/LocationAddFormProvider.tsx
#: src/location/components/location/LocationList/LocationListHeader.tsx
#: src/share/components/breadcrumbs/RouterBreadcrumbs.tsx
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserAddFormProvider.tsx
#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListHeader.tsx
#: src/timber/components/buyer/BuyerForm/BuyerAddFormProvider.tsx
#: src/timber/components/buyer/BuyerList/BuyerListHeader.tsx
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddFormProvider.tsx
#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListHeader.tsx
#: src/timber/components/contractor/ContractorForm/ContractorAddFormProvider.tsx
#: src/timber/components/contractor/ContractorList/ContractorListHeader.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddFormProvider.tsx
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListHeader.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddFormProvider.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListHeader.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryAddFormProvider.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListHeader.tsx
#: src/timber/components/cutting/CuttingForm/CuttingAddFormProvider.tsx
#: src/timber/components/cutting/CuttingList/CuttingListHeader.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerAddFormProvider.tsx
#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListHeader.tsx
#: src/timber/components/log/LogForm/LogAddFormProvider.tsx
#: src/timber/components/log/LogList/LogListHeader.tsx
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryAddFormProvider.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListHeader.tsx
#: src/timber/components/price/PriceForm/PriceAddFormProvider.tsx
#: src/timber/components/price/PriceList/PriceListHeader.tsx
#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileAddFormProvider.tsx
#: src/timber/components/pricingProfile/PricingProfileList/PricingProfileListHeader.tsx
#: src/timber/components/provider/ProviderForm/ProviderAddFormProvider.tsx
#: src/timber/components/provider/ProviderList/ProviderListHeader.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddFormProvider.tsx
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListHeader.tsx
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierAddFormProvider.tsx
#: src/timber/components/roadCarrier/RoadCarrierList/RoadCarrierListHeader.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddFormProvider.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListHeader.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryAddFormProvider.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListHeader.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddFormProvider.tsx
#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListHeader.tsx
#: src/timber/components/timberClass/TimberClassForm/TimberClassAddFormProvider.tsx
#: src/timber/components/timberClass/TimberClassList/TimberClassListHeader.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddFormProvider.tsx
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListHeader.tsx
#: src/timber/components/timberType/TimberTypeForm/TimberTypeAddFormProvider.tsx
#: src/timber/components/timberType/TimberTypeList/TimberTypeListHeader.tsx
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddFormProvider.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListHeader.tsx
msgid "Add"
msgstr "Dodaj"

#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserFormSelect.tsx
#: src/timber/pages/accountingUser/AccountingUserAddEditPage.tsx
msgid "Add Accounting User"
msgstr "Dodaj računovođu"

#: src/address/components/address/AddressForm/AddressFormSelect.tsx
#: src/address/pages/address/AddressAddEditPage.tsx
msgid "Add Address"
msgstr "Dodaj Adresu"

#: src/timber/components/buyer/BuyerForm/BuyerFormSelect.tsx
#: src/timber/pages/buyer/BuyerAddEditPage.tsx
msgid "Add Buyer"
msgstr "Dodaj Kupca"

#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserFormSelect.tsx
#: src/timber/pages/buyerUser/BuyerUserAddEditPage.tsx
msgid "Add Buyer User"
msgstr "Dodaj Korisnika Kupca"

#: src/timber/components/contractor/ContractorForm/ContractorFormSelect.tsx
#: src/timber/pages/contractor/ContractorAddEditPage.tsx
msgid "Add Contractor"
msgstr "Dodaj Izvođača"

#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserFormSelect.tsx
#: src/timber/pages/contractorUser/ContractorUserAddEditPage.tsx
msgid "Add Contractor User"
msgstr "Dodaj Korisnika Izvođača"

#: src/timber/components/cordwood/CordwoodForm/CordwoodFormSelect.tsx
#: src/timber/pages/cordwood/CordwoodAddEditPage.tsx
msgid "Add Cordwood"
msgstr "Dodaj Višemetricu"

#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryFormSelect.tsx
#: src/timber/pages/cordwoodHistory/CordwoodHistoryAddEditPage.tsx
msgid "Add Cordwood History"
msgstr "Dodaj Povijest Višemetrice"

#: src/timber/components/cutting/CuttingForm/CuttingFormSelect.tsx
#: src/timber/pages/cutting/CuttingAddEditPage.tsx
msgid "Add Cutting"
msgstr "Dodaj Sječu"

#: src/timber/pages/driver/DriverAddEditPage.tsx
#~ msgid "Add Driver"
#~ msgstr "Dodaj Vozača"

#: src/address/hooks/useAddress.ts
#: src/address/hooks/useUserAddress.ts
#: src/auth/hooks/useMembersGroup.ts
#: src/auth/hooks/useMembersGroupUser.ts
#: src/auth/hooks/useRole.ts
#: src/auth/hooks/useRoleAssignment.ts
#: src/auth/hooks/useRolePermission.ts
#: src/auth/hooks/useScopeGroup.ts
#: src/auth/hooks/useUser.ts
#: src/auth/hooks/useUserSession.ts
#: src/location/hooks/useLocation.ts
#: src/timber/hooks/useAccountingUser.ts
#: src/timber/hooks/useBuyer.ts
#: src/timber/hooks/useBuyerUser.ts
#: src/timber/hooks/useContractor.ts
#: src/timber/hooks/useContractorUser.ts
#: src/timber/hooks/useCordwood.ts
#: src/timber/hooks/useCordwoodHistory.ts
#: src/timber/hooks/useCutting.ts
#: src/timber/hooks/useForestOwner.ts
#: src/timber/hooks/useLog.ts
#: src/timber/hooks/useLogHistory.ts
#: src/timber/hooks/usePrice.ts
#: src/timber/hooks/usePricingProfile.ts
#: src/timber/hooks/useProvider.ts
#: src/timber/hooks/useProviderUser.ts
#: src/timber/hooks/useRoadCarrier.ts
#: src/timber/hooks/useShipment.ts
#: src/timber/hooks/useShipmentHistory.ts
#: src/timber/hooks/useThicknessClass.ts
#: src/timber/hooks/useTimberClass.ts
#: src/timber/hooks/useTimberStorage.ts
#: src/timber/hooks/useTimberType.ts
#: src/timber/hooks/useTreeMarking.ts
msgid "Add error: "
msgstr "Greška pri dodavanju: "

#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerFormSelect.tsx
#: src/timber/pages/forestOwner/ForestOwnerAddEditPage.tsx
msgid "Add Forest Owner"
msgstr "Dodaj Vlasnika Šume"

#: src/location/components/location/LocationForm/LocationFormSelect.tsx
#: src/location/pages/location/LocationAddEditPage.tsx
msgid "Add Location"
msgstr "Dodaj Lokaciju"

#: src/timber/components/log/LogForm/LogFormSelect.tsx
#: src/timber/pages/log/LogAddEditPage.tsx
msgid "Add Log"
msgstr "Dodaj Trupac"

#: src/timber/components/logHistory/LogHistoryForm/LogHistoryFormSelect.tsx
#: src/timber/pages/logHistory/LogHistoryAddEditPage.tsx
msgid "Add Log History"
msgstr "Dodaj Povijest Trupca"

#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupFormSelect.tsx
#: src/auth/pages/membersGroup/MembersGroupAddEditPage.tsx
msgid "Add Members Group"
msgstr "Dodaj Grupu Članova"

#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserFormSelect.tsx
#: src/auth/pages/membersGroupUser/MembersGroupUserAddEditPage.tsx
msgid "Add Members Group User"
msgstr "Dodaj Korisnika Grupe Članova"

#: src/timber/components/price/PriceForm/PriceFormSelect.tsx
#: src/timber/pages/price/PriceAddEditPage.tsx
msgid "Add Price"
msgstr "Dodaj cijenu"

#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileFormSelect.tsx
#: src/timber/pages/pricingProfile/PricingProfileAddEditPage.tsx
msgid "Add Pricing Profile"
msgstr "Dodaj cijenovni profil"

#: src/timber/components/provider/ProviderForm/ProviderFormSelect.tsx
#: src/timber/pages/provider/ProviderAddEditPage.tsx
msgid "Add Provider"
msgstr "Dodaj pružatelja usluge"

#: src/timber/components/providerUser/ProviderUserForm/ProviderUserFormSelect.tsx
#: src/timber/pages/providerUser/ProviderUserAddEditPage.tsx
msgid "Add Provider User"
msgstr "Dodaj Korisnika pružatelja usluge"

#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierFormSelect.tsx
#: src/timber/pages/roadCarrier/RoadCarrierAddEditPage.tsx
msgid "Add Road Carrier"
msgstr "Dodaj Prijevoznika"

#: src/auth/components/role/RoleForm/RoleFormSelect.tsx
#: src/auth/pages/role/RoleAddEditPage.tsx
msgid "Add Role"
msgstr "Dodaj Ulogu"

#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentFormSelect.tsx
#: src/auth/pages/roleAssignment/RoleAssignmentAddEditPage.tsx
msgid "Add Role Assignment"
msgstr "Dodaj Dodjelu Uloge"

#: src/auth/components/rolePermission/RolePermissionForm/RolePermissionFormSelect.tsx
#: src/auth/pages/rolePermission/RolePermissionAddEditPage.tsx
msgid "Add Role Permission"
msgstr "Dodaj Dozvolu Uloge"

#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupFormSelect.tsx
#: src/auth/pages/scopeGroup/ScopeGroupAddEditPage.tsx
msgid "Add Scope Group"
msgstr "Dodaj Grupni Domet"

#: src/timber/components/shipment/ShipmentForm/ShipmentFormSelect.tsx
#: src/timber/pages/shipment/ShipmentAddEditPage.tsx
msgid "Add Shipment"
msgstr "Dodaj Pošiljku"

#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryFormSelect.tsx
#: src/timber/pages/shipmentHistory/ShipmentHistoryAddEditPage.tsx
msgid "Add Shipment History"
msgstr "Dodaj Povijest Pošiljke"

#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassFormSelect.tsx
#: src/timber/pages/thicknessClass/ThicknessClassAddEditPage.tsx
msgid "Add Thickness Class"
msgstr "Dodaj Klasu Debljine"

#: src/timber/components/timberClass/TimberClassForm/TimberClassFormSelect.tsx
#: src/timber/pages/timberClass/TimberClassAddEditPage.tsx
msgid "Add Timber Class"
msgstr "Dodaj Klase Drva"

#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageFormSelect.tsx
#: src/timber/pages/timberStorage/TimberStorageAddEditPage.tsx
msgid "Add Timber Storage"
msgstr "Dodaj Skladište Drva"

#: src/timber/components/timberType/TimberTypeForm/TimberTypeFormSelect.tsx
#: src/timber/pages/timberType/TimberTypeAddEditPage.tsx
msgid "Add Timber Type"
msgstr "Dodaj Vrstu Drva"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx
msgid "Add to shipment"
msgstr "Dodaj u pošiljku"

#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingFormSelect.tsx
#: src/timber/pages/treeMarking/TreeMarkingAddEditPage.tsx
msgid "Add Tree Marking"
msgstr "Dodaj doznaku"

#: src/auth/components/user/UserForm/UserFormSelect.tsx
#: src/auth/pages/user/UserAddEditPage.tsx
msgid "Add User"
msgstr "Dodaj Korisnika"

#: src/address/components/userAddress/UserAddressForm/UserAddressFormSelect.tsx
#: src/address/pages/userAddress/UserAddressAddEditPage.tsx
msgid "Add User Address"
msgstr "Dodaj Korisničku Adresu"

#: src/auth/components/userSession/UserSessionForm/UserSessionFormSelect.tsx
#: src/auth/pages/userSession/UserSessionAddEditPage.tsx
msgid "Add User Session"
msgstr "Dodaj Korisničku Sesiju"

#: src/address/components/address/AddressDetail/AddressDetail.tsx
#: src/address/components/address/AddressForm/AddressAddForm.tsx
#: src/address/components/address/AddressForm/AddressUpdateForm.tsx
#: src/address/components/address/AddressList/AddressListItem.tsx
#: src/address/components/userAddress/UserAddressDetail/UserAddressDetail.tsx
#: src/address/components/userAddress/UserAddressForm/UserAddressAddForm.tsx
#: src/address/components/userAddress/UserAddressList/UserAddressListItem.tsx
#: src/address/pages/address/AddressEntityPage.tsx
#: src/location/components/location/LocationDetail/LocationDetail.tsx
#: src/location/components/location/LocationForm/LocationAddForm.tsx
#: src/location/components/location/LocationForm/LocationUpdateForm.tsx
#: src/location/components/location/LocationList/LocationListItem.tsx
#: src/timber/components/buyer/BuyerDetail/BuyerDetail.tsx
#: src/timber/components/buyer/BuyerForm/BuyerAddForm.tsx
#: src/timber/components/buyer/BuyerForm/BuyerUpdateForm.tsx
#: src/timber/components/contractor/ContractorDetail/ContractorDetail.tsx
#: src/timber/components/contractor/ContractorForm/ContractorAddForm.tsx
#: src/timber/components/contractor/ContractorForm/ContractorUpdateForm.tsx
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerDetail.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerAddForm.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerUpdateForm.tsx
#: src/timber/components/provider/ProviderDetail/ProviderDetail.tsx
#: src/timber/components/provider/ProviderForm/ProviderAddForm.tsx
#: src/timber/components/provider/ProviderForm/ProviderUpdateForm.tsx
#: src/timber/components/roadCarrier/RoadCarrierDetail/RoadCarrierDetail.tsx
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierAddForm.tsx
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierUpdateForm.tsx
msgid "Address"
msgstr "Adresa"

#: src/address/hooks/useAddress.ts
msgid "Address add error: "
msgstr "Pogreška pri dodavanju adrese: "

#: src/address/hooks/useAddress.ts
msgid "Address delete error: "
msgstr "Pogreška pri brisanju adrese: "

#: src/address/hooks/useAddress.ts
msgid "Address deleted"
msgstr "Adresa je obrisana"

#: src/address/components/userAddress/UserAddressForm/UserAddressAddForm.tsx
#~ msgid "Address Id is required"
#~ msgstr "Identifikator adrese je obavezan"

#: src/address/components/userAddress/UserAddressForm/UserAddressAddForm.tsx
msgid "Address is required"
msgstr "Adresa je obavezna"

#: src/address/hooks/useAddress.ts
msgid "Address update error: "
msgstr "Pogreška pri ažuriranju adrese: "

#: src/address/hooks/useAddress.ts
msgid "Address updated"
msgstr "Adresa je ažurirana"

#: src/address/components/address/AddressList/AddressListHeader.tsx
#: src/address/pages/listItems.tsx
#: src/app/mappers.tsx
msgid "Addresses"
msgstr "Adrese"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
msgid "Adjust prices to the target total amount"
msgstr "Prilagodi cijene prema ciljanom totalnom iznosu"

#: src/app/App.tsx
#: src/timber/types/models/UserType.d.ts
msgid "Admin"
msgstr "Admin"

#: src/share/components/chat/ChatHeader.tsx
msgid "AI Assistant"
msgstr "AI pomoćnik"

#: src/share/components/chat/serverErrors.ts
#: src/share/components/chat/useChat.ts
msgid "AI chat is restricted to admin, providerAdmin or providerUser."
msgstr "AI chat je ograničen na administratora, administratora davatelja usluge i korisnika davatelja usluge."

#: src/timber/components/history/HistoryList/HistoryListSearch.tsx
msgid "All"
msgstr "Sve"

#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
msgid "Allows Multi Storage Shipments"
msgstr "Omogućuje otpreme s više skladišta"

#: src/pages/LoginPage.tsx
msgid "and"
msgstr "i"

#. placeholder {0}: group.items.length - ITEMS_PER_GROUP
#: src/timber/components/provider/ProviderDetail/ProviderAttentionList.tsx
msgid "and {0} more"
msgstr "i još {0}"

#: src/share/components/form/FormDateTime/FormDateRange.tsx
msgid "Apply"
msgstr "Primjeni"

#: src/share/components/chat/ChatThread.tsx
msgid "Ask about logs, shipments, buyers, or other timber data"
msgstr "Pitajte o logovima, otpremama, kupcima ili drugim podacima o drvu"

#: src/auth/pages/scopeGroup/ScopeGroupDetailPage.tsx
msgid "Assign"
msgstr "Dodijeli"

#: src/timber/components/generic/report/GenericRootShipments.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx
msgid "at"
msgstr "na"

#: src/auth/pages/listItems.tsx
msgid "Auth"
msgstr "Autorizacija"

#: src/address/pages/address/AddressAddEditPage.tsx
#: src/address/pages/address/AddressDetailPage.tsx
#: src/address/pages/address/AddressUpdateEditPage.tsx
#: src/address/pages/userAddress/UserAddressAddEditPage.tsx
#: src/address/pages/userAddress/UserAddressDetailPage.tsx
#: src/address/pages/userAddress/UserAddressUpdateEditPage.tsx
#: src/auth/pages/membersGroup/MembersGroupAddEditPage.tsx
#: src/auth/pages/membersGroup/MembersGroupDetailPage.tsx
#: src/auth/pages/membersGroup/MembersGroupUpdateEditPage.tsx
#: src/auth/pages/membersGroupUser/MembersGroupUserAddEditPage.tsx
#: src/auth/pages/membersGroupUser/MembersGroupUserDetailPage.tsx
#: src/auth/pages/membersGroupUser/MembersGroupUserUpdateEditPage.tsx
#: src/auth/pages/role/RoleAddEditPage.tsx
#: src/auth/pages/role/RoleDetailPage.tsx
#: src/auth/pages/role/RoleUpdateEditPage.tsx
#: src/auth/pages/roleAssignment/RoleAssignmentAddEditPage.tsx
#: src/auth/pages/roleAssignment/RoleAssignmentDetailPage.tsx
#: src/auth/pages/roleAssignment/RoleAssignmentUpdateEditPage.tsx
#: src/auth/pages/rolePermission/RolePermissionAddEditPage.tsx
#: src/auth/pages/rolePermission/RolePermissionDetailPage.tsx
#: src/auth/pages/rolePermission/RolePermissionUpdateEditPage.tsx
#: src/auth/pages/scopeGroup/ScopeGroupAddEditPage.tsx
#: src/auth/pages/scopeGroup/ScopeGroupDetailPage.tsx
#: src/auth/pages/scopeGroup/ScopeGroupUpdateEditPage.tsx
#: src/auth/pages/user/UserAddEditPage.tsx
#: src/auth/pages/user/UserDetailPage.tsx
#: src/auth/pages/user/UserUpdateEditPage.tsx
#: src/auth/pages/userSession/UserSessionAddEditPage.tsx
#: src/auth/pages/userSession/UserSessionDetailPage.tsx
#: src/auth/pages/userSession/UserSessionUpdateEditPage.tsx
#: src/location/pages/location/LocationAddEditPage.tsx
#: src/location/pages/location/LocationDetailPage.tsx
#: src/location/pages/location/LocationUpdateEditPage.tsx
#: src/timber/pages/accountingUser/AccountingUserAddEditPage.tsx
#: src/timber/pages/accountingUser/AccountingUserDetailPage.tsx
#: src/timber/pages/accountingUser/AccountingUserUpdateEditPage.tsx
#: src/timber/pages/buyer/BuyerAddEditPage.tsx
#: src/timber/pages/buyer/BuyerDetailPage.tsx
#: src/timber/pages/buyer/BuyerUpdateEditPage.tsx
#: src/timber/pages/buyerUser/BuyerUserAddEditPage.tsx
#: src/timber/pages/buyerUser/BuyerUserDetailPage.tsx
#: src/timber/pages/buyerUser/BuyerUserUpdateEditPage.tsx
#: src/timber/pages/contractor/ContractorAddEditPage.tsx
#: src/timber/pages/contractor/ContractorDetailPage.tsx
#: src/timber/pages/contractor/ContractorUpdateEditPage.tsx
#: src/timber/pages/contractorUser/ContractorUserAddEditPage.tsx
#: src/timber/pages/contractorUser/ContractorUserDetailPage.tsx
#: src/timber/pages/contractorUser/ContractorUserUpdateEditPage.tsx
#: src/timber/pages/cordwood/CordwoodAddEditPage.tsx
#: src/timber/pages/cordwood/CordwoodDetailPage.tsx
#: src/timber/pages/cordwood/CordwoodUpdateEditPage.tsx
#: src/timber/pages/cordwoodHistory/CordwoodHistoryAddEditPage.tsx
#: src/timber/pages/cordwoodHistory/CordwoodHistoryDetailPage.tsx
#: src/timber/pages/cordwoodHistory/CordwoodHistoryUpdateEditPage.tsx
#: src/timber/pages/cutting/CuttingAddEditPage.tsx
#: src/timber/pages/cutting/CuttingDetailPage.tsx
#: src/timber/pages/cutting/CuttingUpdateEditPage.tsx
#: src/timber/pages/forestOwner/ForestOwnerAddEditPage.tsx
#: src/timber/pages/forestOwner/ForestOwnerDetailPage.tsx
#: src/timber/pages/forestOwner/ForestOwnerUpdateEditPage.tsx
#: src/timber/pages/log/LogAddEditPage.tsx
#: src/timber/pages/log/LogDetailPage.tsx
#: src/timber/pages/log/LogUpdateEditPage.tsx
#: src/timber/pages/logHistory/LogHistoryAddEditPage.tsx
#: src/timber/pages/logHistory/LogHistoryDetailPage.tsx
#: src/timber/pages/logHistory/LogHistoryUpdateEditPage.tsx
#: src/timber/pages/price/PriceAddEditPage.tsx
#: src/timber/pages/price/PriceDetailPage.tsx
#: src/timber/pages/price/PriceUpdateEditPage.tsx
#: src/timber/pages/pricingProfile/PricingProfileAddEditPage.tsx
#: src/timber/pages/pricingProfile/PricingProfileDetailPage.tsx
#: src/timber/pages/pricingProfile/PricingProfileUpdateEditPage.tsx
#: src/timber/pages/provider/ProviderAddEditPage.tsx
#: src/timber/pages/provider/ProviderDetailPage.tsx
#: src/timber/pages/provider/ProviderUpdateEditPage.tsx
#: src/timber/pages/providerUser/ProviderUserAddEditPage.tsx
#: src/timber/pages/providerUser/ProviderUserDetailPage.tsx
#: src/timber/pages/providerUser/ProviderUserUpdateEditPage.tsx
#: src/timber/pages/roadCarrier/RoadCarrierAddEditPage.tsx
#: src/timber/pages/roadCarrier/RoadCarrierDetailPage.tsx
#: src/timber/pages/roadCarrier/RoadCarrierUpdateEditPage.tsx
#: src/timber/pages/shipment/ShipmentAddEditPage.tsx
#: src/timber/pages/shipment/ShipmentDetailPage.tsx
#: src/timber/pages/shipment/ShipmentUpdateEditPage.tsx
#: src/timber/pages/shipmentHistory/ShipmentHistoryAddEditPage.tsx
#: src/timber/pages/shipmentHistory/ShipmentHistoryDetailPage.tsx
#: src/timber/pages/shipmentHistory/ShipmentHistoryUpdateEditPage.tsx
#: src/timber/pages/thicknessClass/ThicknessClassAddEditPage.tsx
#: src/timber/pages/thicknessClass/ThicknessClassDetailPage.tsx
#: src/timber/pages/thicknessClass/ThicknessClassUpdateEditPage.tsx
#: src/timber/pages/timberClass/TimberClassAddEditPage.tsx
#: src/timber/pages/timberClass/TimberClassDetailPage.tsx
#: src/timber/pages/timberClass/TimberClassUpdateEditPage.tsx
#: src/timber/pages/timberStorage/TimberStorageAddEditPage.tsx
#: src/timber/pages/timberStorage/TimberStorageDetailPage.tsx
#: src/timber/pages/timberStorage/TimberStorageUpdateEditPage.tsx
#: src/timber/pages/timberType/TimberTypeAddEditPage.tsx
#: src/timber/pages/timberType/TimberTypeDetailPage.tsx
#: src/timber/pages/timberType/TimberTypeUpdateEditPage.tsx
#: src/timber/pages/treeMarking/TreeMarkingAddEditPage.tsx
#: src/timber/pages/treeMarking/TreeMarkingDetailPage.tsx
#: src/timber/pages/treeMarking/TreeMarkingUpdateEditPage.tsx
#~ msgid "Back"
#~ msgstr "Natrag"

#: src/pages/ForgotPasswordPage.tsx
msgid "Back to Login"
msgstr "Natrag na prijavu"

#: src/timber/components/buyer/BuyerDetail/BuyerDetail.tsx
#: src/timber/components/buyer/BuyerForm/BuyerAddForm.tsx
#: src/timber/components/buyer/BuyerForm/BuyerUpdateForm.tsx
#: src/timber/components/contractor/ContractorDetail/ContractorDetail.tsx
#: src/timber/components/contractor/ContractorForm/ContractorAddForm.tsx
#: src/timber/components/contractor/ContractorForm/ContractorUpdateForm.tsx
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerDetail.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerAddForm.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerUpdateForm.tsx
#: src/timber/components/provider/ProviderDetail/ProviderDetail.tsx
#: src/timber/components/provider/ProviderForm/ProviderAddForm.tsx
#: src/timber/components/provider/ProviderForm/ProviderUpdateForm.tsx
msgid "Bank"
msgstr "Banka"

#: src/auth/components/user/UserDetail/UserDetail.tsx
#: src/auth/components/user/UserForm/UserAddForm.tsx
#: src/auth/components/user/UserForm/UserUpdateForm.tsx
#: src/auth/components/user/UserList/UserListItem.tsx
msgid "Banned"
msgstr "Zabranjeno"

#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx
msgid "Bark Thickness"
msgstr "Debljina kore"

#: src/timber/components/buyer/BuyerDetail/BuyerDetail.tsx
#: src/timber/components/buyerUser/BuyerUserDetail/BuyerUserDetail.tsx
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddForm.tsx
#: src/timber/components/generic/report/GenericRootShipments.tsx
#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx
#: src/timber/pages/buyer/BuyerEntityPage.tsx
#: src/timber/pages/listItems.tsx
msgid "Buyer"
msgstr "Kupac"

#: src/timber/hooks/useBuyer.ts
msgid "Buyer add error: "
msgstr "Pogreška pri dodavanju kupca: "

#: src/timber/hooks/useBuyer.ts
msgid "Buyer delete error: "
msgstr "Greška pri brisanju kupca: "

#: src/timber/hooks/useBuyer.ts
msgid "Buyer deleted"
msgstr "Kupac je obrisan"

#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
#~ msgid "Buyer Id is required"
#~ msgstr "ID kupca je obavezan"

#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Buyer is required"
msgstr "Kupac je obavezan"

#: src/timber/hooks/useBuyer.ts
msgid "Buyer update error: "
msgstr "Pogreška pri ažuriranju kupca: "

#: src/timber/hooks/useBuyer.ts
msgid "Buyer updated"
msgstr "Kupac je ažuriran"

#: src/timber/components/buyerUser/BuyerUserDetail/BuyerUserDetail.tsx
#: src/timber/pages/buyerUser/BuyerUserEntityPage.tsx
msgid "Buyer User"
msgstr "Korisnik kupca"

#: src/timber/hooks/useBuyerUser.ts
msgid "Buyer User add error: "
msgstr "Pogreška pri dodavanju korisnika kupca: "

#: src/timber/hooks/useBuyerUser.ts
msgid "Buyer User delete error: "
msgstr "Pogreška pri brisanju korisnika kupca: "

#: src/timber/hooks/useBuyerUser.ts
msgid "Buyer User deleted"
msgstr "Korisnik kupca je obrisan"

#: src/timber/hooks/useBuyerUser.ts
msgid "Buyer User update error: "
msgstr "Pogreška pri ažuriranju korisnika kupca: "

#: src/timber/hooks/useBuyerUser.ts
msgid "Buyer User updated"
msgstr "Korisnik kupca je ažuriran"

#: src/app/mappers.tsx
#: src/auth/components/user/UserDetail/UserTabs.tsx
#: src/timber/components/buyer/BuyerDetail/BuyerTabs.tsx
#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListHeader.tsx
msgid "Buyer Users"
msgstr "Korisnici kupca"

#: src/app/mappers.tsx
#: src/timber/components/buyer/BuyerList/BuyerListHeader.tsx
#: src/timber/pages/listItems.tsx
#: src/timber/types/models/Split.ts
msgid "Buyers"
msgstr "Kupci"

#: src/pages/LoginPage.tsx
msgid "By logging in you agree to our"
msgstr "Prijavom prihvaćate naše"

#: src/pages/TermsPage.tsx
msgid "By using this application, you agree to use it in accordance with applicable laws and our policies. You are responsible for maintaining the security of your account."
msgstr "Korištenjem ove aplikacije pristajete koristiti je u skladu s važećim zakonima i našim pravilima. Odgovorni ste za održavanje sigurnosti svog računa."

#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx
#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemFromHistory.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx
msgid "C"
msgstr "C"

#: src/address/components/address/AddressForm/AddressFormSelect.tsx
#: src/address/components/userAddress/UserAddressForm/UserAddressFormSelect.tsx
#: src/address/pages/address/AddressAddEditPage.tsx
#: src/address/pages/address/AddressUpdateEditPage.tsx
#: src/address/pages/userAddress/UserAddressAddEditPage.tsx
#: src/address/pages/userAddress/UserAddressUpdateEditPage.tsx
#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupFormSelect.tsx
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListSearch.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserFormSelect.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListSearch.tsx
#: src/auth/components/role/RoleForm/RoleFormSelect.tsx
#: src/auth/components/role/RoleList/RoleListSearch.tsx
#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentFormSelect.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListSearch.tsx
#: src/auth/components/rolePermission/RolePermissionForm/RolePermissionFormSelect.tsx
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListSearch.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupFormSelect.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListSearch.tsx
#: src/auth/components/user/UserForm/UserFormSelect.tsx
#: src/auth/components/userSession/UserSessionForm/UserSessionFormSelect.tsx
#: src/auth/pages/membersGroup/MembersGroupAddEditPage.tsx
#: src/auth/pages/membersGroup/MembersGroupUpdateEditPage.tsx
#: src/auth/pages/membersGroupUser/MembersGroupUserAddEditPage.tsx
#: src/auth/pages/membersGroupUser/MembersGroupUserUpdateEditPage.tsx
#: src/auth/pages/role/RoleAddEditPage.tsx
#: src/auth/pages/role/RoleUpdateEditPage.tsx
#: src/auth/pages/roleAssignment/RoleAssignmentAddEditPage.tsx
#: src/auth/pages/roleAssignment/RoleAssignmentUpdateEditPage.tsx
#: src/auth/pages/rolePermission/RolePermissionAddEditPage.tsx
#: src/auth/pages/rolePermission/RolePermissionUpdateEditPage.tsx
#: src/auth/pages/scopeGroup/ScopeGroupAddEditPage.tsx
#: src/auth/pages/scopeGroup/ScopeGroupUpdateEditPage.tsx
#: src/auth/pages/user/UserAddEditPage.tsx
#: src/auth/pages/user/UserUpdateEditPage.tsx
#: src/auth/pages/userSession/UserSessionAddEditPage.tsx
#: src/auth/pages/userSession/UserSessionUpdateEditPage.tsx
#: src/location/components/location/LocationForm/LocationFormSelect.tsx
#: src/location/components/location/LocationList/LocationListSearch.tsx
#: src/location/pages/location/LocationAddEditPage.tsx
#: src/location/pages/location/LocationUpdateEditPage.tsx
#: src/share/components/chat/ChatMessage.tsx
#: src/share/components/dialog/DeleteDialog/DeleteDialog.tsx
#: src/share/components/dialog/PasswordDialog/PasswordDialog.tsx
#: src/share/components/form/FormDateTime/FormDate.tsx
#: src/share/components/form/FormDateTime/FormDateTime.tsx
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserFormSelect.tsx
#: src/timber/components/buyer/BuyerForm/BuyerFormSelect.tsx
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserFormSelect.tsx
#: src/timber/components/contractor/ContractorForm/ContractorFormSelect.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserFormSelect.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodFormSelect.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryFormSelect.tsx
#: src/timber/components/cutting/CuttingForm/CuttingFormSelect.tsx
#: src/timber/components/cutting/CuttingList/CuttingListSearch.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerFormSelect.tsx
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/log/LogForm/LogFormSelect.tsx
#: src/timber/components/log/LogList/LogListSearch.tsx
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryFormSelect.tsx
#: src/timber/components/price/PriceForm/PriceFormSelect.tsx
#: src/timber/components/price/PriceList/PriceListSearch.tsx
#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileFormSelect.tsx
#: src/timber/components/provider/ProviderForm/ProviderFormSelect.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserFormSelect.tsx
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierFormSelect.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentFormSelect.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryFormSelect.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassFormSelect.tsx
#: src/timber/components/timberClass/TimberClassForm/TimberClassFormSelect.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageFormSelect.tsx
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListSearch.tsx
#: src/timber/components/timberType/TimberTypeForm/TimberTypeFormSelect.tsx
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingFormSelect.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListSearch.tsx
#: src/timber/pages/accountingUser/AccountingUserAddEditPage.tsx
#: src/timber/pages/accountingUser/AccountingUserUpdateEditPage.tsx
#: src/timber/pages/buyer/BuyerAddEditPage.tsx
#: src/timber/pages/buyer/BuyerUpdateEditPage.tsx
#: src/timber/pages/buyerUser/BuyerUserAddEditPage.tsx
#: src/timber/pages/buyerUser/BuyerUserUpdateEditPage.tsx
#: src/timber/pages/contractor/ContractorAddEditPage.tsx
#: src/timber/pages/contractor/ContractorUpdateEditPage.tsx
#: src/timber/pages/contractorUser/ContractorUserAddEditPage.tsx
#: src/timber/pages/contractorUser/ContractorUserUpdateEditPage.tsx
#: src/timber/pages/cordwood/CordwoodAddEditPage.tsx
#: src/timber/pages/cordwood/CordwoodUpdateEditPage.tsx
#: src/timber/pages/cordwoodHistory/CordwoodHistoryAddEditPage.tsx
#: src/timber/pages/cordwoodHistory/CordwoodHistoryUpdateEditPage.tsx
#: src/timber/pages/cutting/CuttingAddEditPage.tsx
#: src/timber/pages/cutting/CuttingUpdateEditPage.tsx
#: src/timber/pages/forestOwner/ForestOwnerAddEditPage.tsx
#: src/timber/pages/forestOwner/ForestOwnerUpdateEditPage.tsx
#: src/timber/pages/log/LogAddEditPage.tsx
#: src/timber/pages/log/LogUpdateEditPage.tsx
#: src/timber/pages/logHistory/LogHistoryAddEditPage.tsx
#: src/timber/pages/logHistory/LogHistoryUpdateEditPage.tsx
#: src/timber/pages/price/PriceAddEditPage.tsx
#: src/timber/pages/price/PriceUpdateEditPage.tsx
#: src/timber/pages/pricingProfile/PricingProfileAddEditPage.tsx
#: src/timber/pages/pricingProfile/PricingProfileUpdateEditPage.tsx
#: src/timber/pages/provider/ProviderAddEditPage.tsx
#: src/timber/pages/provider/ProviderUpdateEditPage.tsx
#: src/timber/pages/providerUser/ProviderUserAddEditPage.tsx
#: src/timber/pages/providerUser/ProviderUserUpdateEditPage.tsx
#: src/timber/pages/roadCarrier/RoadCarrierAddEditPage.tsx
#: src/timber/pages/roadCarrier/RoadCarrierUpdateEditPage.tsx
#: src/timber/pages/shipment/ShipmentAddEditPage.tsx
#: src/timber/pages/shipment/ShipmentUpdateEditPage.tsx
#: src/timber/pages/shipmentHistory/ShipmentHistoryAddEditPage.tsx
#: src/timber/pages/shipmentHistory/ShipmentHistoryUpdateEditPage.tsx
#: src/timber/pages/thicknessClass/ThicknessClassAddEditPage.tsx
#: src/timber/pages/thicknessClass/ThicknessClassUpdateEditPage.tsx
#: src/timber/pages/timberClass/TimberClassAddEditPage.tsx
#: src/timber/pages/timberClass/TimberClassUpdateEditPage.tsx
#: src/timber/pages/timberStorage/TimberStorageAddEditPage.tsx
#: src/timber/pages/timberStorage/TimberStorageUpdateEditPage.tsx
#: src/timber/pages/timberType/TimberTypeAddEditPage.tsx
#: src/timber/pages/timberType/TimberTypeUpdateEditPage.tsx
#: src/timber/pages/treeMarking/TreeMarkingAddEditPage.tsx
#: src/timber/pages/treeMarking/TreeMarkingUpdateEditPage.tsx
msgid "Cancel"
msgstr "Odustani"

#: src/timber/types/models/ShipmentState.d.ts
msgid "Cancelled"
msgstr "Stornirano"

#: src/timber/components/history/HistoryList/HistoryListSearch.tsx
#: src/timber/types/models/MergedHistory.ts
msgid "Cancelled from Shipment"
msgstr "Storniran "

#: src/app/App.tsx
#: src/pages/ChangePasswordPage.tsx
msgid "Change Password"
msgstr "Promijeni lozinku"

#: src/share/components/chat/useChat.ts
msgid "Chat failed"
msgstr "Chat nije uspio"

#: src/address/components/address/AddressDetail/AddressDetail.tsx
#: src/address/components/address/AddressForm/AddressAddForm.tsx
#: src/address/components/address/AddressForm/AddressUpdateForm.tsx
#: src/address/components/address/AddressList/AddressListItem.tsx
#: src/location/components/location/LocationDetail/LocationDetail.tsx
#: src/location/components/location/LocationForm/LocationAddForm.tsx
#: src/location/components/location/LocationForm/LocationUpdateForm.tsx
#: src/location/components/location/LocationList/LocationListItem.tsx
msgid "City"
msgstr "Grad"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootTable.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemFromHistory.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx
msgid "Class"
msgstr "Klasa"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/price/PriceForm/PriceAddForm.tsx
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx
#~ msgid "Class Id is required"
#~ msgstr "Id klase je obavezan"

#: src/timber/components/history/HistoryList/HistoryListSearch.tsx
msgid "Clear"
msgstr "Obriši"

#: src/share/components/chat/ConversationList.tsx
msgid "Clear search"
msgstr "Očisti pretragu"

#: src/share/components/form/FormDateTime/FormDateRange.tsx
#: src/timber/components/generic/report/GenericRootReportPdfDialog.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListPdfDialog.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodShipmentReportPdfDialog.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListPdfDialog.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogShipmentReportPdfDialog.tsx
msgid "Close"
msgstr "Zatvori"

#: src/share/components/chat/ChatHeader.tsx
msgid "Close chat"
msgstr "Zatvori chat"

#: src/timber/types/models/CuttingState.d.ts
#: src/timber/types/models/ShipmentState.d.ts
msgid "Closed"
msgstr "Zatvoren"

#: src/share/components/layout/Layout/Layout.tsx
msgid "Column"
msgstr "Stupac"

#: src/share/components/layout/Layout/Layout.tsx
#~ msgid "Column {containerId}"
#~ msgstr "Stupac {containerId}"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
msgid "Commit"
msgstr "Dodijeli"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
msgid "Commited"
msgstr "Dodijeljeno"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
msgid "Commited / Total"
msgstr "Dodijeljeno / Ukupno"

#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
msgid "Committed"
msgstr "Dodijeljeno"

#: src/share/components/dialog/DeleteDialog/DeleteDialog.tsx
msgid "Confirm"
msgstr "Potvrdi"

#: src/share/components/dialog/DeleteDialog/DeleteDialog.tsx
msgid "Confirm Delete"
msgstr "Potvrdi brisanje"

#: src/pages/ChangePasswordPage.tsx
msgid "Confirm New Password"
msgstr "Potvrdi novu lozinku"

#: src/pages/ResetPasswordPage.tsx
#: src/share/components/dialog/PasswordDialog/PasswordDialog.tsx
msgid "Confirm Password"
msgstr "Potvrdi lozinku"

#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
msgid "Context"
msgstr "Kontekst"

#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryAddForm.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryAddForm.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryAddForm.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx
msgid "Context History"
msgstr "Konteks Povijesti"

#: src/timber/components/contractor/ContractorDetail/ContractorDetail.tsx
#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingList/CuttingListItem.tsx
#: src/timber/pages/contractor/ContractorEntityPage.tsx
#: src/timber/pages/listItems.tsx
msgid "Contractor"
msgstr "Izvođač"

#: src/timber/hooks/useContractor.ts
msgid "Contractor add error: "
msgstr "Pogreška pri dodavanju izvođača: "

#: src/timber/hooks/useContractor.ts
msgid "Contractor delete error: "
msgstr "Pogreška pri brisanju izvođača: "

#: src/timber/hooks/useContractor.ts
msgid "Contractor deleted"
msgstr "Izvođač je obrisan"

#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#~ msgid "Contractor Id is required"
#~ msgstr "Id izvođača je obavezan"

#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
msgid "Contractor is required"
msgstr "Izvođač je obavezan"

#: src/timber/hooks/useContractor.ts
msgid "Contractor update error: "
msgstr "Pogreška pri ažuriranju izvođača: "

#: src/timber/hooks/useContractor.ts
msgid "Contractor updated"
msgstr "Izvođač je ažuriran"

#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx
#: src/timber/pages/contractorUser/ContractorUserEntityPage.tsx
msgid "Contractor User"
msgstr "Korisnik izvođača"

#: src/timber/hooks/useContractorUser.ts
msgid "Contractor User add error: "
msgstr "Pogreška pri dodavanju korisnika izvođača: "

#: src/timber/hooks/useContractorUser.ts
msgid "Contractor User delete error: "
msgstr "Pogreška pri brisanju korisnika izvođača: "

#: src/timber/hooks/useContractorUser.ts
msgid "Contractor User deleted"
msgstr "Korisnik izvođača je obrisan"

#: src/timber/hooks/useContractorUser.ts
msgid "Contractor User update error: "
msgstr "Pogreška pri ažuriranju korisnika izvođača: "

#: src/timber/hooks/useContractorUser.ts
msgid "Contractor User updated"
msgstr "Korisnik izvođača je ažuriran"

#: src/timber/types/models/Split.ts
msgid "Contractor users"
msgstr "Korisnici izvođača"

#: src/app/mappers.tsx
#: src/auth/components/user/UserDetail/UserTabs.tsx
#: src/timber/components/contractor/ContractorDetail/ContractorTabs.tsx
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListHeader.tsx
msgid "Contractor Users"
msgstr "Korisnici izvođača"

#: src/app/mappers.tsx
#: src/timber/components/contractor/ContractorList/ContractorListHeader.tsx
#: src/timber/pages/listItems.tsx
#: src/timber/types/models/Split.ts
msgid "Contractors"
msgstr "Izvođači"

#: src/share/components/chat/ChatThread.tsx
msgid "Conversation"
msgstr "Razgovor"

#: src/share/components/chat/serverErrors.ts
msgid "Conversation not found"
msgstr "Razgovor nije pronađen"

#: src/share/components/chat/serverErrors.ts
msgid "Conversation storage unavailable"
msgstr "Pohrana razgovora nije dostupna"

#: src/share/components/chat/Markdown.tsx
msgid "Copied"
msgstr "Kopirano"

#: src/share/components/chat/Markdown.tsx
msgid "Copy code"
msgstr "Kopiraj kod"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryAddForm.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
#: src/timber/components/cutting/CuttingList/ActiveCuttings.tsx
#: src/timber/components/generic/report/StorageShipmentPies.tsx
#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx
#: src/timber/components/history/HistoryList/HistoryListSearch.tsx
#: src/timber/pages/cordwood/CordwoodEntityPage.tsx
#: src/timber/types/models/MergedHistory.ts
#: src/timber/types/models/ShipmentType.d.ts
msgid "Cordwood"
msgstr "Višemetrica"

#: src/timber/hooks/useCordwood.ts
msgid "Cordwood add error: "
msgstr "Pogreška pri dodavanju višemetrice: "

#: src/timber/hooks/useCordwood.ts
msgid "Cordwood delete error: "
msgstr "Pogreška pri brisanju višemetrice: "

#: src/timber/hooks/useCordwood.ts
msgid "Cordwood deleted"
msgstr "Višemetrica je obrisana"

#: src/app/mappers.tsx
#: src/timber/components/cordwood/CordwoodDetail/CordwoodTabs.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListHeader.tsx
msgid "Cordwood Histories"
msgstr "Povijest višemetrice"

#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/pages/cordwoodHistory/CordwoodHistoryEntityPage.tsx
msgid "Cordwood History"
msgstr "Povijest višemetrice"

#: src/timber/hooks/useCordwoodHistory.ts
msgid "Cordwood History add error: "
msgstr "Pogreška pri dodavanju povijesti višemetrice: "

#: src/timber/hooks/useCordwoodHistory.ts
msgid "Cordwood History delete error: "
msgstr "Pogreška pri brisanju povijesti Višemetrice: "

#: src/timber/hooks/useCordwoodHistory.ts
msgid "Cordwood History deleted"
msgstr "Povijest višemetrice je obrisana"

#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryAddForm.tsx
#~ msgid "Cordwood Id is required"
#~ msgstr "Id višemetrice je obavezan"

#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryAddForm.tsx
msgid "Cordwood is required"
msgstr "Višemetrica je obavezna"

#: src/timber/components/generic/report/GenericRootReport.tsx
msgid "Cordwood Shipments"
msgstr "Pošiljke višemetrice"

#: src/timber/hooks/useCordwood.ts
msgid "Cordwood update error: "
msgstr "Pogreška pri ažuriranju višemetrice: "

#: src/timber/hooks/useCordwood.ts
msgid "Cordwood updated"
msgstr "Višemetrica je ažurirana"

#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
msgid "Cordwood volume (m³)"
msgstr "Volumen višemetrice (m³)"

#: src/app/mappers.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListHeader.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx
#: src/timber/components/generic/report/GenericRootShipments.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentTabs.tsx
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx
msgid "Cordwoods"
msgstr "Višemetrica"

#: src/share/components/chat/useChat.ts
msgid "Could not download the file."
msgstr "Datoteku nije bilo moguće preuzeti."

#: src/share/components/chat/useChat.ts
msgid "Could not edit: the conversation could not be branched."
msgstr "Nije moguće urediti: razgovor nije mogao biti razgranan."

#: src/share/components/chat/useChat.ts
msgid "Could not regenerate: the previous reply could not be discarded."
msgstr "Nije moguće ponovno generirati: prethodni odgovor nije mogao biti odbačen."

#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
msgid "Count"
msgstr "Broj"

#: src/address/components/address/AddressDetail/AddressDetail.tsx
#: src/address/components/address/AddressForm/AddressAddForm.tsx
#: src/address/components/address/AddressForm/AddressUpdateForm.tsx
#: src/location/components/location/LocationDetail/LocationDetail.tsx
#: src/location/components/location/LocationForm/LocationAddForm.tsx
#: src/location/components/location/LocationForm/LocationUpdateForm.tsx
#: src/location/components/location/LocationList/LocationListItem.tsx
msgid "Country"
msgstr "Država"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
msgid "Create new pricing profile"
msgstr "Napravi novi cijenovni profil"

#: src/timber/components/history/HistoryList/HistoryListSearch.tsx
#: src/timber/types/models/MergedHistory.ts
msgid "Created"
msgstr "Stvoren"

#: src/auth/components/roleAssignment/RoleAssignmentDetail/RoleAssignmentDetail.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListItem.tsx
#: src/auth/components/rolePermission/RolePermissionDetail/RolePermissionDetail.tsx
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListItem.tsx
#: src/auth/components/user/UserDetail/UserDetail.tsx
#: src/auth/components/user/UserList/UserListItem.tsx
#: src/auth/components/userSession/UserSessionDetail/UserSessionDetail.tsx
#: src/auth/components/userSession/UserSessionList/UserSessionListItem.tsx
#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
msgid "Created At"
msgstr "Stvoreno"

#: src/timber/components/generic/report/TimelineRootReport.tsx
#~ msgid "Created At From"
#~ msgstr "Stvoreno od"

#: src/timber/components/generic/report/TimelineRootReport.tsx
#~ msgid "Created At To"
#~ msgstr "Stvoreno do"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootReport.tsx
#: src/timber/components/generic/report/GenericRootShipments.tsx
#: src/timber/components/generic/report/TimelineRootReport.tsx
#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
#: src/timber/components/history/HistoryList/HistoryListSearch.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageDetail.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx
#: src/timber/components/treeMarking/TreeMarkingDetail/TreeMarkingDetail.tsx
#: src/timber/pages/cutting/CuttingEntityPage.tsx
msgid "Cutting"
msgstr "Sječa"

#: src/timber/hooks/useCutting.ts
msgid "Cutting add error: "
msgstr "Pogreška pri dodavanju sječe: "

#: src/timber/hooks/useCutting.ts
msgid "Cutting delete error: "
msgstr "Pogreška pri brisanju sječe: "

#: src/timber/hooks/useCutting.ts
msgid "Cutting deleted"
msgstr "Sječe je obrisano"

#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx
#~ msgid "Cutting Id is required"
#~ msgstr "Id sječe je obavezan"

#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx
msgid "Cutting is required"
msgstr "Sječa je obavezna"

#: src/timber/hooks/useCutting.ts
msgid "Cutting update error: "
msgstr "Pogreška pri ažuriranju sječe: "

#: src/timber/hooks/useCutting.ts
msgid "Cutting updated"
msgstr "Sječa je ažurirano"

#: src/app/mappers.tsx
#: src/timber/components/contractor/ContractorDetail/ContractorTabs.tsx
#: src/timber/components/cutting/CuttingList/CuttingListHeader.tsx
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerTabs.tsx
#: src/timber/components/provider/ProviderDetail/ProviderTabs.tsx
#: src/timber/pages/listItems.tsx
msgid "Cuttings"
msgstr "Sječe"

#: src/timber/components/provider/ProviderDetail/ProviderAttentionList.tsx
msgid "Cuttings that have gone quiet"
msgstr "Sječe koje su stale"

#: src/pages/PreferencesPage.tsx
msgid "Dark"
msgstr "Tamno"

#: src/app/App.tsx
#: src/app/mappers.tsx
#: src/pages/DashboardHomePage.tsx
#: src/pages/listItems.tsx
msgid "Dashboard"
msgstr "Nadzorna ploča"

#: src/timber/components/generic/report/GenericRootReport.tsx
msgid "Data"
msgstr "Podaci"

#: src/timber/components/generic/report/TimelineRootReport.tsx
msgid "Date"
msgstr "Datum"

#: src/timber/components/history/HistoryList/HistoryListItem.tsx
msgid "Date/Time"
msgstr "Datum/Vrijeme"

#: src/timber/components/generic/report/TimelineRootReport.tsx
msgid "Day"
msgstr "Dan"

#: src/share/components/gdpr/CookieConsent.tsx
msgid "Decline"
msgstr "Odbij"

#: src/share/components/form/FormInput/NumberField.tsx
msgid "Decrease"
msgstr "Smanji"

#: src/address/pages/address/AddressDetailPage.tsx
#: src/address/pages/address/AddressEntityPage.tsx
#: src/address/pages/userAddress/UserAddressDetailPage.tsx
#: src/address/pages/userAddress/UserAddressEntityPage.tsx
#: src/auth/pages/membersGroup/MembersGroupDetailPage.tsx
#: src/auth/pages/membersGroup/MembersGroupEntityPage.tsx
#: src/auth/pages/membersGroupUser/MembersGroupUserDetailPage.tsx
#: src/auth/pages/membersGroupUser/MembersGroupUserEntityPage.tsx
#: src/auth/pages/role/RoleDetailPage.tsx
#: src/auth/pages/role/RoleEntityPage.tsx
#: src/auth/pages/roleAssignment/RoleAssignmentDetailPage.tsx
#: src/auth/pages/roleAssignment/RoleAssignmentEntityPage.tsx
#: src/auth/pages/rolePermission/RolePermissionDetailPage.tsx
#: src/auth/pages/rolePermission/RolePermissionEntityPage.tsx
#: src/auth/pages/scopeGroup/ScopeGroupDetailPage.tsx
#: src/auth/pages/scopeGroup/ScopeGroupEntityPage.tsx
#: src/auth/pages/user/UserDetailPage.tsx
#: src/auth/pages/user/UserEntityPage.tsx
#: src/auth/pages/userSession/UserSessionDetailPage.tsx
#: src/auth/pages/userSession/UserSessionEntityPage.tsx
#: src/location/pages/location/LocationDetailPage.tsx
#: src/location/pages/location/LocationEntityPage.tsx
#: src/share/components/chat/ConversationList.tsx
#: src/timber/pages/accountingUser/AccountingUserDetailPage.tsx
#: src/timber/pages/accountingUser/AccountingUserEntityPage.tsx
#: src/timber/pages/buyer/BuyerDetailPage.tsx
#: src/timber/pages/buyer/BuyerEntityPage.tsx
#: src/timber/pages/buyerUser/BuyerUserDetailPage.tsx
#: src/timber/pages/buyerUser/BuyerUserEntityPage.tsx
#: src/timber/pages/contractor/ContractorDetailPage.tsx
#: src/timber/pages/contractor/ContractorEntityPage.tsx
#: src/timber/pages/contractorUser/ContractorUserDetailPage.tsx
#: src/timber/pages/contractorUser/ContractorUserEntityPage.tsx
#: src/timber/pages/cordwood/CordwoodDetailPage.tsx
#: src/timber/pages/cordwood/CordwoodEntityPage.tsx
#: src/timber/pages/cordwoodHistory/CordwoodHistoryDetailPage.tsx
#: src/timber/pages/cordwoodHistory/CordwoodHistoryEntityPage.tsx
#: src/timber/pages/cutting/CuttingDetailPage.tsx
#: src/timber/pages/cutting/CuttingEntityPage.tsx
#: src/timber/pages/forestOwner/ForestOwnerDetailPage.tsx
#: src/timber/pages/forestOwner/ForestOwnerEntityPage.tsx
#: src/timber/pages/log/LogDetailPage.tsx
#: src/timber/pages/log/LogEntityPage.tsx
#: src/timber/pages/logHistory/LogHistoryDetailPage.tsx
#: src/timber/pages/logHistory/LogHistoryEntityPage.tsx
#: src/timber/pages/price/PriceDetailPage.tsx
#: src/timber/pages/price/PriceEntityPage.tsx
#: src/timber/pages/pricingProfile/PricingProfileDetailPage.tsx
#: src/timber/pages/pricingProfile/PricingProfileEntityPage.tsx
#: src/timber/pages/provider/ProviderDetailPage.tsx
#: src/timber/pages/provider/ProviderEntityPage.tsx
#: src/timber/pages/providerUser/ProviderUserDetailPage.tsx
#: src/timber/pages/providerUser/ProviderUserEntityPage.tsx
#: src/timber/pages/roadCarrier/RoadCarrierDetailPage.tsx
#: src/timber/pages/roadCarrier/RoadCarrierEntityPage.tsx
#: src/timber/pages/shipment/ShipmentDetailPage.tsx
#: src/timber/pages/shipment/ShipmentEntityPage.tsx
#: src/timber/pages/shipmentHistory/ShipmentHistoryDetailPage.tsx
#: src/timber/pages/shipmentHistory/ShipmentHistoryEntityPage.tsx
#: src/timber/pages/thicknessClass/ThicknessClassDetailPage.tsx
#: src/timber/pages/thicknessClass/ThicknessClassEntityPage.tsx
#: src/timber/pages/timberClass/TimberClassDetailPage.tsx
#: src/timber/pages/timberClass/TimberClassEntityPage.tsx
#: src/timber/pages/timberStorage/TimberStorageDetailPage.tsx
#: src/timber/pages/timberStorage/TimberStorageEntityPage.tsx
#: src/timber/pages/timberType/TimberTypeDetailPage.tsx
#: src/timber/pages/timberType/TimberTypeEntityPage.tsx
#: src/timber/pages/treeMarking/TreeMarkingDetailPage.tsx
#: src/timber/pages/treeMarking/TreeMarkingEntityPage.tsx
msgid "Delete"
msgstr "Izbriši"

#. placeholder {0}: conv.title || t`New conversation`
#: src/share/components/chat/ConversationList.tsx
msgid "Delete {0}"
msgstr "Izbriši {0}"

#: src/share/components/chat/ChatHeader.tsx
msgid "Delete conversation"
msgstr "Izbriši razgovor"

#: src/address/hooks/useAddress.ts
#: src/address/hooks/useUserAddress.ts
#: src/auth/hooks/useMembersGroup.ts
#: src/auth/hooks/useMembersGroupUser.ts
#: src/auth/hooks/useRole.ts
#: src/auth/hooks/useRoleAssignment.ts
#: src/auth/hooks/useRolePermission.ts
#: src/auth/hooks/useScopeGroup.ts
#: src/auth/hooks/useUser.ts
#: src/auth/hooks/useUserSession.ts
#: src/location/hooks/useLocation.ts
#: src/timber/hooks/useAccountingUser.ts
#: src/timber/hooks/useBuyer.ts
#: src/timber/hooks/useBuyerUser.ts
#: src/timber/hooks/useContractor.ts
#: src/timber/hooks/useContractorUser.ts
#: src/timber/hooks/useCordwood.ts
#: src/timber/hooks/useCordwoodHistory.ts
#: src/timber/hooks/useCutting.ts
#: src/timber/hooks/useForestOwner.ts
#: src/timber/hooks/useLog.ts
#: src/timber/hooks/useLogHistory.ts
#: src/timber/hooks/usePrice.ts
#: src/timber/hooks/usePricingProfile.ts
#: src/timber/hooks/useProvider.ts
#: src/timber/hooks/useProviderUser.ts
#: src/timber/hooks/useRoadCarrier.ts
#: src/timber/hooks/useShipment.ts
#: src/timber/hooks/useShipmentHistory.ts
#: src/timber/hooks/useThicknessClass.ts
#: src/timber/hooks/useTimberClass.ts
#: src/timber/hooks/useTimberStorage.ts
#: src/timber/hooks/useTimberType.ts
#: src/timber/hooks/useTreeMarking.ts
msgid "Delete error: "
msgstr "Pogreška pri brisanju: "

#: src/timber/components/history/HistoryList/HistoryListSearch.tsx
#: src/timber/types/models/MergedHistory.ts
msgid "Deleted"
msgstr "Obrisan"

#: src/address/components/address/AddressDetail/AddressDetail.tsx
#: src/address/components/address/AddressForm/AddressAddForm.tsx
#: src/address/components/address/AddressForm/AddressUpdateForm.tsx
#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupDetail.tsx
#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupAddForm.tsx
#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupUpdateForm.tsx
#: src/auth/components/role/RoleDetail/RoleDetail.tsx
#: src/auth/components/role/RoleForm/RoleAddForm.tsx
#: src/auth/components/role/RoleForm/RoleUpdateForm.tsx
#: src/auth/components/role/RoleList/RoleListItem.tsx
#: src/auth/components/scopeGroup/ScopeGroupDetail/ScopeGroupDetail.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupUpdateForm.tsx
#: src/location/components/location/LocationDetail/LocationDetail.tsx
#: src/location/components/location/LocationForm/LocationAddForm.tsx
#: src/location/components/location/LocationForm/LocationUpdateForm.tsx
#: src/timber/components/accountingUser/AccountingUserDetail/AccountingUserDetail.tsx
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserAddForm.tsx
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserUpdateForm.tsx
#: src/timber/components/buyer/BuyerDetail/BuyerDetail.tsx
#: src/timber/components/buyer/BuyerForm/BuyerAddForm.tsx
#: src/timber/components/buyer/BuyerForm/BuyerUpdateForm.tsx
#: src/timber/components/buyer/BuyerList/BuyerListItem.tsx
#: src/timber/components/buyerUser/BuyerUserDetail/BuyerUserDetail.tsx
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddForm.tsx
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserUpdateForm.tsx
#: src/timber/components/contractor/ContractorDetail/ContractorDetail.tsx
#: src/timber/components/contractor/ContractorForm/ContractorAddForm.tsx
#: src/timber/components/contractor/ContractorForm/ContractorUpdateForm.tsx
#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx
#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerDetail.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerAddForm.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerUpdateForm.tsx
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/pricingProfile/PricingProfileDetail/PricingProfileDetail.tsx
#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileAddForm.tsx
#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileUpdateForm.tsx
#: src/timber/components/provider/ProviderDetail/ProviderDetail.tsx
#: src/timber/components/provider/ProviderForm/ProviderAddForm.tsx
#: src/timber/components/provider/ProviderForm/ProviderUpdateForm.tsx
#: src/timber/components/providerUser/ProviderUserDetail/ProviderUserDetail.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserUpdateForm.tsx
#: src/timber/components/roadCarrier/RoadCarrierDetail/RoadCarrierDetail.tsx
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierAddForm.tsx
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierUpdateForm.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx
#: src/timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassDetail.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx
#: src/timber/components/timberClass/TimberClassDetail/TimberClassDetail.tsx
#: src/timber/components/timberClass/TimberClassForm/TimberClassAddForm.tsx
#: src/timber/components/timberClass/TimberClassForm/TimberClassUpdateForm.tsx
#: src/timber/components/timberType/TimberTypeDetail/TimberTypeDetail.tsx
#: src/timber/components/timberType/TimberTypeForm/TimberTypeAddForm.tsx
#: src/timber/components/timberType/TimberTypeForm/TimberTypeUpdateForm.tsx
msgid "Description"
msgstr "Opis"

#: src/timber/pages/accountingUser/AccountingUserDetailPage.tsx
msgid "Details Accounting User"
msgstr "Detalji računovođe"

#: src/address/pages/address/AddressDetailPage.tsx
msgid "Details Address"
msgstr "Detalji adrese"

#: src/timber/pages/buyer/BuyerDetailPage.tsx
msgid "Details Buyer"
msgstr "Detalji kupca"

#: src/timber/pages/buyerUser/BuyerUserDetailPage.tsx
msgid "Details Buyer User"
msgstr "Detalji korisnika kupca"

#: src/timber/pages/contractor/ContractorDetailPage.tsx
msgid "Details Contractor"
msgstr "Detalji izvođača"

#: src/timber/pages/contractorUser/ContractorUserDetailPage.tsx
msgid "Details Contractor User"
msgstr "Detalji korisnika izvođača"

#: src/timber/pages/cordwood/CordwoodDetailPage.tsx
msgid "Details Cordwood"
msgstr "Detalji višemetrice"

#: src/timber/pages/cordwoodHistory/CordwoodHistoryDetailPage.tsx
msgid "Details Cordwood History"
msgstr "Detalji povijesti višemetrice"

#: src/timber/pages/cutting/CuttingDetailPage.tsx
msgid "Details Cutting"
msgstr "Detalji sječe"

#: src/timber/pages/driver/DriverDetailPage.tsx
#~ msgid "Details Driver"
#~ msgstr "Detalji vozača"

#: src/timber/pages/forestOwner/ForestOwnerDetailPage.tsx
msgid "Details Forest Owner"
msgstr "Detalji vlasnika šume"

#: src/location/pages/location/LocationDetailPage.tsx
msgid "Details Location"
msgstr "Detalji lokacije"

#: src/timber/pages/log/LogDetailPage.tsx
msgid "Details Log"
msgstr "Detalji trupca"

#: src/timber/pages/logHistory/LogHistoryDetailPage.tsx
msgid "Details Log History"
msgstr "Detalji povijesti trupca"

#: src/auth/pages/membersGroup/MembersGroupDetailPage.tsx
msgid "Details Members Group"
msgstr "Detalji grupe članova"

#: src/auth/pages/membersGroupUser/MembersGroupUserDetailPage.tsx
msgid "Details Members Group User"
msgstr "Detalji korisnika grupe članova"

#: src/timber/pages/price/PriceDetailPage.tsx
msgid "Details Price"
msgstr "Detalji cijene"

#: src/timber/pages/pricingProfile/PricingProfileDetailPage.tsx
msgid "Details Pricing Profile"
msgstr "Detalji cijenovnog profila"

#: src/timber/pages/provider/ProviderDetailPage.tsx
msgid "Details Provider"
msgstr "Detalji pružatelja usluge"

#: src/timber/pages/providerUser/ProviderUserDetailPage.tsx
msgid "Details Provider User"
msgstr "Detalji korisnika pružatelja usluge"

#: src/timber/pages/roadCarrier/RoadCarrierDetailPage.tsx
msgid "Details Road Carrier"
msgstr "Detalji prjevoznika"

#: src/auth/pages/role/RoleDetailPage.tsx
msgid "Details Role"
msgstr "Detalji uloge"

#: src/auth/pages/roleAssignment/RoleAssignmentDetailPage.tsx
msgid "Details Role Assignment"
msgstr "Detalji dodijeljene uloge"

#: src/auth/pages/rolePermission/RolePermissionDetailPage.tsx
msgid "Details Role Permission"
msgstr "Detalji dozvole uloge"

#: src/auth/pages/scopeGroup/ScopeGroupDetailPage.tsx
msgid "Details Scope Group"
msgstr "Detalji grupe opsega"

#: src/timber/pages/shipment/ShipmentDetailPage.tsx
msgid "Details Shipment"
msgstr "Detalji otpreme"

#: src/timber/pages/shipmentHistory/ShipmentHistoryDetailPage.tsx
msgid "Details Shipment History"
msgstr "Detalji povijesti pošiljke"

#: src/timber/pages/thicknessClass/ThicknessClassDetailPage.tsx
msgid "Details Thickness Class"
msgstr "Detalji klase debljine"

#: src/timber/pages/timberClass/TimberClassDetailPage.tsx
msgid "Details Timber Class"
msgstr "Detalji klase drvene građe"

#: src/timber/pages/timberStorage/TimberStorageDetailPage.tsx
msgid "Details Timber Storage"
msgstr "Detalji skladištenja drvene građe"

#: src/timber/pages/timberType/TimberTypeDetailPage.tsx
msgid "Details Timber Type"
msgstr "Detalji vrste drvene građe"

#: src/timber/pages/treeMarking/TreeMarkingDetailPage.tsx
msgid "Details Tree Marking"
msgstr "Detalji doznake"

#: src/auth/pages/user/UserDetailPage.tsx
msgid "Details User"
msgstr "Detalji korisnika"

#: src/address/pages/userAddress/UserAddressDetailPage.tsx
msgid "Details User Address"
msgstr "Detalji korisničke adrese"

#: src/auth/pages/userSession/UserSessionDetailPage.tsx
msgid "Details User Session"
msgstr "Detalji korisničke sesije"

#: src/auth/components/userSession/UserSessionDetail/UserSessionDetail.tsx
#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx
#: src/auth/components/userSession/UserSessionForm/UserSessionUpdateForm.tsx
#: src/auth/components/userSession/UserSessionList/UserSessionListItem.tsx
msgid "Device"
msgstr "Uređaj"

#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx
msgid "Diameter"
msgstr "Diametar"

#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
msgid "Diameter (cm)"
msgstr "Promjer (cm)"

#: src/timber/components/log/LogList/LogListSearch.tsx
msgid "Diameter (cm) From"
msgstr "Promjer (cm) od"

#: src/timber/components/log/LogList/LogListSearch.tsx
msgid "Diameter (cm) To"
msgstr "Promjer (cm) do"

#: src/share/components/chat/ChatFileList.tsx
msgid "Download"
msgstr "Preuzmi"

#. placeholder {0}: file.filename
#: src/share/components/chat/ChatFileList.tsx
msgid "Download {0}"
msgstr "Preuzmi {0}"

#: src/share/components/footer/Footer.tsx
msgid "Download Mobile App"
msgstr "Preuzmite Mobilnu Aplikaciju"

#: src/timber/components/driver/DriverDetail/DriverDetail.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
#: src/timber/pages/driver/DriverEntityPage.tsx
#~ msgid "Driver"
#~ msgstr "Vozač"

#: src/timber/hooks/useDriver.ts
#~ msgid "Driver add error: "
#~ msgstr "Pogreška pri dodavanju vozača: "

#: src/timber/hooks/useDriver.ts
#~ msgid "Driver delete error: "
#~ msgstr "Pogreška pri brisanju vozača: "

#: src/timber/hooks/useDriver.ts
#~ msgid "Driver deleted"
#~ msgstr "Vozač je obrisan"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
#~ msgid "Driver Id is required"
#~ msgstr "ID vozača je obavezan"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
#~ msgid "Driver Name"
#~ msgstr "Ime vozača"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
#~ msgid "Driver Registration Number"
#~ msgstr "Registracijski broj vozača"

#: src/timber/hooks/useDriver.ts
#~ msgid "Driver update error: "
#~ msgstr "Pogreška pri ažuriranju vozača: "

#: src/timber/hooks/useDriver.ts
#~ msgid "Driver updated"
#~ msgstr "Vozač je ažuriran"

#: src/app/mappers.tsx
#: src/timber/components/driver/DriverList/DriverListHeader.tsx
#: src/timber/pages/listItems.tsx
#~ msgid "Drivers"
#~ msgstr "Vozači"

#: src/share/components/layout/Layout/Trash.tsx
msgid "Drop here to delete"
msgstr "Ispusti ovdje za brisanje"

#: src/address/components/address/AddressList/AddressListItemTools.tsx
#: src/address/components/userAddress/UserAddressList/UserAddressListItemTools.tsx
#: src/address/pages/address/AddressDetailPage.tsx
#: src/address/pages/address/AddressEntityPage.tsx
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListItemTools.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListItemTools.tsx
#: src/auth/components/role/RoleList/RoleListItemTools.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListItemTools.tsx
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListItemTools.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListItemTools.tsx
#: src/auth/components/user/UserList/UserListItemTools.tsx
#: src/auth/components/userSession/UserSessionList/UserSessionListItemTools.tsx
#: src/auth/pages/membersGroup/MembersGroupDetailPage.tsx
#: src/auth/pages/membersGroup/MembersGroupEntityPage.tsx
#: src/auth/pages/role/RoleDetailPage.tsx
#: src/auth/pages/role/RoleEntityPage.tsx
#: src/auth/pages/scopeGroup/ScopeGroupDetailPage.tsx
#: src/auth/pages/scopeGroup/ScopeGroupEntityPage.tsx
#: src/auth/pages/user/UserDetailPage.tsx
#: src/auth/pages/user/UserEntityPage.tsx
#: src/auth/pages/userSession/UserSessionDetailPage.tsx
#: src/auth/pages/userSession/UserSessionEntityPage.tsx
#: src/location/components/location/LocationList/LocationListItemTools.tsx
#: src/location/pages/location/LocationDetailPage.tsx
#: src/location/pages/location/LocationEntityPage.tsx
#: src/share/components/breadcrumbs/RouterBreadcrumbs.tsx
#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListItemTools.tsx
#: src/timber/components/buyer/BuyerList/BuyerListItemTools.tsx
#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListItemTools.tsx
#: src/timber/components/contractor/ContractorList/ContractorListItemTools.tsx
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListItemTools.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListItemTools.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItemTools.tsx
#: src/timber/components/cutting/CuttingList/CuttingListItemTools.tsx
#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListItemTools.tsx
#: src/timber/components/log/LogList/LogListItemTools.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItemTools.tsx
#: src/timber/components/price/PriceList/PriceListItemTools.tsx
#: src/timber/components/pricingProfile/PricingProfileList/PricingProfileListItemTools.tsx
#: src/timber/components/provider/ProviderList/ProviderListItemTools.tsx
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListItemTools.tsx
#: src/timber/components/roadCarrier/RoadCarrierList/RoadCarrierListItemTools.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListItemTools.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItemTools.tsx
#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListItemTools.tsx
#: src/timber/components/timberClass/TimberClassList/TimberClassListItemTools.tsx
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListItemTools.tsx
#: src/timber/components/timberType/TimberTypeList/TimberTypeListItemTools.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListItemTools.tsx
#: src/timber/pages/accountingUser/AccountingUserDetailPage.tsx
#: src/timber/pages/accountingUser/AccountingUserEntityPage.tsx
#: src/timber/pages/buyer/BuyerDetailPage.tsx
#: src/timber/pages/buyer/BuyerEntityPage.tsx
#: src/timber/pages/buyerUser/BuyerUserDetailPage.tsx
#: src/timber/pages/buyerUser/BuyerUserEntityPage.tsx
#: src/timber/pages/contractor/ContractorDetailPage.tsx
#: src/timber/pages/contractor/ContractorEntityPage.tsx
#: src/timber/pages/contractorUser/ContractorUserDetailPage.tsx
#: src/timber/pages/contractorUser/ContractorUserEntityPage.tsx
#: src/timber/pages/cordwood/CordwoodDetailPage.tsx
#: src/timber/pages/cordwood/CordwoodEntityPage.tsx
#: src/timber/pages/cutting/CuttingDetailPage.tsx
#: src/timber/pages/cutting/CuttingEntityPage.tsx
#: src/timber/pages/forestOwner/ForestOwnerDetailPage.tsx
#: src/timber/pages/forestOwner/ForestOwnerEntityPage.tsx
#: src/timber/pages/log/LogDetailPage.tsx
#: src/timber/pages/log/LogEntityPage.tsx
#: src/timber/pages/price/PriceDetailPage.tsx
#: src/timber/pages/price/PriceEntityPage.tsx
#: src/timber/pages/pricingProfile/PricingProfileDetailPage.tsx
#: src/timber/pages/pricingProfile/PricingProfileEntityPage.tsx
#: src/timber/pages/provider/ProviderDetailPage.tsx
#: src/timber/pages/provider/ProviderEntityPage.tsx
#: src/timber/pages/providerUser/ProviderUserDetailPage.tsx
#: src/timber/pages/providerUser/ProviderUserEntityPage.tsx
#: src/timber/pages/roadCarrier/RoadCarrierDetailPage.tsx
#: src/timber/pages/roadCarrier/RoadCarrierEntityPage.tsx
#: src/timber/pages/shipment/ShipmentDetailPage.tsx
#: src/timber/pages/shipment/ShipmentEntityPage.tsx
#: src/timber/pages/thicknessClass/ThicknessClassDetailPage.tsx
#: src/timber/pages/thicknessClass/ThicknessClassEntityPage.tsx
#: src/timber/pages/timberClass/TimberClassDetailPage.tsx
#: src/timber/pages/timberClass/TimberClassEntityPage.tsx
#: src/timber/pages/timberStorage/TimberStorageDetailPage.tsx
#: src/timber/pages/timberStorage/TimberStorageEntityPage.tsx
#: src/timber/pages/timberType/TimberTypeDetailPage.tsx
#: src/timber/pages/timberType/TimberTypeEntityPage.tsx
#: src/timber/pages/treeMarking/TreeMarkingDetailPage.tsx
#: src/timber/pages/treeMarking/TreeMarkingEntityPage.tsx
msgid "Edit"
msgstr "Uredi"

#: src/timber/pages/accountingUser/AccountingUserUpdateEditPage.tsx
msgid "Edit Accounting User"
msgstr "Uredi računovođu"

#: src/address/pages/address/AddressUpdateEditPage.tsx
msgid "Edit Address"
msgstr "Uredi adresu"

#: src/share/components/chat/ChatMessage.tsx
msgid "Edit and resend"
msgstr "Uredi i pošalji ponovno"

#: src/timber/pages/buyer/BuyerUpdateEditPage.tsx
msgid "Edit Buyer"
msgstr "Uredi kupca"

#: src/timber/pages/buyerUser/BuyerUserUpdateEditPage.tsx
msgid "Edit Buyer User"
msgstr "Uredi korisnika kupca"

#: src/timber/pages/contractor/ContractorUpdateEditPage.tsx
msgid "Edit Contractor"
msgstr "Uredi izvođača"

#: src/timber/pages/contractorUser/ContractorUserUpdateEditPage.tsx
msgid "Edit Contractor User"
msgstr "Uredi korisnika izvođača"

#: src/timber/pages/cordwood/CordwoodUpdateEditPage.tsx
msgid "Edit Cordwood"
msgstr "Uredi višemetricu"

#: src/timber/pages/cordwoodHistory/CordwoodHistoryUpdateEditPage.tsx
msgid "Edit Cordwood History"
msgstr "Uredi povijest višemetrice"

#: src/timber/pages/cutting/CuttingUpdateEditPage.tsx
msgid "Edit Cutting"
msgstr "Uredi sječu"

#: src/timber/pages/driver/DriverUpdateEditPage.tsx
#~ msgid "Edit Driver"
#~ msgstr "Uredi vozača"

#: src/timber/pages/forestOwner/ForestOwnerUpdateEditPage.tsx
msgid "Edit Forest Owner"
msgstr "Uredi vlasnika šume"

#: src/location/pages/location/LocationUpdateEditPage.tsx
msgid "Edit Location"
msgstr "Uredi lokaciju"

#: src/timber/pages/log/LogUpdateEditPage.tsx
msgid "Edit Log"
msgstr "Uredi trupac"

#: src/timber/pages/logHistory/LogHistoryUpdateEditPage.tsx
msgid "Edit Log History"
msgstr "Uredi povijest trupca"

#: src/auth/pages/membersGroup/MembersGroupUpdateEditPage.tsx
msgid "Edit Members Group"
msgstr "Uredi grupu članova"

#: src/auth/pages/membersGroupUser/MembersGroupUserUpdateEditPage.tsx
msgid "Edit Members Group User"
msgstr "Uredi korisnika grupe članova"

#: src/share/components/chat/ChatMessage.tsx
msgid "Edit message"
msgstr "Uredi poruku"

#: src/timber/pages/price/PriceUpdateEditPage.tsx
msgid "Edit Price"
msgstr "Uredi cijenu"

#: src/timber/pages/pricingProfile/PricingProfileUpdateEditPage.tsx
msgid "Edit Pricing Profile"
msgstr "Uredi cijenovni profil"

#: src/timber/pages/provider/ProviderUpdateEditPage.tsx
msgid "Edit Provider"
msgstr "Uredi pružatelja usluge"

#: src/timber/pages/providerUser/ProviderUserUpdateEditPage.tsx
msgid "Edit Provider User"
msgstr "Uredi korisnika pružatelja usluge"

#: src/timber/pages/roadCarrier/RoadCarrierUpdateEditPage.tsx
msgid "Edit Road Carrier"
msgstr "Uredi prijevoznika"

#: src/auth/pages/role/RoleUpdateEditPage.tsx
msgid "Edit Role"
msgstr "Uredi ulogu"

#: src/auth/pages/roleAssignment/RoleAssignmentUpdateEditPage.tsx
msgid "Edit Role Assignment"
msgstr "Uredi dodijeljenu ulogu"

#: src/auth/pages/rolePermission/RolePermissionUpdateEditPage.tsx
msgid "Edit Role Permission"
msgstr "Uredi dozvolu uloge"

#: src/auth/pages/scopeGroup/ScopeGroupUpdateEditPage.tsx
msgid "Edit Scope Group"
msgstr "Uredi grupu opsega"

#: src/timber/pages/shipment/ShipmentUpdateEditPage.tsx
msgid "Edit Shipment"
msgstr "Uredi pošiljku"

#: src/timber/pages/shipmentHistory/ShipmentHistoryUpdateEditPage.tsx
msgid "Edit Shipment History"
msgstr "Uredi povijest pošiljke"

#: src/timber/pages/thicknessClass/ThicknessClassUpdateEditPage.tsx
msgid "Edit Thickness Class"
msgstr "Uredi klasu debljine"

#: src/timber/pages/timberClass/TimberClassUpdateEditPage.tsx
msgid "Edit Timber Class"
msgstr "Uredi klasu drvene građe"

#: src/timber/pages/timberStorage/TimberStorageUpdateEditPage.tsx
msgid "Edit Timber Storage"
msgstr "Uredi skladištenje drvene građe"

#: src/timber/pages/timberType/TimberTypeUpdateEditPage.tsx
msgid "Edit Timber Type"
msgstr "Uredi vrstu drvene građe"

#: src/timber/pages/treeMarking/TreeMarkingUpdateEditPage.tsx
msgid "Edit Tree Marking"
msgstr "Uredi doznaku"

#: src/auth/pages/user/UserUpdateEditPage.tsx
msgid "Edit User"
msgstr "Uredi korisnika"

#: src/address/pages/userAddress/UserAddressUpdateEditPage.tsx
msgid "Edit User Address"
msgstr "Uredi korisničku adresu"

#: src/auth/pages/userSession/UserSessionUpdateEditPage.tsx
msgid "Edit User Session"
msgstr "Uredi korisničku sesiju"

#: src/share/components/chat/ChatMessage.tsx
msgid "Edit your question"
msgstr "Uredi svoje pitanje"

#: src/address/components/address/AddressDetail/AddressDetail.tsx
#: src/address/components/address/AddressForm/AddressAddForm.tsx
#: src/address/components/address/AddressForm/AddressUpdateForm.tsx
#: src/address/components/address/AddressList/AddressListItem.tsx
#: src/auth/components/user/UserDetail/UserDetail.tsx
#: src/auth/components/user/UserForm/UserAddForm.tsx
#: src/auth/components/user/UserList/UserListItem.tsx
#: src/timber/components/accountingUser/AccountingUserDetail/AccountingUserDetail.tsx
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserAddForm.tsx
#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListItem.tsx
#: src/timber/components/buyerUser/BuyerUserDetail/BuyerUserDetail.tsx
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddForm.tsx
#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListItem.tsx
#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListItem.tsx
#: src/timber/components/providerUser/ProviderUserDetail/ProviderUserDetail.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListItem.tsx
msgid "Email"
msgstr "E-mail"

#: src/pages/ForgotPasswordPage.tsx
#: src/pages/LoginPage.tsx
#: src/pages/ProfilePage.tsx
msgid "Email Address"
msgstr "E-mail adresa"

#: src/pages/ForgotPasswordPage.tsx
#: src/pages/LoginPage.tsx
msgid "Email Address is invalid"
msgstr "E-mail adresa je nevažeća"

#: src/pages/ForgotPasswordPage.tsx
#: src/pages/LoginPage.tsx
msgid "Email address is required"
msgstr "E-mail adresa je obavezna"

#: src/auth/components/user/UserForm/UserAddForm.tsx
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserAddForm.tsx
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx
msgid "Email is required"
msgstr "E-mail je obavezan"

#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
#: src/timber/components/cutting/CuttingList/CuttingListItem.tsx
msgid "End At"
msgstr "Završetak u"

#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
msgid "End At is required"
msgstr "Završetak u je obavezan"

#: src/share/components/form/FormDateTime/FormDateRange.tsx
msgid "End Date"
msgstr "Krajnji datum"

#: src/pages/ForgotPasswordPage.tsx
msgid "Enter your email address and we’ll send you a link to reset your password."
msgstr "Unesite svoju e-mail adresu i poslat ćemo vam link za resetovanje lozinke."

#: src/share/components/alert/DescriptionAlert/useDescriptionAlert.ts
msgid "Error"
msgstr "Greška"

#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx
msgid "External Key"
msgstr "Vanjski ključ"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootTable.tsx
msgid "Failed to load data"
msgstr "Neuspješno učitavanje podataka"

#: src/share/components/chat/useChat.ts
msgid "Failed to send message"
msgstr "Slanje poruke nije uspjelo"

#: src/timber/types/models/CuttingState.d.ts
#: src/timber/types/models/ShipmentState.d.ts
msgid "Finished"
msgstr "Gotov"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "For Personal Use"
msgstr "Za osobnu upotrebu"

#: src/pages/PrivacyPolicyPage.tsx
msgid "For questions, contact: info@iokrono.com."
msgstr "Za pitanja kontaktirajte: info@iokrono.com."

#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
#: src/timber/components/cutting/CuttingList/CuttingListItem.tsx
#: src/timber/components/cutting/CuttingList/CuttingListSearch.tsx
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerDetail.tsx
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageDetail.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateForm.tsx
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListItem.tsx
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListSearch.tsx
#: src/timber/pages/forestOwner/ForestOwnerEntityPage.tsx
msgid "Forest Owner"
msgstr "Vlasnik šume"

#: src/timber/hooks/useForestOwner.ts
msgid "Forest Owner add error: "
msgstr "Greška pri dodavanju vlasnika šume: "

#: src/timber/hooks/useForestOwner.ts
msgid "Forest Owner delete error: "
msgstr "Greška pri brisanju vlasnika šume: "

#: src/timber/hooks/useForestOwner.ts
msgid "Forest Owner deleted"
msgstr "Vlasnik šume je obrisan"

#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateForm.tsx
#~ msgid "Forest Owner Id is required"
#~ msgstr "ID vlasnika šume je obavezan"

#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateForm.tsx
msgid "Forest Owner is required"
msgstr "Vlasnik šume je obavezan"

#: src/timber/hooks/useForestOwner.ts
msgid "Forest Owner update error: "
msgstr "Greška pri ažuriranju vlasnika šume: "

#: src/timber/hooks/useForestOwner.ts
msgid "Forest Owner updated"
msgstr "Vlasnik šume je ažuriran"

#: src/timber/types/models/Split.ts
msgid "Forest owners"
msgstr "Vlasnici šuma"

#: src/app/mappers.tsx
#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListHeader.tsx
#: src/timber/pages/listItems.tsx
msgid "Forest Owners"
msgstr "Vlasnici šuma"

#: src/pages/ForgotPasswordPage.tsx
msgid "Forgot Password"
msgstr "Zaboravljena lozinka"

#: src/pages/LoginPage.tsx
msgid "Forgot Password?"
msgstr "Zaboravili ste lozinku?"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootReport.tsx
#: src/timber/components/generic/report/TimelineRootReport.tsx
msgid "From"
msgstr "Od"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootReport.tsx
#: src/timber/components/generic/report/TimelineRootReport.tsx
#~ msgid "From Input Date"
#~ msgstr "Od datuma unosa"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootReport.tsx
#: src/timber/components/generic/report/TimelineRootReport.tsx
#~ msgid "From Shipment Date"
#~ msgstr "Od datuma pošiljke"

#: src/pages/ProfilePage.tsx
msgid "Full Name"
msgstr "Puno ime"

#: src/share/components/chat/ChatThread.tsx
msgid "Give me a report for the last month for each active cutting"
msgstr "Daj mi izvješće za prošli mjesec za svaku aktivnu sječu"

#: src/share/components/chat/ChatThread.tsx
msgid "Give me a report for the last month for each contractor"
msgstr "Daj mi izvješće za prošli mjesec za svakog izvođača"

#: src/share/components/scope/ScopeSwitcher.tsx
msgid "Global"
msgstr "Globalno"

#: src/pages/NotFoundPage.tsx
#: src/pages/UnauthorizedPage.tsx
msgid "Go Home"
msgstr "Idi na početnu stranicu"

#: src/pages/NotFoundPage.tsx
#: src/pages/UnauthorizedPage.tsx
msgid "Go Login"
msgstr "Idi na prijavu"

#: src/pages/DashboardHomePage.tsx
msgid "Go to"
msgstr "Idi na"

#: src/timber/components/generic/report/GenericRootReport.tsx
msgid "Graphs"
msgstr "Grafovi"

#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupDetail.tsx
#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupAddForm.tsx
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListSearch.tsx
msgid "Group Type"
msgstr "Tip grupe"

#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupAddForm.tsx
msgid "Group Type is required"
msgstr "Tip grupe je obavezan"

#: src/auth/components/user/UserForm/UserAddForm.tsx
#: src/auth/components/user/UserForm/UserUpdateForm.tsx
msgid "Hash Password"
msgstr "Hash lozinka"

#: src/auth/components/user/UserForm/UserAddForm.tsx
#: src/auth/components/user/UserForm/UserUpdateForm.tsx
msgid "Hash Password is required"
msgstr "Hash lozinka je obavezna"

#: src/share/components/chat/ChatWidget.tsx
msgid "Hide history"
msgstr "Sakrij povijest"

#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupDetail.tsx
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListItem.tsx
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListSearch.tsx
#: src/auth/components/scopeGroup/ScopeGroupDetail/ScopeGroupDetail.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListItem.tsx
#: src/location/components/location/LocationDetail/LocationDetail.tsx
#: src/location/components/location/LocationList/LocationListItem.tsx
#: src/location/components/location/LocationList/LocationListSearch.tsx
msgid "Hierarchy Name"
msgstr "Naziv hijerarhije"

#: src/app/App.tsx
#: src/pages/listItems.tsx
#: src/timber/components/history/HistoryList/HistoryListHeader.tsx
#: src/timber/pages/history/HistoryListPage.tsx
msgid "History"
msgstr "Povijest"

#: src/app/App.tsx
msgid "Home"
msgstr "Početna"

#: src/share/components/chat/ChatThread.tsx
#~ msgid "How many timber storages are there?"
#~ msgstr "Koliko ima skladišta drva?"

#: src/share/components/footer/Footer.tsx
msgid "How to Install APK on Android"
msgstr "Kako Instalirati APK na Android"

#: src/timber/components/buyer/BuyerDetail/BuyerDetail.tsx
#: src/timber/components/buyer/BuyerForm/BuyerAddForm.tsx
#: src/timber/components/buyer/BuyerForm/BuyerUpdateForm.tsx
#: src/timber/components/contractor/ContractorDetail/ContractorDetail.tsx
#: src/timber/components/contractor/ContractorForm/ContractorAddForm.tsx
#: src/timber/components/contractor/ContractorForm/ContractorUpdateForm.tsx
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerDetail.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerAddForm.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerUpdateForm.tsx
#: src/timber/components/provider/ProviderDetail/ProviderDetail.tsx
#: src/timber/components/provider/ProviderForm/ProviderAddForm.tsx
#: src/timber/components/provider/ProviderForm/ProviderUpdateForm.tsx
msgid "Iban"
msgstr "IBAN"

#: src/pages/ProfilePage.tsx
msgid "Id"
msgstr "ID"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/log/LogList/LogListSearch.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemFromHistory.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx
msgid "IK"
msgstr "IK"

#: src/timber/types/models/CuttingState.d.ts
#: src/timber/types/models/ShipmentState.d.ts
msgid "In progress"
msgstr "U tijeku"

#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
msgid "In storage (m³)"
msgstr "U skladištu (m³)"

#: src/share/components/form/FormInput/NumberField.tsx
msgid "Increase"
msgstr "Povećaj"

#: src/timber/components/generic/report/GenericRootShipments.tsx
#: src/timber/components/history/HistoryList/HistoryListItem.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx
msgid "Key"
msgstr "Ključ"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Key is required"
msgstr "Ključ je obavezan"

#: src/share/components/localization/Locale/Locale.tsx
msgid "Language"
msgstr "Jezik"

#: src/share/components/chat/ConversationList.tsx
msgid "Last 7 days"
msgstr "Zadnjih 7 dana"

#: src/share/components/form/FormDateTime/FormDateRange.tsx
msgid "Last Month"
msgstr "Prošli mjesec"

#: src/pages/PrivacyPolicyPage.tsx
msgid "Last updated:"
msgstr "Zadnje ažuriranje:"

#: src/share/components/form/FormDateTime/FormDateRange.tsx
msgid "Last Week"
msgstr "Prošli tjedan"

#: src/share/components/form/FormDateTime/FormDateRange.tsx
msgid "Last Year"
msgstr "Prošla godina"

#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
msgid "left the storage"
msgstr "otpremljeno iz skladišta"

#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx
msgid "Length"
msgstr "Dužina"

#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
msgid "Length (cm)"
msgstr "Dužina (cm)"

#: src/timber/components/log/LogList/LogListSearch.tsx
msgid "Length (cm) From"
msgstr "Dužina (cm) od"

#: src/timber/components/log/LogList/LogListSearch.tsx
msgid "Length (cm) To"
msgstr "Dužina (cm) do"

#: src/pages/PreferencesPage.tsx
msgid "Light"
msgstr "Svijetlo"

#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
msgid "Linked"
msgstr "Povezano"

#: src/timber/pages/accountingUser/AccountingUserListPage.tsx
msgid "List Accounting User"
msgstr "Lista računovođa"

#: src/address/pages/address/AddressListPage.tsx
msgid "List Address"
msgstr "Lista adresa"

#: src/timber/pages/buyer/BuyerListPage.tsx
msgid "List Buyer"
msgstr "Lista kupaca"

#: src/timber/pages/buyerUser/BuyerUserListPage.tsx
msgid "List Buyer User"
msgstr "Lista korisnika kupaca"

#: src/timber/pages/contractor/ContractorListPage.tsx
msgid "List Contractor"
msgstr "Lista izvođača"

#: src/timber/pages/contractorUser/ContractorUserListPage.tsx
msgid "List Contractor User"
msgstr "Lista korisnika izvođača"

#: src/timber/pages/cordwood/CordwoodListPage.tsx
msgid "List Cordwood"
msgstr "Lista višemetrice"

#: src/timber/pages/cordwoodHistory/CordwoodHistoryListPage.tsx
msgid "List Cordwood History"
msgstr "Lista povijesti višemetrice"

#: src/timber/pages/cutting/CuttingListPage.tsx
msgid "List Cutting"
msgstr "Lista sječa"

#: src/timber/pages/driver/DriverListPage.tsx
#~ msgid "List Driver"
#~ msgstr "Lista vozača"

#: src/timber/pages/forestOwner/ForestOwnerListPage.tsx
msgid "List Forest Owner"
msgstr "Lista vlasnika šuma"

#: src/location/pages/location/LocationListPage.tsx
msgid "List Location"
msgstr "Lista lokacija"

#: src/timber/pages/log/LogListPage.tsx
msgid "List Log"
msgstr "Lista trupaca"

#: src/timber/pages/logHistory/LogHistoryListPage.tsx
msgid "List Log History"
msgstr "Lista povijesti trupca"

#: src/auth/pages/membersGroup/MembersGroupListPage.tsx
msgid "List Members Group"
msgstr "Lista grupa članova"

#: src/auth/pages/membersGroupUser/MembersGroupUserListPage.tsx
msgid "List Members Group User"
msgstr "Lista korisnika grupa članova"

#: src/timber/pages/price/PriceListPage.tsx
msgid "List Price"
msgstr "Lista cijena"

#: src/timber/pages/pricingProfile/PricingProfileListPage.tsx
msgid "List Pricing Profile"
msgstr "Lista cijenovnih profila"

#: src/timber/pages/provider/ProviderListPage.tsx
msgid "List Provider"
msgstr "Lista pružatelja usluge"

#: src/timber/pages/providerUser/ProviderUserListPage.tsx
msgid "List Provider User"
msgstr "Lista korisnika pružatelja usluge"

#: src/timber/pages/roadCarrier/RoadCarrierListPage.tsx
msgid "List Road Carrier"
msgstr "Lista prijevoznika"

#: src/auth/pages/role/RoleListPage.tsx
msgid "List Role"
msgstr "Lista uloga"

#: src/auth/pages/roleAssignment/RoleAssignmentListPage.tsx
msgid "List Role Assignment"
msgstr "Lista dodijeljenih uloga"

#: src/auth/pages/rolePermission/RolePermissionListPage.tsx
msgid "List Role Permission"
msgstr "Lista dozvola uloga"

#: src/auth/pages/scopeGroup/ScopeGroupListPage.tsx
msgid "List Scope Group"
msgstr "Lista grupa opsega"

#: src/timber/pages/shipment/ShipmentListPage.tsx
msgid "List Shipment"
msgstr "Lista pošiljki"

#: src/timber/pages/shipmentHistory/ShipmentHistoryListPage.tsx
msgid "List Shipment History"
msgstr "List povijesti pošiljke"

#: src/share/components/chat/ChatThread.tsx
#~ msgid "List the timber classes"
#~ msgstr "Prikaži klase drva"

#: src/timber/pages/thicknessClass/ThicknessClassListPage.tsx
msgid "List Thickness Class"
msgstr "Lista klasa debljine"

#: src/timber/pages/timberClass/TimberClassListPage.tsx
msgid "List Timber Class"
msgstr "Lista klasa drvene građe"

#: src/timber/pages/timberStorage/TimberStorageListPage.tsx
msgid "List Timber Storage"
msgstr "Lista skladišta drvene građe"

#: src/timber/pages/timberType/TimberTypeListPage.tsx
msgid "List Timber Type"
msgstr "Lista vrsta drvene građe"

#: src/timber/pages/treeMarking/TreeMarkingListPage.tsx
msgid "List Tree Marking"
msgstr "Lista doznaka"

#: src/auth/pages/user/UserListPage.tsx
msgid "List User"
msgstr "Lista korisnika"

#: src/address/pages/userAddress/UserAddressListPage.tsx
msgid "List User Address"
msgstr "Lista korisničkih adresa"

#: src/auth/pages/userSession/UserSessionListPage.tsx
msgid "List User Session"
msgstr "Lista korisničkih sesija"

#: src/share/components/chat/ConversationList.tsx
msgid "Load more"
msgstr "Učitaj više"

#: src/share/components/chat/ConversationList.tsx
msgid "Loading..."
msgstr "Učitavanje..."

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx
msgid "Local Created At"
msgstr "Lokalno kreirano u"

#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
#: src/timber/components/log/LogList/LogListSearch.tsx
msgid "Local Created At From"
msgstr "Lokalno kreirano od"

#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
#: src/timber/components/log/LogList/LogListSearch.tsx
msgid "Local Created At To"
msgstr "Lokalno kreirano do"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
msgid "Local Deleted At"
msgstr "Lokalno obrisano u"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
msgid "Local Updated At"
msgstr "Lokalno ažurirano u"

#: src/location/components/location/LocationDetail/LocationDetail.tsx
#: src/location/components/location/LocationList/LocationListSearch.tsx
#: src/location/pages/location/LocationEntityPage.tsx
#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageDetail.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateForm.tsx
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListItem.tsx
msgid "Location"
msgstr "Lokacija"

#: src/location/hooks/useLocation.ts
msgid "Location add error: "
msgstr "Greška pri dodavanju lokacije: "

#: src/location/hooks/useLocation.ts
msgid "Location delete error: "
msgstr "Greška pri brisanju lokacije: "

#: src/location/hooks/useLocation.ts
msgid "Location deleted"
msgstr "Lokacija je obrisana"

#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateForm.tsx
#~ msgid "Location Id is required"
#~ msgstr "ID lokacije je obavezan"

#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateForm.tsx
msgid "Location is required"
msgstr "Lokacija je obavezna"

#: src/location/hooks/useLocation.ts
msgid "Location update error: "
msgstr "Greška pri ažuriranju lokacije: "

#: src/location/hooks/useLocation.ts
msgid "Location updated"
msgstr "Lokacija je ažurirana"

#: src/app/mappers.tsx
#: src/location/components/location/LocationDetail/LocationTabs.tsx
#: src/location/components/location/LocationList/LocationListHeader.tsx
#: src/location/pages/listItems.tsx
msgid "Locations"
msgstr "Lokacije"

#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryAddForm.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
#: src/timber/pages/log/LogEntityPage.tsx
#: src/timber/types/models/MergedHistory.ts
msgid "Log"
msgstr "Trupac"

#: src/timber/hooks/useLog.ts
msgid "Log add error: "
msgstr "Greška pri dodavanju trupca: "

#: src/timber/hooks/useLog.ts
msgid "Log delete error: "
msgstr "Greška pri brisanju trupca: "

#: src/timber/hooks/useLog.ts
msgid "Log deleted"
msgstr "Trupac je obrisan"

#: src/app/mappers.tsx
#: src/timber/components/log/LogDetail/LogTabs.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListHeader.tsx
msgid "Log Histories"
msgstr "Povijesti trupca"

#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/pages/logHistory/LogHistoryEntityPage.tsx
msgid "Log History"
msgstr "Povijest trupaca"

#: src/timber/hooks/useLogHistory.ts
msgid "Log History add error: "
msgstr "Greška pri dodavanju povijesti trupca: "

#: src/timber/hooks/useLogHistory.ts
msgid "Log History delete error: "
msgstr "Greška pri brisanju povijesti trupca: "

#: src/timber/hooks/useLogHistory.ts
msgid "Log History deleted"
msgstr "Povijest trupca je obrisana"

#: src/timber/components/logHistory/LogHistoryForm/LogHistoryAddForm.tsx
#~ msgid "Log Id is required"
#~ msgstr "ID trupca je obavezan"

#: src/pages/LoginPage.tsx
msgid "Log in with another provider"
msgstr "Prijavite se s drugim pružateljem usluga"

#: src/pages/LoginPage.tsx
#~ msgid "Log in with another provider:"
#~ msgstr "Prijavite se putem drugog pružatelja usluga:"

#: src/timber/components/logHistory/LogHistoryForm/LogHistoryAddForm.tsx
msgid "Log is required"
msgstr "Trupac je obevezan"

#: src/timber/components/generic/report/GenericRootReport.tsx
msgid "Log Shipments"
msgstr "Pošiljke trupaca"

#: src/timber/hooks/useLog.ts
msgid "Log update error: "
msgstr "Greška pri ažuriranju trupca: "

#: src/timber/hooks/useLog.ts
msgid "Log updated"
msgstr "Trupac je ažuriran"

#: src/app/App.tsx
msgid "Login"
msgstr "Prijavite se"

#: src/pages/LoginPage.tsx
msgid "Login to have access!"
msgstr "Prijavite se za pristup!"

#: src/app/App.tsx
msgid "Logout"
msgstr "Odjava"

#: src/app/mappers.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx
#: src/timber/components/cutting/CuttingList/ActiveCuttings.tsx
#: src/timber/components/generic/report/GenericRootShipments.tsx
#: src/timber/components/generic/report/StorageShipmentPies.tsx
#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx
#: src/timber/components/history/HistoryList/HistoryListSearch.tsx
#: src/timber/components/log/LogList/LogListHeader.tsx
#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentTabs.tsx
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx
#: src/timber/types/models/ShipmentType.d.ts
msgid "Logs"
msgstr "Trupci"

#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
msgid "logs and cordwood"
msgstr "trupci i višemetrica"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootShipments.tsx
#: src/timber/components/generic/report/GenericRootTable.tsx
#: src/timber/components/generic/report/TimelineRootReport.tsx
#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx
msgid "Logs Count"
msgstr "Broj trupaca"

#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
msgid "Logs volume (m³)"
msgstr "Volumen trupaca (m³)"

#: src/timber/types/models/CordwoodMeasurementType.d.ts
msgid "m3"
msgstr "m³"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
msgid "Matched rows"
msgstr "Podudarni redovi"

#: src/timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassDetail.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx
msgid "Max Diameter"
msgstr "Maksimalni promjer"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx
msgid "Measurement Type"
msgstr "Mjerna jedinica"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#~ msgid "Measurement Type is required"
#~ msgstr "Mjerna jedinica je obavezna"

#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserAddForm.tsx
#: src/auth/components/role/RoleForm/RoleAddForm.tsx
#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx
msgid "Member Group"
msgstr "Grupa članova"

#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserAddForm.tsx
#: src/auth/components/role/RoleForm/RoleAddForm.tsx
#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx
msgid "Member Group is required"
msgstr "Grupa članova je obavezna"

#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupDetail.tsx
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListSearch.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserDetail/MembersGroupUserDetail.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListItem.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListSearch.tsx
#: src/auth/components/role/RoleDetail/RoleDetail.tsx
#: src/auth/components/role/RoleList/RoleListItem.tsx
#: src/auth/components/role/RoleList/RoleListSearch.tsx
#: src/auth/components/roleAssignment/RoleAssignmentDetail/RoleAssignmentDetail.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListItem.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListSearch.tsx
#: src/auth/components/scopeGroup/ScopeGroupDetail/ScopeGroupDetail.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListItem.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListSearch.tsx
#: src/auth/components/user/UserDetail/UserDetail.tsx
#: src/auth/components/userSession/UserSessionDetail/UserSessionDetail.tsx
#: src/auth/pages/membersGroup/MembersGroupEntityPage.tsx
#: src/auth/types/models/GroupType.d.ts
msgid "Members Group"
msgstr "Grupa članova"

#: src/auth/hooks/useMembersGroup.ts
msgid "Members Group add error: "
msgstr "Greška pri dodavanju grupe članova: "

#: src/auth/hooks/useMembersGroup.ts
msgid "Members Group delete error: "
msgstr "Greška pri brisanju grupe članova: "

#: src/auth/hooks/useMembersGroup.ts
msgid "Members Group deleted"
msgstr "Grupa članova je obrisana"

#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserAddForm.tsx
#: src/auth/components/role/RoleForm/RoleAddForm.tsx
#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx
#~ msgid "Members Group Id is required"
#~ msgstr "ID grupe članova je obavezan"

#: src/auth/hooks/useMembersGroup.ts
msgid "Members Group update error: "
msgstr "Greška pri ažuriranju grupe članova: "

#: src/auth/hooks/useMembersGroup.ts
msgid "Members Group updated"
msgstr "Grupa članova je ažurirana"

#: src/auth/components/membersGroupUser/MembersGroupUserDetail/MembersGroupUserDetail.tsx
#: src/auth/pages/membersGroupUser/MembersGroupUserEntityPage.tsx
msgid "Members Group User"
msgstr "Korisnik grupe članova"

#: src/auth/hooks/useMembersGroupUser.ts
msgid "Members Group User add error: "
msgstr "Greška pri dodavanju korisnika grupe članova: "

#: src/auth/hooks/useMembersGroupUser.ts
msgid "Members Group User delete error: "
msgstr "Greška pri brisanju korisnika grupe članova: "

#: src/auth/hooks/useMembersGroupUser.ts
msgid "Members Group User deleted"
msgstr "Korisnik grupe članova je obrisan"

#: src/app/mappers.tsx
#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupTabs.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListHeader.tsx
#: src/auth/components/user/UserDetail/UserTabs.tsx
msgid "Members Group Users"
msgstr "Korisnici grupa članova"

#: src/app/mappers.tsx
#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupTabs.tsx
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListHeader.tsx
#: src/auth/pages/listItems.tsx
msgid "Members Groups"
msgstr "Grupe članova"

#: src/timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassDetail.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx
msgid "Min Diameter"
msgstr "Minimalni promjer"

#: src/address/components/address/AddressDetail/AddressDetail.tsx
#: src/address/components/address/AddressForm/AddressAddForm.tsx
#: src/address/components/address/AddressForm/AddressUpdateForm.tsx
#: src/address/components/address/AddressList/AddressListItem.tsx
msgid "Mobile Phone"
msgstr "Mobilni telefon"

#: src/timber/components/generic/report/TimelineRootReport.tsx
msgid "Month"
msgstr "Mjesec"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx
msgid "Move to this shipment"
msgstr "Premjesti u ovu pošiljku"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
msgid "MU"
msgstr "MJ"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
msgid "MU is required"
msgstr "MJ je obavezna"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/price/PriceForm/PriceAddForm.tsx
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddForm.tsx
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingUpdateForm.tsx
msgid "must be a number."
msgstr "mora biti broj."

#: src/pages/DashboardHomePage.tsx
msgid "My provider"
msgstr "Moj pružatelj"

#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupDetail.tsx
#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupAddForm.tsx
#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupUpdateForm.tsx
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListItem.tsx
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListSearch.tsx
#: src/auth/components/role/RoleDetail/RoleDetail.tsx
#: src/auth/components/role/RoleForm/RoleAddForm.tsx
#: src/auth/components/role/RoleForm/RoleUpdateForm.tsx
#: src/auth/components/role/RoleList/RoleListItem.tsx
#: src/auth/components/role/RoleList/RoleListSearch.tsx
#: src/auth/components/scopeGroup/ScopeGroupDetail/ScopeGroupDetail.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupUpdateForm.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListItem.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListSearch.tsx
#: src/location/components/location/LocationDetail/LocationDetail.tsx
#: src/location/components/location/LocationForm/LocationAddForm.tsx
#: src/location/components/location/LocationForm/LocationUpdateForm.tsx
#: src/location/components/location/LocationList/LocationListSearch.tsx
#: src/timber/components/accountingUser/AccountingUserDetail/AccountingUserDetail.tsx
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserAddForm.tsx
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserUpdateForm.tsx
#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListItem.tsx
#: src/timber/components/buyer/BuyerDetail/BuyerDetail.tsx
#: src/timber/components/buyer/BuyerForm/BuyerAddForm.tsx
#: src/timber/components/buyer/BuyerForm/BuyerUpdateForm.tsx
#: src/timber/components/buyer/BuyerList/BuyerListItem.tsx
#: src/timber/components/buyerUser/BuyerUserDetail/BuyerUserDetail.tsx
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddForm.tsx
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserUpdateForm.tsx
#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListItem.tsx
#: src/timber/components/contractor/ContractorDetail/ContractorDetail.tsx
#: src/timber/components/contractor/ContractorForm/ContractorAddForm.tsx
#: src/timber/components/contractor/ContractorForm/ContractorUpdateForm.tsx
#: src/timber/components/contractor/ContractorList/ContractorListItem.tsx
#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListItem.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
#: src/timber/components/cutting/CuttingList/CuttingListItem.tsx
#: src/timber/components/cutting/CuttingList/CuttingListSearch.tsx
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerDetail.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerAddForm.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerUpdateForm.tsx
#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListItem.tsx
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/pricingProfile/PricingProfileDetail/PricingProfileDetail.tsx
#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileAddForm.tsx
#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileUpdateForm.tsx
#: src/timber/components/pricingProfile/PricingProfileList/PricingProfileListItem.tsx
#: src/timber/components/provider/ProviderDetail/ProviderDetail.tsx
#: src/timber/components/provider/ProviderDetail/ProviderSplitTab.tsx
#: src/timber/components/provider/ProviderForm/ProviderAddForm.tsx
#: src/timber/components/provider/ProviderForm/ProviderUpdateForm.tsx
#: src/timber/components/provider/ProviderList/ProviderListItem.tsx
#: src/timber/components/providerUser/ProviderUserDetail/ProviderUserDetail.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserUpdateForm.tsx
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListItem.tsx
#: src/timber/components/roadCarrier/RoadCarrierDetail/RoadCarrierDetail.tsx
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierAddForm.tsx
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierUpdateForm.tsx
#: src/timber/components/roadCarrier/RoadCarrierList/RoadCarrierListItem.tsx
#: src/timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassDetail.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListItem.tsx
#: src/timber/components/timberClass/TimberClassDetail/TimberClassDetail.tsx
#: src/timber/components/timberClass/TimberClassForm/TimberClassAddForm.tsx
#: src/timber/components/timberClass/TimberClassForm/TimberClassUpdateForm.tsx
#: src/timber/components/timberClass/TimberClassList/TimberClassListItem.tsx
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageDetail.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateForm.tsx
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListItem.tsx
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListSearch.tsx
#: src/timber/components/timberType/TimberTypeDetail/TimberTypeDetail.tsx
#: src/timber/components/timberType/TimberTypeForm/TimberTypeAddForm.tsx
#: src/timber/components/timberType/TimberTypeForm/TimberTypeUpdateForm.tsx
#: src/timber/components/timberType/TimberTypeList/TimberTypeListItem.tsx
msgid "Name"
msgstr "Naziv"

#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupAddForm.tsx
#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupUpdateForm.tsx
#: src/auth/components/role/RoleForm/RoleAddForm.tsx
#: src/auth/components/role/RoleForm/RoleUpdateForm.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupUpdateForm.tsx
#: src/location/components/location/LocationForm/LocationAddForm.tsx
#: src/location/components/location/LocationForm/LocationUpdateForm.tsx
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserAddForm.tsx
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserUpdateForm.tsx
#: src/timber/components/buyer/BuyerForm/BuyerAddForm.tsx
#: src/timber/components/buyer/BuyerForm/BuyerUpdateForm.tsx
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddForm.tsx
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserUpdateForm.tsx
#: src/timber/components/contractor/ContractorForm/ContractorAddForm.tsx
#: src/timber/components/contractor/ContractorForm/ContractorUpdateForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerAddForm.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerUpdateForm.tsx
#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileAddForm.tsx
#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileUpdateForm.tsx
#: src/timber/components/provider/ProviderForm/ProviderAddForm.tsx
#: src/timber/components/provider/ProviderForm/ProviderUpdateForm.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserUpdateForm.tsx
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierAddForm.tsx
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierUpdateForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx
#: src/timber/components/timberClass/TimberClassForm/TimberClassAddForm.tsx
#: src/timber/components/timberClass/TimberClassForm/TimberClassUpdateForm.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateForm.tsx
#: src/timber/components/timberType/TimberTypeForm/TimberTypeAddForm.tsx
#: src/timber/components/timberType/TimberTypeForm/TimberTypeUpdateForm.tsx
msgid "Name is required"
msgstr "Naviv je obavezan"

#: src/share/components/chat/ChatHeader.tsx
msgid "Narrow chat"
msgstr "Suži chat"

#: src/timber/components/provider/ProviderDetail/ProviderAttentionList.tsx
msgid "Needs attention"
msgstr "Zahtijeva pažnju"

#: src/share/components/chat/ChatHeader.tsx
#: src/share/components/chat/ConversationList.tsx
msgid "New conversation"
msgstr "Novi razgovor"

#: src/pages/ChangePasswordPage.tsx
msgid "New Password"
msgstr "Nova lozinka"

#: src/pages/ChangePasswordPage.tsx
msgid "New password is required"
msgstr "Nova lozinka je obavezna"

#: src/pages/ChangePasswordPage.tsx
msgid "New password must be more than 8 characters"
msgstr "Nova lozinka mora imati više od 8 znakova"

#: src/share/components/chat/ChatToolView.tsx
msgid "no"
msgstr "Ne"

#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemFromHistory.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx
msgid "No"
msgstr "Ne"

#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListItem.tsx
msgid "No Accounting Users"
msgstr "Nema računovođa"

#: src/address/components/address/AddressList/AddressListItem.tsx
msgid "No Addresses"
msgstr "Nema adresa"

#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListItem.tsx
msgid "No Buyer Users"
msgstr "Nema kupaca korisnika"

#: src/timber/components/buyer/BuyerList/BuyerListItem.tsx
msgid "No Buyers"
msgstr "Nema kupaca"

#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListItem.tsx
msgid "No Contractor Users"
msgstr "Nema korisnika izvođača"

#: src/timber/components/contractor/ContractorList/ContractorListItem.tsx
msgid "No Contractors"
msgstr "Nema izvođača"

#: src/share/components/chat/ConversationList.tsx
msgid "No conversations match \"{search}\""
msgstr "Nema razgovora koji odgovaraju \"{search}\""

#: src/share/components/chat/ConversationList.tsx
msgid "No conversations yet"
msgstr "Još nema razgovora"

#: src/timber/components/cutting/CuttingList/ActiveCuttings.tsx
msgid "No cordwood data"
msgstr "Nema zapisa sa višemetricom"

#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
msgid "No Cordwood Histories"
msgstr "Nema povijesti višemetrice"

#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx
msgid "No Cordwoods"
msgstr "Nema višemetrice"

#: src/timber/components/cutting/CuttingList/CuttingListItem.tsx
msgid "No Cuttings"
msgstr "Nema sječa"

#: src/timber/components/cutting/CuttingList/ActiveCuttings.tsx
#: src/timber/components/generic/report/ParetoChart.tsx
msgid "No data"
msgstr "Nema podataka"

#: src/timber/components/driver/DriverList/DriverListItem.tsx
#~ msgid "No Drivers"
#~ msgstr "Nema vozača"

#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListItem.tsx
msgid "No Forest Owners"
msgstr "Nema vlasnika šuma"

#: src/timber/components/history/HistoryList/HistoryListItem.tsx
msgid "No history records found"
msgstr "Nisu pronađeni povijesni podaci"

#: src/location/components/location/LocationList/LocationListItem.tsx
msgid "No Locations"
msgstr "Nema lokacija"

#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
msgid "No Log Histories"
msgstr "Nema povijesti trupca"

#: src/timber/components/log/LogList/LogListItem.tsx
msgid "No Logs"
msgstr "Nema trupaca"

#: src/timber/components/cutting/CuttingList/ActiveCuttings.tsx
msgid "No logs data"
msgstr "Nema zapisa sa trupcima"

#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListItem.tsx
msgid "No Members Group Users"
msgstr "Nema korisnika grupa članova"

#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListItem.tsx
msgid "No Members Groups"
msgstr "Nema grupa članova"

#: src/timber/components/price/PriceList/PriceListItem.tsx
msgid "No Prices"
msgstr "Nema cijena"

#: src/timber/components/pricingProfile/PricingProfileList/PricingProfileListItem.tsx
msgid "No Pricing Profiles"
msgstr "Nema cijenovnih profila"

#: src/timber/components/providerUser/ProviderUserList/ProviderUserListItem.tsx
msgid "No Provider Users"
msgstr "Nema korisnika pružatelja usluge"

#: src/timber/components/provider/ProviderList/ProviderListItem.tsx
msgid "No Providers"
msgstr "Nema pružatelja usluge"

#: src/timber/components/roadCarrier/RoadCarrierList/RoadCarrierListItem.tsx
msgid "No Road Carriers"
msgstr "Nema prijevoznika"

#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListItem.tsx
msgid "No Role Assignments"
msgstr "Nema dodijeljenih uloga"

#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListItem.tsx
msgid "No Role Permissions"
msgstr "Nema dozvola uloga"

#: src/auth/components/role/RoleList/RoleListItem.tsx
msgid "No Roles"
msgstr "Nema uloga"

#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListItem.tsx
msgid "No Scope Groups"
msgstr "Nema grupa opsega"

#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx
msgid "No Shipment Histories"
msgstr "Nema povijesti pošiljke"

#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx
msgid "No Shipments"
msgstr "Nema pošiljki"

#: src/timber/components/generic/report/GenericRootShipments.tsx
msgid "No shipments found"
msgstr "Nema pošiljki"

#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListItem.tsx
msgid "No Thickness Classes"
msgstr "Nema klasa debljine"

#: src/timber/components/timberClass/TimberClassList/TimberClassListItem.tsx
msgid "No Timber Classes"
msgstr "Nema klasa drvene građe"

#. placeholder {0}: item.ageDays
#: src/timber/components/provider/ProviderDetail/ProviderAttentionList.tsx
msgid "No timber has gone in for {0} days and the cutting was due before that."
msgstr "{0} dana nije ušla drvna masa, a sječa je trebala biti završena prije toga."

#. placeholder {0}: item.ageDays
#: src/timber/components/provider/ProviderDetail/ProviderAttentionList.tsx
msgid "No timber has gone in for {0} days."
msgstr "{0} dana nije ušla drvna masa."

#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListItem.tsx
msgid "No Timber Storages"
msgstr "Nema skladišta drvene građe"

#: src/timber/components/timberType/TimberTypeList/TimberTypeListItem.tsx
msgid "No Timber Types"
msgstr "Nema vrsta drvene građe"

#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListItem.tsx
msgid "No Tree Markings"
msgstr "Nema doznaka"

#: src/address/components/userAddress/UserAddressList/UserAddressListItem.tsx
msgid "No User Addresses"
msgstr "Nema korisničkih adresa"

#: src/auth/components/userSession/UserSessionList/UserSessionListItem.tsx
msgid "No User Sessions"
msgstr "Nema korisničkih sesija"

#: src/auth/components/user/UserList/UserListItem.tsx
msgid "No Users"
msgstr "Nema korisnika"

#: src/timber/types/models/UserType.d.ts
msgid "Normal"
msgstr "Normalan"

#: src/pages/NotFoundPage.tsx
msgid "Not Found"
msgstr "Nije pronađeno"

#: src/pages/NotFoundPage.tsx
msgid "Not Found Page"
msgstr "Stranica nije pronađena"

#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
msgid "not shipped yet"
msgstr "još nije otpremljeno"

#: src/location/components/location/LocationDetail/LocationDetail.tsx
#: src/location/components/location/LocationForm/LocationAddForm.tsx
#: src/location/components/location/LocationForm/LocationUpdateForm.tsx
msgid "Note"
msgstr "Bilješka"

#: src/timber/types/models/CordwoodMeasurementType.d.ts
msgid "npm"
msgstr "npm"

#: src/timber/components/generic/report/GenericRootReportPdfDialog.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListPdfDialog.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodShipmentReportPdfDialog.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListPdfDialog.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogShipmentReportPdfDialog.tsx
msgid "Number of copies"
msgstr "Broj kopija"

#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
msgid "of {totalCuttings} total"
msgstr "od {totalCuttings} ukupno"

#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
msgid "of the produced volume"
msgstr "od ukupno proizvedenog volumena"

#: src/share/components/dialog/PasswordDialog/PasswordDialog.tsx
#: src/share/components/form/FormDateTime/FormDate.tsx
#: src/share/components/form/FormDateTime/FormDateTime.tsx
msgid "OK"
msgstr "U redu"

#: src/pages/ChangePasswordPage.tsx
msgid "Old Password"
msgstr "Stara lozinka"

#: src/pages/ChangePasswordPage.tsx
msgid "Old password is required"
msgstr "Stara lozinka je obavezna"

#: src/pages/ChangePasswordPage.tsx
msgid "Old password must be more than 8 characters"
msgstr "Stara lozinka mora imati više od 8 znakova"

#: src/share/components/chat/ConversationList.tsx
msgid "Older"
msgstr "Starije"

#: src/share/components/chat/ChatWidget.tsx
msgid "Open AI chat"
msgstr "Otvori AI chat"

#: src/app/App.tsx
msgid "Open settings"
msgstr "Otvorite postavke"

#: src/timber/components/provider/ProviderDetail/ProviderAttentionList.tsx
msgid "Overdue"
msgstr "Kasni"

#: src/timber/components/provider/ProviderDetail/ProviderTabs.tsx
msgid "Overview"
msgstr "Pregled"

#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserAddForm.tsx
#~ msgid "Owned Members Group Id is required"
#~ msgstr "ID posjedovane grupe članova je obavezan"

#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserAddForm.tsx
msgid "Owner Member Group"
msgstr "Vlasnik grupe članova"

#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserAddForm.tsx
msgid "Owner Member Group is required"
msgstr "Vlasnik grupe članova je obavezan"

#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupAddForm.tsx
#: src/location/components/location/LocationForm/LocationAddForm.tsx
msgid "Parent"
msgstr "Roditelj"

#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupAddForm.tsx
#: src/location/components/location/LocationForm/LocationAddForm.tsx
#~ msgid "Parent Id is required"
#~ msgstr "ID roditelja je obavezan"

#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupAddForm.tsx
#: src/location/components/location/LocationForm/LocationAddForm.tsx
msgid "Parent is required"
msgstr "Roditelj je obavezan"

#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx
msgid "Parent Scope Group"
msgstr "Roditeljska grupa opsega"

#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx
#~ msgid "Parent Scope Group Id is required"
#~ msgstr "ID roditeljske grupe opsega je obavezan"

#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx
msgid "Parent Scope Group is required"
msgstr "Roditeljska grupa opsega je obavezna"

#: src/pages/LoginPage.tsx
#: src/pages/ResetPasswordPage.tsx
msgid "Password"
msgstr "Lozinka"

#: src/pages/LoginPage.tsx
#: src/pages/ResetPasswordPage.tsx
msgid "Password is required"
msgstr "Lozinka je obavezna"

#: src/pages/LoginPage.tsx
msgid "Password must be less than 32 characters"
msgstr "Lozinka mora imati manje od 32 znaka"

#: src/pages/LoginPage.tsx
#: src/pages/ResetPasswordPage.tsx
msgid "Password must be more than 8 characters"
msgstr "Lozinka mora imati više od 8 znakova"

#: src/pages/ChangePasswordPage.tsx
#: src/pages/ResetPasswordPage.tsx
msgid "Password updated successfully, login"
msgstr "Lozinka je uspješno ažurirana, prijavite se"

#: src/pages/ChangePasswordPage.tsx
#: src/pages/ResetPasswordPage.tsx
msgid "Passwords do not match"
msgstr "Lozinke se ne podudaraju"

#: src/auth/components/rolePermission/RolePermissionDetail/RolePermissionDetail.tsx
#: src/auth/components/rolePermission/RolePermissionForm/RolePermissionAddForm.tsx
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListItem.tsx
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListSearch.tsx
msgid "Permission"
msgstr "Dozvola"

#: src/auth/components/rolePermission/RolePermissionForm/RolePermissionAddForm.tsx
msgid "Permission is required"
msgstr "Dozvola je obavezna"

#: src/address/components/address/AddressDetail/AddressDetail.tsx
#: src/address/components/address/AddressForm/AddressAddForm.tsx
#: src/address/components/address/AddressForm/AddressUpdateForm.tsx
#: src/address/components/address/AddressList/AddressListItem.tsx
msgid "Phone"
msgstr "Telefon"

#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
msgid "pieces"
msgstr "komada"

#: src/share/components/dialog/DeleteDialog/DeleteDialog.tsx
#: src/share/components/dialog/PasswordDialog/PasswordDialog.tsx
msgid "Please confirm delete of the entity."
msgstr "Molimo potvrdite brisanje entiteta."

#: src/pages/ResetPasswordPage.tsx
msgid "Please confirm your password"
msgstr "Molimo potvrdite vašu lozinku"

#: src/pages/ActivationPage.tsx
msgid "Please enter a activation ocode"
msgstr "Molimo unesite aktivacijski kod"

#: src/pages/ChangePasswordPage.tsx
#: src/pages/ResetPasswordPage.tsx
msgid "Please enter a new password"
msgstr "Molimo unesite novu lozinku"

#: src/app/App.tsx
#: src/pages/PreferencesPage.tsx
msgid "Preferences"
msgstr "Postavke"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/price/PriceDetail/PriceDetail.tsx
#: src/timber/components/price/PriceForm/PriceAddForm.tsx
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx
#: src/timber/components/price/PriceList/PriceListItem.tsx
#: src/timber/pages/price/PriceEntityPage.tsx
msgid "Price"
msgstr "Cijena"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
msgid "Price [Original: {originalValue}]"
msgstr "Cijena [Orginal: {originalValue}]"

#: src/timber/hooks/usePrice.ts
msgid "Price add error: "
msgstr "Greška prilikom unosa cijene:"

#: src/timber/components/buyer/BuyerDetail/BuyerTabs.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerTabs.tsx
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/provider/ProviderDetail/ProviderTabs.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentTabs.tsx
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx
msgid "Price Calculator"
msgstr "Cijenovni kalkulator"

#: src/timber/hooks/usePrice.ts
msgid "Price delete error: "
msgstr "Greška prilikom brisanje cijene: "

#: src/timber/hooks/usePrice.ts
msgid "Price deleted"
msgstr "Cijna je obrisana"

#: src/timber/hooks/usePrice.ts
msgid "Price update error: "
msgstr "Greška prilikom promejene cijene: "

#: src/timber/hooks/usePrice.ts
msgid "Price updated"
msgstr "Cijena je promijenjena"

#: src/app/mappers.tsx
#: src/timber/components/price/PriceList/PriceListHeader.tsx
#: src/timber/components/pricingProfile/PricingProfileDetail/PricingProfileTabs.tsx
msgid "Prices"
msgstr "Cijene"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/price/PriceDetail/PriceDetail.tsx
#: src/timber/components/price/PriceForm/PriceAddForm.tsx
#: src/timber/components/pricingProfile/PricingProfileDetail/PricingProfileDetail.tsx
#: src/timber/pages/pricingProfile/PricingProfileEntityPage.tsx
msgid "Pricing Profile"
msgstr "Cijenovni profil"

#: src/timber/hooks/usePricingProfile.ts
msgid "Pricing Profile add error: "
msgstr "Greška prilikom dodavanja cijenovnog profila:"

#: src/timber/hooks/usePricingProfile.ts
msgid "Pricing Profile delete error: "
msgstr "Greška prilikom brisanja cijenovnog profila: "

#: src/timber/hooks/usePricingProfile.ts
msgid "Pricing Profile deleted"
msgstr "Cijenovni profil je obrisan"

#: src/timber/components/price/PriceForm/PriceAddForm.tsx
#~ msgid "Pricing Profile Id is required"
#~ msgstr "ID cijenovnog profila je obavezan"

#: src/timber/components/price/PriceForm/PriceAddForm.tsx
msgid "Pricing Profile is required"
msgstr "Cijenovni profil je obavezan"

#: src/timber/hooks/usePricingProfile.ts
msgid "Pricing Profile update error: "
msgstr "Greška prilikom promjene cijenovnog profila"

#: src/timber/hooks/usePricingProfile.ts
msgid "Pricing Profile updated"
msgstr "Cijenovni profil je promijenjen"

#: src/app/mappers.tsx
#: src/timber/components/pricingProfile/PricingProfileList/PricingProfileListHeader.tsx
#: src/timber/pages/listItems.tsx
msgid "Pricing Profiles"
msgstr "Cijenovni profili"

#: src/app/App.tsx
#: src/pages/LoginPage.tsx
#: src/pages/PrivacyPolicyPage.tsx
#: src/pages/TermsPage.tsx
#: src/share/components/gdpr/CookieConsent.tsx
msgid "Privacy Policy"
msgstr "Politika privatnosti"

#: src/timber/types/models/CordwoodMeasurementType.d.ts
msgid "prm"
msgstr "prm"

#: src/app/App.tsx
#: src/pages/ProfilePage.tsx
msgid "Profile"
msgstr "Profil"

#: src/pages/ProfilePage.tsx
msgid "Profile Page"
msgstr "Stranica profila"

#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/provider/ProviderDetail/ProviderDetail.tsx
#: src/timber/components/providerUser/ProviderUserDetail/ProviderUserDetail.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx
#: src/timber/pages/listItems.tsx
#: src/timber/pages/provider/ProviderEntityPage.tsx
msgid "Provider"
msgstr "Pružatelja usluge"

#: src/timber/hooks/useProvider.ts
msgid "Provider add error: "
msgstr "Greška pri dodavanju pružatelja usluge: "

#: src/timber/hooks/useProvider.ts
msgid "Provider delete error: "
msgstr "Greška pri brisanju pružatelja usluge: "

#: src/timber/hooks/useProvider.ts
msgid "Provider deleted"
msgstr "Pružatelja usluge je obrisan"

#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx
#~ msgid "Provider Id is required"
#~ msgstr "ID pružatelja usluge je obavezan"

#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx
msgid "Provider is required"
msgstr "Pružatelj usluge je obavezan"

#: src/timber/hooks/useProvider.ts
msgid "Provider update error: "
msgstr "Greška pri ažuriranju pružatelja usluge: "

#: src/timber/hooks/useProvider.ts
msgid "Provider updated"
msgstr "Pružatelja usluge je ažuriran"

#: src/timber/components/providerUser/ProviderUserDetail/ProviderUserDetail.tsx
#: src/timber/pages/providerUser/ProviderUserEntityPage.tsx
msgid "Provider User"
msgstr "Korisnik pružatelja usluge"

#: src/timber/hooks/useProviderUser.ts
msgid "Provider User add error: "
msgstr "Greška pri dodavanju korisnika pružatelja usluge: "

#: src/timber/hooks/useProviderUser.ts
msgid "Provider User delete error: "
msgstr "Greška pri brisanju korisnika pružatelja usluge: "

#: src/timber/hooks/useProviderUser.ts
msgid "Provider User deleted"
msgstr "Korisnik pružatelja usluge je obrisan"

#: src/timber/hooks/useProviderUser.ts
msgid "Provider User update error: "
msgstr "Greška pri ažuriranju korisnika pružatelja usluge: "

#: src/timber/hooks/useProviderUser.ts
msgid "Provider User updated"
msgstr "Korisnik pružatelja usluge je ažuriran"

#: src/app/mappers.tsx
#: src/auth/components/user/UserDetail/UserTabs.tsx
#: src/timber/components/provider/ProviderDetail/ProviderTabs.tsx
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListHeader.tsx
msgid "Provider Users"
msgstr "Pružateljevi korisnici"

#: src/app/mappers.tsx
#: src/timber/components/provider/ProviderList/ProviderListHeader.tsx
#: src/timber/pages/listItems.tsx
msgid "Providers"
msgstr "Pružatelji usluge"

#: src/share/components/form/FormDateTime/FormDateRange.tsx
msgid "Quick Select"
msgstr "Brza lista"

#: src/share/components/chat/serverErrors.ts
msgid "Rate limit exceeded. Please wait before sending more messages."
msgstr "Prekoračen je limit zahtjeva. Pričekajte prije slanja novih poruka."

#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListSearch.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListSearch.tsx
#: src/auth/components/role/RoleList/RoleListSearch.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListSearch.tsx
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListSearch.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListSearch.tsx
#: src/location/components/location/LocationList/LocationListSearch.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
#: src/timber/components/cutting/CuttingList/CuttingListSearch.tsx
#: src/timber/components/log/LogList/LogListSearch.tsx
#: src/timber/components/price/PriceList/PriceListSearch.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListSearch.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListSearch.tsx
msgid "Refresh"
msgstr "Osvježi"

#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx
#: src/auth/components/userSession/UserSessionForm/UserSessionUpdateForm.tsx
msgid "Refresh Token"
msgstr "Osvježavajući token"

#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx
#: src/auth/components/userSession/UserSessionForm/UserSessionUpdateForm.tsx
msgid "Refresh Token is required"
msgstr "Osvježavajući token je obavezan"

#: src/share/components/chat/ChatMessage.tsx
msgid "Regenerate reply"
msgstr "Generiraj odgovor ponovno"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx
msgid "Remove from this shipment"
msgstr "Oriši iz pošiljke"

#: src/timber/components/buyer/BuyerDetail/BuyerTabs.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentTabs.tsx
msgid "Report"
msgstr "Izvještaj"

#: src/timber/components/contractor/ContractorDetail/ContractorTabs.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerTabs.tsx
#: src/timber/components/provider/ProviderDetail/ProviderTabs.tsx
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx
msgid "Report All"
msgstr "Svi izvještaji"

#: src/timber/components/generic/report/GenericRootShipments.tsx
#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx
msgid "Report Key"
msgstr "Ključ izvješća"

#: src/timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassDetail.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx
#: src/timber/components/timberClass/TimberClassDetail/TimberClassDetail.tsx
#: src/timber/components/timberClass/TimberClassForm/TimberClassAddForm.tsx
#: src/timber/components/timberClass/TimberClassForm/TimberClassUpdateForm.tsx
#: src/timber/components/timberType/TimberTypeDetail/TimberTypeDetail.tsx
#: src/timber/components/timberType/TimberTypeForm/TimberTypeAddForm.tsx
#: src/timber/components/timberType/TimberTypeForm/TimberTypeUpdateForm.tsx
msgid "Report Name Long"
msgstr "Puni naziv izvješća"

#: src/timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassDetail.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx
#: src/timber/components/timberClass/TimberClassDetail/TimberClassDetail.tsx
#: src/timber/components/timberClass/TimberClassForm/TimberClassAddForm.tsx
#: src/timber/components/timberClass/TimberClassForm/TimberClassUpdateForm.tsx
#: src/timber/components/timberType/TimberTypeDetail/TimberTypeDetail.tsx
#: src/timber/components/timberType/TimberTypeForm/TimberTypeAddForm.tsx
#: src/timber/components/timberType/TimberTypeForm/TimberTypeUpdateForm.tsx
msgid "Report Name Short"
msgstr "Kratki naziv izvješća"

#: src/timber/components/contractor/ContractorDetail/ContractorTabs.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerTabs.tsx
#: src/timber/components/provider/ProviderDetail/ProviderTabs.tsx
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx
msgid "Report Not shipt"
msgstr "Izvještaji - nije poslano"

#: src/timber/components/contractor/ContractorDetail/ContractorTabs.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerTabs.tsx
#: src/timber/components/provider/ProviderDetail/ProviderTabs.tsx
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx
msgid "Report Shipt"
msgstr "Izvještaji - poslano"

#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx
msgid "Report TreeMarkings"
msgstr "Izvještaji sa doznakom"

#: src/app/App.tsx
#: src/pages/listItems.tsx
#: src/pages/ReportsPage.tsx
msgid "Reports"
msgstr "Izvješća"

#: src/share/components/gdpr/CookieConsent.tsx
msgid "Reset"
msgstr "Resetiraj"

#: src/auth/pages/scopeGroup/ScopeGroupDetailPage.tsx
msgid "Reset Assign"
msgstr "Resetiraj dodjelu"

#: src/pages/ResetPasswordPage.tsx
msgid "Reset Password"
msgstr "Resetiraj lozinku"

#: src/pages/ForgotPasswordPage.tsx
msgid "Retrieve Password"
msgstr "Preuzimanje lozinke"

#: src/timber/components/roadCarrier/RoadCarrierDetail/RoadCarrierDetail.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
#: src/timber/pages/roadCarrier/RoadCarrierEntityPage.tsx
msgid "Road Carrier"
msgstr "Prijevoznik"

#: src/timber/hooks/useRoadCarrier.ts
msgid "Road Carrier add error: "
msgstr "Greška prilikom dodavanja prijevoznika: "

#: src/timber/hooks/useRoadCarrier.ts
msgid "Road Carrier delete error: "
msgstr "Greška prilikom brisanja prijevoznika: "

#: src/timber/hooks/useRoadCarrier.ts
msgid "Road Carrier deleted"
msgstr "Prijevoznik je obrisan"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
#~ msgid "Road Carrier Id is required"
#~ msgstr "ID prijevoznika je obavezan"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Road Carrier is required"
msgstr "Prijevoznik je obavezan"

#: src/timber/hooks/useRoadCarrier.ts
msgid "Road Carrier update error: "
msgstr "Greška prilikom promjene prijevoznika"

#: src/timber/hooks/useRoadCarrier.ts
msgid "Road Carrier updated"
msgstr "Prijevoznik je promijenjen"

#: src/app/mappers.tsx
#: src/timber/components/roadCarrier/RoadCarrierList/RoadCarrierListHeader.tsx
#: src/timber/pages/listItems.tsx
msgid "Road Carriers"
msgstr "Prijevoznici"

#: src/auth/components/role/RoleDetail/RoleDetail.tsx
#: src/auth/components/roleAssignment/RoleAssignmentDetail/RoleAssignmentDetail.tsx
#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListItem.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListSearch.tsx
#: src/auth/components/rolePermission/RolePermissionDetail/RolePermissionDetail.tsx
#: src/auth/components/rolePermission/RolePermissionForm/RolePermissionAddForm.tsx
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListItem.tsx
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListSearch.tsx
#: src/auth/pages/role/RoleEntityPage.tsx
msgid "Role"
msgstr "Uloga"

#: src/auth/hooks/useRole.ts
msgid "Role add error: "
msgstr "Greška pri dodavanju uloge: "

#: src/auth/components/roleAssignment/RoleAssignmentDetail/RoleAssignmentDetail.tsx
#: src/auth/pages/roleAssignment/RoleAssignmentEntityPage.tsx
msgid "Role Assignment"
msgstr "Dodjela uloge"

#: src/auth/hooks/useRoleAssignment.ts
msgid "Role Assignment add error: "
msgstr "Greška pri dodavanju dodjele uloge: "

#: src/auth/hooks/useRoleAssignment.ts
msgid "Role Assignment delete error: "
msgstr "Greška pri brisanju dodjele uloge: "

#: src/auth/hooks/useRoleAssignment.ts
msgid "Role Assignment deleted"
msgstr "Dodjela uloge je obrisana"

#: src/app/mappers.tsx
#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupTabs.tsx
#: src/auth/components/role/RoleDetail/RoleTabs.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListHeader.tsx
#: src/auth/components/scopeGroup/ScopeGroupDetail/ScopeGroupTabs.tsx
msgid "Role Assignments"
msgstr "Dodjele uloga"

#: src/auth/hooks/useRole.ts
msgid "Role delete error: "
msgstr "Greška pri brisanju uloge: "

#: src/auth/hooks/useRole.ts
msgid "Role deleted"
msgstr "Uloga je obrisana"

#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx
#: src/auth/components/rolePermission/RolePermissionForm/RolePermissionAddForm.tsx
#~ msgid "Role Id is required"
#~ msgstr "ID uloge je obavezan"

#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx
#: src/auth/components/rolePermission/RolePermissionForm/RolePermissionAddForm.tsx
msgid "Role is required"
msgstr "Rola je obavezna"

#: src/auth/components/rolePermission/RolePermissionDetail/RolePermissionDetail.tsx
#: src/auth/pages/rolePermission/RolePermissionEntityPage.tsx
msgid "Role Permission"
msgstr "Dozvola uloge"

#: src/auth/hooks/useRolePermission.ts
msgid "Role Permission add error: "
msgstr "Greška pri dodavanju dozvole uloge: "

#: src/auth/hooks/useRolePermission.ts
msgid "Role Permission delete error: "
msgstr "Greška pri brisanju dozvole uloge: "

#: src/auth/hooks/useRolePermission.ts
msgid "Role Permission deleted"
msgstr "Dozvola uloge je obrisana"

#: src/app/mappers.tsx
#: src/auth/components/role/RoleDetail/RoleTabs.tsx
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListHeader.tsx
msgid "Role Permissions"
msgstr "Dozvole uloga"

#: src/auth/hooks/useRole.ts
msgid "Role update error: "
msgstr "Greška pri ažuriranju uloge: "

#: src/auth/hooks/useRole.ts
msgid "Role updated"
msgstr "Uloga je ažurirana"

#: src/app/mappers.tsx
#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupTabs.tsx
#: src/auth/components/role/RoleList/RoleListHeader.tsx
#: src/auth/pages/listItems.tsx
msgid "Roles"
msgstr "Uloge"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
msgid "Row Total"
msgstr "Total reda"

#: src/share/components/chat/ChatToolView.tsx
msgid "row(s)"
msgstr "red(ova)"

#: src/address/components/address/AddressList/AddressListPagination.tsx
#: src/address/components/userAddress/UserAddressList/UserAddressListPagination.tsx
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListPagination.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListPagination.tsx
#: src/auth/components/role/RoleList/RoleListPagination.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListPagination.tsx
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListPagination.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListPagination.tsx
#: src/auth/components/user/UserList/UserListPagination.tsx
#: src/auth/components/userSession/UserSessionList/UserSessionListPagination.tsx
#: src/location/components/location/LocationList/LocationListPagination.tsx
#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListPagination.tsx
#: src/timber/components/buyer/BuyerList/BuyerListPagination.tsx
#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListPagination.tsx
#: src/timber/components/contractor/ContractorList/ContractorListPagination.tsx
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListPagination.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListPagination.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListPagination.tsx
#: src/timber/components/cutting/CuttingList/CuttingListPagination.tsx
#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListPagination.tsx
#: src/timber/components/generic/report/GenericRootShipments.tsx
#: src/timber/components/history/HistoryList/HistoryListPagination.tsx
#: src/timber/components/log/LogList/LogListPagination.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListPagination.tsx
#: src/timber/components/price/PriceList/PriceListPagination.tsx
#: src/timber/components/pricingProfile/PricingProfileList/PricingProfileListPagination.tsx
#: src/timber/components/provider/ProviderList/ProviderListPagination.tsx
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListPagination.tsx
#: src/timber/components/roadCarrier/RoadCarrierList/RoadCarrierListPagination.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListPagination.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListPagination.tsx
#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListPagination.tsx
#: src/timber/components/timberClass/TimberClassList/TimberClassListPagination.tsx
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListPagination.tsx
#: src/timber/components/timberType/TimberTypeList/TimberTypeListPagination.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListPagination.tsx
msgid "rows per page"
msgstr "redaka po stranici"

#: src/share/components/chat/ChatMessage.tsx
msgid "Running {runningTool}…"
msgstr "Izvodi se {runningTool}…"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
msgid "Save"
msgstr "Pohrani"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
msgid "Save as new profile"
msgstr "Pohrani kao novi profil"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
msgid "Save changes to selected profile"
msgstr "Pohrani promjene u odabrani profil"

#: src/auth/components/role/RoleDetail/RoleDetail.tsx
#: src/auth/components/role/RoleForm/RoleAddForm.tsx
#: src/auth/components/role/RoleForm/RoleUpdateForm.tsx
#: src/auth/components/role/RoleList/RoleListItem.tsx
#: src/auth/components/role/RoleList/RoleListSearch.tsx
msgid "Scope"
msgstr "Opseg"

#: src/auth/components/roleAssignment/RoleAssignmentDetail/RoleAssignmentDetail.tsx
#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListItem.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListSearch.tsx
#: src/auth/components/scopeGroup/ScopeGroupDetail/ScopeGroupDetail.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListItem.tsx
#: src/auth/pages/scopeGroup/ScopeGroupEntityPage.tsx
msgid "Scope Group"
msgstr "Grupa opsega"

#: src/auth/hooks/useScopeGroup.ts
msgid "Scope Group add error: "
msgstr "Greška pri dodavanju grupe opsega: "

#: src/auth/components/scopeGroup/ScopeGroupDetail/ScopeGroupDetail.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupUpdateForm.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListItem.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListSearch.tsx
msgid "Scope Group Context"
msgstr "Kontekst grupe opsega"

#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupUpdateForm.tsx
msgid "Scope Group Context is required"
msgstr "Kontekst grupe opsega je obavezan"

#: src/auth/hooks/useScopeGroup.ts
msgid "Scope Group delete error: "
msgstr "Greška pri brisanju grupe opsega: "

#: src/auth/hooks/useScopeGroup.ts
msgid "Scope Group deleted"
msgstr "Grupa opsega je obrisana"

#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx
#~ msgid "Scope Group Id is required"
#~ msgstr "ID grupe opsega je obavezan"

#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx
msgid "Scope Group is required"
msgstr "Grupe opsega je obavezna"

#: src/auth/hooks/useScopeGroup.ts
msgid "Scope Group update error: "
msgstr "Greška pri ažuriranju grupe opsega: "

#: src/auth/hooks/useScopeGroup.ts
msgid "Scope Group updated"
msgstr "Grupa opsega je ažurirana"

#: src/app/mappers.tsx
#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupTabs.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListHeader.tsx
#: src/auth/pages/listItems.tsx
msgid "Scope Groups"
msgstr "Grupe opsega"

#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListSearch.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListSearch.tsx
#: src/auth/components/role/RoleList/RoleListSearch.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListSearch.tsx
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListSearch.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListSearch.tsx
#: src/location/components/location/LocationList/LocationListSearch.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
#: src/timber/components/cutting/CuttingList/CuttingListSearch.tsx
#: src/timber/components/log/LogList/LogListSearch.tsx
#: src/timber/components/price/PriceList/PriceListSearch.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListSearch.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListSearch.tsx
msgid "Search"
msgstr "Pretraga"

#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListSearch.tsx
#~ msgid "Search (by Cordwood Id, Action)"
#~ msgstr "Pretraga (po ID Višemetrice, Akciji)"

#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListSearch.tsx
msgid "Search (by Cordwood, Action)"
msgstr "Pretraga (po visemtrici, akciji)"

#: src/address/components/address/AddressList/AddressListSearch.tsx
msgid "Search (by Email, Address, City)"
msgstr "Pretraga (po Emailu, Adresi, Gradu)"

#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListSearch.tsx
#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListSearch.tsx
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListSearch.tsx
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListSearch.tsx
msgid "Search (by Email, Name)"
msgstr "Pretraga (po Emailu, Imenu)"

#: src/auth/components/user/UserList/UserListSearch.tsx
msgid "Search (by Email)"
msgstr "Pretraga (po Emailu)"

#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListSearch.tsx
#: src/location/components/location/LocationList/LocationListSearch.tsx
msgid "Search (by Hierarchy Name)"
msgstr "Pretraga (po Nazivu hijerarhije)"

#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx
msgid "Search (by Key, Report Key, Shipment At)"
msgstr "Pretraga (po Ključu, Ključu izvješća, Datum slanja)"

#: src/timber/components/logHistory/LogHistoryList/LogHistoryListSearch.tsx
#~ msgid "Search (by Log Id, Action)"
#~ msgstr "Pretraga (po ID trupca, Akciji)"

#: src/timber/components/logHistory/LogHistoryList/LogHistoryListSearch.tsx
msgid "Search (by Log, Action)"
msgstr "Pretraga (po stablu, akciji)"

#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListSearch.tsx
msgid "Search (by Member Group, Owner Member Group)"
msgstr "Pretraga (po grupi članova, vlasniku grupe članova)"

#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListSearch.tsx
msgid "Search (by Member Group, Role)"
msgstr "Pretraga (po grupi članova, roli)"

#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListSearch.tsx
#~ msgid "Search (by Members Group Id, Owned Members Group Id)"
#~ msgstr "Pretraga (po ID grupe članova, ID posjedovane grupe članova)"

#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListSearch.tsx
#~ msgid "Search (by Members Group Id, Role Id)"
#~ msgstr "Pretraga (po ID grupe članova, ID uloge)"

#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListSearch.tsx
#~ msgid "Search (by Name, Class Id)"
#~ msgstr "Pretraga (po Imenu, ID klase)"

#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListSearch.tsx
msgid "Search (by Name, Timber Class)"
msgstr "Pretraga (po nazivu, klasi)"

#: src/auth/components/role/RoleList/RoleListSearch.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListSearch.tsx
#: src/timber/components/buyer/BuyerList/BuyerListSearch.tsx
#: src/timber/components/contractor/ContractorList/ContractorListSearch.tsx
#: src/timber/components/cutting/CuttingList/CuttingListSearch.tsx
#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListSearch.tsx
#: src/timber/components/pricingProfile/PricingProfileList/PricingProfileListSearch.tsx
#: src/timber/components/provider/ProviderList/ProviderListSearch.tsx
#: src/timber/components/roadCarrier/RoadCarrierList/RoadCarrierListSearch.tsx
#: src/timber/components/timberClass/TimberClassList/TimberClassListSearch.tsx
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListSearch.tsx
#: src/timber/components/timberType/TimberTypeList/TimberTypeListSearch.tsx
msgid "Search (by Name)"
msgstr "Pretraga (po Imenu)"

#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListSearch.tsx
#~ msgid "Search (by Role Id, Permission)"
#~ msgstr "Pretraga (po ID uloge, Dozvoli)"

#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListSearch.tsx
msgid "Search (by Role, Permission)"
msgstr "Pretraga (po roli, dozvolama)"

#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListSearch.tsx
#~ msgid "Search (by Shipment Id, Action)"
#~ msgstr "Pretraga (po ID pošiljke, akcije)"

#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListSearch.tsx
msgid "Search (by Shipment, Action)"
msgstr "Pretraga (po pošiljci, akciji)"

#: src/timber/components/log/LogList/LogListSearch.tsx
msgid "Search (by Timber Key, External Key, IK)"
msgstr "Pretraga (po Ključu drva, Vanjskom ključu, IK)"

#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
msgid "Search (by Timber Key, IK)"
msgstr "Pretraga (po Ključu drva, IK)"

#: src/timber/components/price/PriceList/PriceListSearch.tsx
#~ msgid "Search (by Timber Type Id, Class Id, Thickness Class Id)"
#~ msgstr "Pretraga (tipu drva, po klasa, debljinski rayred)"

#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListSearch.tsx
#~ msgid "Search (by Timber Type Id, Volume (m&#xB3;))"
#~ msgstr "Pretraga (po Ključu tips drva, volumenu)"

#: src/timber/components/price/PriceList/PriceListSearch.tsx
msgid "Search (by Timber Type, Timber Class, Thickness Class)"
msgstr "Pretraga (tipu drva, po klasi, debljinskom razredu)"

#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListSearch.tsx
msgid "Search (by Timber Type, Volume (m&#xB3;))"
msgstr "Pretraga (po Tipu drva, volumenu)"

#: src/address/components/userAddress/UserAddressList/UserAddressListSearch.tsx
#~ msgid "Search (by User Id, Address Id)"
#~ msgstr "Pretraga (po ID korisnika, ID adrese)"

#: src/auth/components/userSession/UserSessionList/UserSessionListSearch.tsx
#~ msgid "Search (by User Id)"
#~ msgstr "Pretraga (po ID korisnika)"

#: src/address/components/userAddress/UserAddressList/UserAddressListSearch.tsx
msgid "Search (by User, Address)"
msgstr "Pretraga (po korisniku, adresi)"

#: src/auth/components/userSession/UserSessionList/UserSessionListSearch.tsx
msgid "Search (by User)"
msgstr "Pretraga (po korisniku)"

#: src/share/components/chat/ConversationList.tsx
msgid "Search history..."
msgstr "Pretraži povijest..."

#: src/share/components/gdpr/CookieConsent.tsx
msgid "See our"
msgstr "Pogledajte naše"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx
msgid "Select cordwood to shipment"
msgstr "Odaberite višemetricu za pošiljku"

#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
msgid "Select log for shipment"
msgstr "Odaberite trupac za pošiljku"

#: src/timber/components/shipment/ShipmentRegulator/LogShipmentUpload.tsx
msgid "Select shipment CSV file"
msgstr "Odaberite CSV datoteku pošiljke"

#: src/share/components/scope/ScopeSwitcher.tsx
msgid "Selected Group"
msgstr "Odabrana grupa"

#: src/share/components/chat/ChatMessage.tsx
msgid "Send"
msgstr "Pošalji"

#: src/share/components/chat/ChatInput.tsx
msgid "Send message"
msgstr "Pošalji poruku"

#. placeholder {0}: response.status
#: src/share/components/chat/useChat.ts
msgid "Server error: {0}"
msgstr "Greška poslužitelja: {0}"

#: src/timber/components/provider/ProviderDetail/ProviderSplitTab.tsx
msgid "Share"
msgstr "Udio"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/log/LogList/LogListSearch.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryAddForm.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx
#: src/timber/pages/shipment/ShipmentEntityPage.tsx
#: src/timber/types/models/MergedHistory.ts
msgid "Shipment"
msgstr "Pošiljka"

#: src/timber/hooks/useShipment.ts
msgid "Shipment add error: "
msgstr "Greška pri dodavanju pošiljke: "

#: src/timber/components/generic/report/GenericRootShipments.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx
msgid "Shipment At"
msgstr "Datum pošiljke"

#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx
msgid "Shipment At From"
msgstr "Pošiljka od datuma"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Shipment at is required"
msgstr "Vrijeme pošiljke je obavezno"

#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx
msgid "Shipment At To"
msgstr "Pošiljka do datuma"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx
msgid "Shipment Cordwood"
msgstr "Pošiljka višemetrice"

#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListItem.tsx
msgid "Shipment Cordwood Code"
msgstr "Kod pošiljke višemetrice"

#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx
msgid "Shipment Cordwood Code is required"
msgstr "Kod pošiljke višemetrica je obavezan"

#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx
msgid "Shipment Cordwood Counter"
msgstr "Brojač pošiljke višemetrice"

#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx
msgid "Shipment Cordwood Counter is required"
msgstr "Brojač pošiljke višemetrice je obavezan"

#: src/timber/hooks/useShipment.ts
msgid "Shipment delete error: "
msgstr "Greška pri brisanju pošiljke: "

#: src/timber/hooks/useShipment.ts
msgid "Shipment deleted"
msgstr "Pošiljka je obrisana"

#: src/app/mappers.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentTabs.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListHeader.tsx
msgid "Shipment Histories"
msgstr "Povijest pošiljki"

#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx
#: src/timber/pages/shipmentHistory/ShipmentHistoryEntityPage.tsx
msgid "Shipment History"
msgstr "Povijest pošiljke"

#: src/timber/hooks/useShipmentHistory.ts
msgid "Shipment History add error: "
msgstr "Greška pri dodavanju povijesti pošiljke: "

#: src/timber/hooks/useShipmentHistory.ts
msgid "Shipment History delete error: "
msgstr "Greška pri brisanju povijesti pošiljke: "

#: src/timber/hooks/useShipmentHistory.ts
msgid "Shipment History deleted"
msgstr "Povijesti pošiljke je obrisana"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryAddForm.tsx
#~ msgid "Shipment Id is required"
#~ msgstr "ID pošiljke je obavezan"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryAddForm.tsx
msgid "Shipment is required"
msgstr "Pošiljka je obavezna"

#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListItem.tsx
msgid "Shipment Log Code"
msgstr "Kod pošiljke trupaca"

#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx
msgid "Shipment Log Code is required"
msgstr "Kod pošiljke trupaca je obavezan"

#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx
msgid "Shipment Log Counter"
msgstr "Brojač pošiljke trupaca"

#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx
msgid "Shipment Log Counter is required"
msgstr "Brojač pošiljke trupaca je obavezann"

#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
msgid "Shipment Logs"
msgstr "Pošiljka trupaca"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Shipment Order"
msgstr "Nalog pošiljke"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootReport.tsx
#: src/timber/components/generic/report/TimelineRootReport.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx
msgid "Shipment Type"
msgstr "Tip pošiljke"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
msgid "Shipment Type is required"
msgstr "Tip pošiljke je obavezan"

#: src/timber/hooks/useShipment.ts
msgid "Shipment update error: "
msgstr "Greška pri ažuriranju pošiljke: "

#: src/timber/hooks/useShipment.ts
msgid "Shipment updated"
msgstr "Pošiljka je ažurirana"

#: src/app/mappers.tsx
#: src/location/components/location/LocationDetail/LocationTabs.tsx
#: src/timber/components/buyer/BuyerDetail/BuyerTabs.tsx
#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserTabs.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx
#: src/timber/components/history/HistoryList/HistoryListSearch.tsx
#: src/timber/components/roadCarrier/RoadCarrierDetail/RoadCarrierTabs.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListHeader.tsx
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx
msgid "Shipments"
msgstr "Pošiljke"

#: src/timber/components/provider/ProviderDetail/ProviderAttentionList.tsx
msgid "Shipments that should have gone out"
msgstr "Pošiljke koje su trebale otići"

#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
#: src/timber/components/provider/ProviderList/ProviderListItem.tsx
msgid "Shipped"
msgstr "Otpremljeno"

#. placeholder {0}: fixedFormat(cordwoodShippedVolume)
#. placeholder {0}: fixedFormat(logsShippedVolume)
#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
msgid "shipped {0}"
msgstr "otpremljeno {0}"

#: src/timber/components/provider/ProviderDetail/ProviderOverviewTab.tsx
msgid "Shipped and stored volume"
msgstr "Otpremljeni i uskladišteni volumen"

#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
msgid "Shipped volume (m³)"
msgstr "Otpremljeni volumen (m³)"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
msgid "Shipping Contractor User"
msgstr "Korisnik izvođača pošiljke"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#~ msgid "Shipping Contractor User Id is required"
#~ msgstr "ID korisnika izvođača pošiljke je obavezan"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
msgid "Shipping Contractor User is required"
msgstr "Korisnik izvođača pošiljke je obavezan"

#. placeholder {0}: data.total
#: src/timber/components/provider/ProviderDetail/ProviderAttentionList.tsx
msgid "Show all {0}"
msgstr "Prikaži svih {0}"

#: src/share/components/chat/ChatWidget.tsx
msgid "Show history"
msgstr "Prikaži povijest"

#: src/share/components/chat/ChatThread.tsx
msgid "Show the last 10 logs"
msgstr "Prikaži posljednjih 10 logova"

#: src/share/components/chat/ChatThread.tsx
msgid "Show the last 10 shipments"
msgstr "Prikaži posljednjih 10 otprema"

#: src/share/components/chat/ChatThread.tsx
#~ msgid "Show the latest shipments"
#~ msgstr "Prikaži najnovije otpreme"

#. placeholder {0}: data.items.length
#. placeholder {1}: data.total
#: src/timber/components/provider/ProviderDetail/ProviderAttentionList.tsx
msgid "showing the {0} worst of {1}"
msgstr "prikazano najgore {0} od {1}"

#: src/pages/DashboardHomePage.tsx
msgid "Sign in to see the state of the timber."
msgstr "Prijavite se da biste vidjeli stanje drvne mase."

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Source Location"
msgstr "Početna lokacija"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
#~ msgid "Source Location Id is required"
#~ msgstr "Lokacija je obavezna"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Source Location is required"
msgstr "Početna lokacija je obevezna"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Source Parcel"
msgstr "Čestica"

#: src/timber/components/provider/ProviderDetail/ProviderTabs.tsx
msgid "Split"
msgstr "Raspodjela"

#: src/share/components/chat/ChatThread.tsx
msgid "Start a conversation with the AI assistant"
msgstr "Započnite razgovor s AI pomoćnikom"

#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
#: src/timber/components/cutting/CuttingList/CuttingListItem.tsx
msgid "Start At"
msgstr "Početak"

#: src/timber/components/cutting/CuttingList/CuttingListSearch.tsx
msgid "Start At From"
msgstr "Početak od"

#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
msgid "Start At is required"
msgstr "Početak je obavezan"

#: src/timber/components/cutting/CuttingList/CuttingListSearch.tsx
msgid "Start At To"
msgstr "Početak do"

#: src/share/components/form/FormDateTime/FormDateRange.tsx
msgid "Start Date"
msgstr "Početni datum"

#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryAddForm.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
#: src/timber/components/cutting/CuttingList/CuttingListItem.tsx
#: src/timber/components/cutting/CuttingList/CuttingListSearch.tsx
#: src/timber/components/generic/report/GenericRootShipments.tsx
#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryAddForm.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx
msgid "State"
msgstr "Stanje"

#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "State is required"
msgstr "Stanje je obavezno"

#: src/share/components/chat/ChatInput.tsx
msgid "Stop generating"
msgstr "Prekini generiranje"

#: src/share/components/chat/ChatMessage.tsx
msgid "stopped"
msgstr "zaustavljeno"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootReport.tsx
#: src/timber/components/generic/report/GenericRootTable.tsx
#: src/timber/components/generic/report/TimelineRootReport.tsx
#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddForm.tsx
msgid "Storage"
msgstr "Skladište"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddForm.tsx
#~ msgid "Storage Id is required"
#~ msgstr "ID skladišta je obavezan"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddForm.tsx
msgid "Storage is required"
msgstr "Skladište je obavezno"

#: src/share/components/chat/useChat.ts
msgid "Streaming is not supported by this browser."
msgstr "Ovaj preglednik ne podržava streaming."

#: src/timber/components/shipment/ShipmentRegulator/LogShipmentUpload.tsx
msgid "Submit"
msgstr "Pošalji"

#: src/share/components/alert/DescriptionAlert/useDescriptionAlert.ts
msgid "Success"
msgstr "Uspjeh"

#: src/app/App.tsx
msgid "Swagger UI"
msgstr "Swagger UI"

#: src/timber/components/buyer/BuyerDetail/BuyerDetail.tsx
#: src/timber/components/buyer/BuyerForm/BuyerAddForm.tsx
#: src/timber/components/buyer/BuyerForm/BuyerUpdateForm.tsx
#: src/timber/components/contractor/ContractorDetail/ContractorDetail.tsx
#: src/timber/components/contractor/ContractorForm/ContractorAddForm.tsx
#: src/timber/components/contractor/ContractorForm/ContractorUpdateForm.tsx
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerDetail.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerAddForm.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerUpdateForm.tsx
#: src/timber/components/provider/ProviderDetail/ProviderDetail.tsx
#: src/timber/components/provider/ProviderForm/ProviderAddForm.tsx
#: src/timber/components/provider/ProviderForm/ProviderUpdateForm.tsx
msgid "Swift"
msgstr "Swift"

#: src/pages/PreferencesPage.tsx
msgid "System"
msgstr "Sustav"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Target Address"
msgstr "Adresa skladišta"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Target City"
msgstr "Grad skladišta"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Target Country"
msgstr "Država skladišta"

#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx
msgid "TC"
msgstr "TC"

#: src/app/App.tsx
#: src/pages/LoginPage.tsx
msgid "Terms"
msgstr "uvjete"

#: src/pages/PrivacyPolicyPage.tsx
#: src/pages/TermsPage.tsx
msgid "Terms of Service"
msgstr "Uvjeti usluge"

#: src/share/components/chat/serverErrors.ts
msgid "The assistant asked for a tool that does not exist."
msgstr "Pomoćnik je zatražio alat koji ne postoji."

#: src/pages/DashboardHomePage.tsx
msgid "The provider of this account could not be loaded."
msgstr "Pružatelj ovog računa nije mogao biti učitan."

#: src/share/components/chat/serverErrors.ts
msgid "The reply used every available tool call. Please ask a more specific question."
msgstr "Odgovor je iskoristio sve dostupne pozive alata. Postavite preciznije pitanje."

#: src/pages/TermsPage.tsx
msgid "The service is provided “as is”. We may modify these terms from time to time. Continued use constitutes acceptance of the updated terms."
msgstr "Usluga se pruža “kakva jest”. Ove uvjete možemo povremeno mijenjati. Nastavak korištenja predstavlja prihvaćanje ažuriranih uvjeta."

#. placeholder {0}: item.ageDays
#: src/timber/components/provider/ProviderDetail/ProviderAttentionList.tsx
msgid "The shipment was due {0} days ago."
msgstr "Pošiljka je trebala otići prije {0} dana."

#: src/timber/components/provider/ProviderDetail/ProviderSplitTab.tsx
msgid "The split could not be loaded."
msgstr "Raspodjela se nije mogla učitati."

#: src/pages/PreferencesPage.tsx
msgid "Theme"
msgstr "Tema"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootTable.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/log/LogList/LogListSearch.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
#: src/timber/components/price/PriceDetail/PriceDetail.tsx
#: src/timber/components/price/PriceForm/PriceAddForm.tsx
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx
#: src/timber/components/price/PriceList/PriceListItem.tsx
#: src/timber/components/price/PriceList/PriceListSearch.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx
#: src/timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassDetail.tsx
#: src/timber/pages/thicknessClass/ThicknessClassEntityPage.tsx
msgid "Thickness Class"
msgstr "Klasa debljine"

#: src/timber/hooks/useThicknessClass.ts
msgid "Thickness Class add error: "
msgstr "Greška pri dodavanju klase debljine: "

#: src/timber/hooks/useThicknessClass.ts
msgid "Thickness Class delete error: "
msgstr "Greška pri brisanju klase debljine: "

#: src/timber/hooks/useThicknessClass.ts
msgid "Thickness Class deleted"
msgstr "Klasa debljine je obrisana"

#: src/timber/components/price/PriceForm/PriceAddForm.tsx
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx
#~ msgid "Thickness Class Id is required"
#~ msgstr "Debljinski razred je obavezan"

#: src/timber/components/price/PriceForm/PriceAddForm.tsx
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx
msgid "Thickness Class is required"
msgstr "Debljinski razred je obavezan"

#: src/timber/hooks/useThicknessClass.ts
msgid "Thickness Class update error: "
msgstr "Greška pri ažuriranju klase debljine: "

#: src/timber/hooks/useThicknessClass.ts
msgid "Thickness Class updated"
msgstr "Klasa debljine je ažurirana"

#: src/app/mappers.tsx
#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListHeader.tsx
#: src/timber/pages/listItems.tsx
msgid "Thickness Classes"
msgstr "Klase debljine"

#: src/share/components/chat/ChatThread.tsx
msgid "Thinking..."
msgstr "Razmišljam..."

#: src/share/components/chat/ChatMessage.tsx
msgid "Thinking…"
msgstr "Razmišljam…"

#: src/share/components/form/FormDateTime/FormDateRange.tsx
msgid "This Month"
msgstr "Ovaj mjesec"

#: src/timber/components/provider/ProviderDetail/ProviderOverviewTab.tsx
#~ msgid "This provider has more cuttings than fit on one page, so the volumes below are only a part of the whole."
#~ msgstr "Ovaj pružatelj ima više sječa nego što stane na jednu stranicu, pa su donji volumeni samo dio cjeline."

#: src/timber/components/provider/ProviderDetail/ProviderOverviewTab.tsx
msgid "This provider has no cuttings yet."
msgstr "Ovaj pružatelj još nema sječa."

#: src/share/components/chat/ChatMessage.tsx
msgid "This reply was cut short. The text is all that was received."
msgstr "Ovaj je odgovor prekinut. Tekst je sve što je primljeno."

#: src/share/components/form/FormDateTime/FormDateRange.tsx
msgid "This Week"
msgstr "Ovaj tjedan"

#: src/share/components/form/FormDateTime/FormDateRange.tsx
msgid "This Year"
msgstr "Ova godina"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootReport.tsx
#: src/timber/components/generic/report/TimelineRootReport.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/log/LogList/LogListSearch.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
#: src/timber/components/price/PriceDetail/PriceDetail.tsx
#: src/timber/components/price/PriceForm/PriceAddForm.tsx
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx
#: src/timber/components/price/PriceList/PriceListItem.tsx
#: src/timber/components/price/PriceList/PriceListSearch.tsx
#: src/timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassDetail.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListItem.tsx
#: src/timber/components/timberClass/TimberClassDetail/TimberClassDetail.tsx
#: src/timber/pages/timberClass/TimberClassEntityPage.tsx
msgid "Timber Class"
msgstr "Klasa drva"

#: src/timber/hooks/useTimberClass.ts
msgid "Timber Class add error: "
msgstr "Greška pri dodavanju klase drva: "

#: src/timber/hooks/useTimberClass.ts
msgid "Timber Class delete error: "
msgstr "Greška pri brisanju klase drva: "

#: src/timber/hooks/useTimberClass.ts
msgid "Timber Class deleted"
msgstr "Klasa drva je obrisana"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/price/PriceForm/PriceAddForm.tsx
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx
msgid "Timber Class is required"
msgstr "Klasa drva je obavezna"

#: src/timber/hooks/useTimberClass.ts
msgid "Timber Class update error: "
msgstr "Greška pri ažuriranju klase drva: "

#: src/timber/hooks/useTimberClass.ts
msgid "Timber Class updated"
msgstr "Klasa drva je ažurirana"

#: src/app/mappers.tsx
#: src/timber/components/timberClass/TimberClassList/TimberClassListHeader.tsx
#: src/timber/pages/listItems.tsx
msgid "Timber Classes"
msgstr "Klase drva"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/log/LogList/LogListSearch.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemFromHistory.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx
msgid "Timber Key"
msgstr "Ključ drva"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
msgid "Timber Key is required"
msgstr "Ključ drva je obavezan"

#: src/timber/components/provider/ProviderDetail/ProviderAttentionList.tsx
msgid "Timber standing in the storages"
msgstr "Drvna masa koja stoji u skladištima"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
#: src/timber/components/generic/report/GenericRootShipments.tsx
#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
#: src/timber/components/history/HistoryList/HistoryListSearch.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageDetail.tsx
#: src/timber/components/treeMarking/TreeMarkingDetail/TreeMarkingDetail.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListItem.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListSearch.tsx
#: src/timber/pages/timberStorage/TimberStorageEntityPage.tsx
msgid "Timber Storage"
msgstr "Skladište drva"

#: src/timber/hooks/useTimberStorage.ts
msgid "Timber Storage add error: "
msgstr "Greška pri dodavanju skladišta drva: "

#: src/timber/hooks/useTimberStorage.ts
msgid "Timber Storage delete error: "
msgstr "Greška pri brisanju skladišta drva: "

#: src/timber/hooks/useTimberStorage.ts
msgid "Timber Storage deleted"
msgstr "Skladište drva je obrisano"

#: src/timber/hooks/useTimberStorage.ts
msgid "Timber Storage update error: "
msgstr "Greška pri ažuriranju skladišta drva: "

#: src/timber/hooks/useTimberStorage.ts
msgid "Timber Storage updated"
msgstr "Skladište drva je ažurirano"

#: src/app/mappers.tsx
#: src/location/components/location/LocationDetail/LocationTabs.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerTabs.tsx
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListHeader.tsx
msgid "Timber Storages"
msgstr "Skladišta drva"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootReport.tsx
#: src/timber/components/generic/report/TimelineRootReport.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/log/LogList/LogListSearch.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
#: src/timber/components/price/PriceDetail/PriceDetail.tsx
#: src/timber/components/price/PriceForm/PriceAddForm.tsx
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx
#: src/timber/components/price/PriceList/PriceListItem.tsx
#: src/timber/components/price/PriceList/PriceListSearch.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemFromHistory.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx
#: src/timber/components/timberType/TimberTypeDetail/TimberTypeDetail.tsx
#: src/timber/components/treeMarking/TreeMarkingDetail/TreeMarkingDetail.tsx
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddForm.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListItem.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListSearch.tsx
#: src/timber/pages/timberType/TimberTypeEntityPage.tsx
msgid "Timber Type"
msgstr "Vrsta drva"

#: src/timber/hooks/useTimberType.ts
msgid "Timber Type add error: "
msgstr "Greška pri dodavanju vrste drva: "

#: src/timber/hooks/useTimberType.ts
msgid "Timber Type delete error: "
msgstr "Greška pri brisanju vrste drva: "

#: src/timber/hooks/useTimberType.ts
msgid "Timber Type deleted"
msgstr "Vrsta drva je obrisana"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/price/PriceForm/PriceAddForm.tsx
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddForm.tsx
#~ msgid "Timber Type Id is required"
#~ msgstr "ID vrste drva je obavezan"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/log/LogForm/LogAddForm.tsx
#: src/timber/components/log/LogForm/LogUpdateForm.tsx
#: src/timber/components/price/PriceForm/PriceAddForm.tsx
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddForm.tsx
msgid "Timber Type is required"
msgstr "Vrsta drva je obavezna"

#: src/timber/hooks/useTimberType.ts
msgid "Timber Type update error: "
msgstr "Greška pri ažuriranju vrste drva: "

#: src/timber/hooks/useTimberType.ts
msgid "Timber Type updated"
msgstr "Vrsta drva je ažurirana"

#: src/app/mappers.tsx
#: src/timber/components/timberType/TimberTypeList/TimberTypeListHeader.tsx
#: src/timber/pages/listItems.tsx
msgid "Timber Types"
msgstr "Vrste drva"

#: src/timber/components/provider/ProviderDetail/ProviderSummaryCards.tsx
msgid "Timber volume (m³)"
msgstr "Ukupni volumen (m³)"

#: src/pages/DashboardHomePage.tsx
#: src/timber/pages/listItems.tsx
msgid "Timberstorage"
msgstr "Timberstorage"

#: src/timber/components/contractor/ContractorDetail/ContractorTabs.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx
#: src/timber/components/generic/report/TimelineRootReport.tsx
#: src/timber/components/provider/ProviderDetail/ProviderTabs.tsx
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx
msgid "Timeline Report"
msgstr "Vremensko izvješće"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootReport.tsx
#: src/timber/components/generic/report/TimelineRootReport.tsx
#~ msgid "To Input Date"
#~ msgstr "Do datuma unosa"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootReport.tsx
#: src/timber/components/generic/report/TimelineRootReport.tsx
msgid "To Shipment Date"
msgstr "Do datuma pošiljke"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootReport.tsx
#: src/timber/components/generic/report/TimelineRootReport.tsx
msgid "To Timber Input Date"
msgstr "Do datuma unosa drva"

#: src/share/components/chat/ConversationList.tsx
#: src/share/components/form/FormDateTime/FormDateRange.tsx
msgid "Today"
msgstr "Danas"

#: src/share/components/chat/ChatToolView.tsx
msgid "Tool result"
msgstr "Rezultat alata"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootTable.tsx
#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx
msgid "Total"
msgstr "Ukupno"

#. placeholder {0}: fixedFormat(data.reduce((acc, row) => acc + row.volume, 0))
#: src/timber/components/generic/report/ParetoChart.tsx
#~ msgid "Total {0} m³"
#~ msgstr ""

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootTable.tsx
msgid "Total class and type"
msgstr "Ukupno u klasi i vrsti"

#: src/timber/components/generic/report/GenericRootShipments.tsx
msgid "Total Logs"
msgstr "Ukupno trupaca"

#: src/timber/components/generic/report/GenericRootTable.tsx
msgid "Total on cutting"
msgstr "Ukupno na sječi"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootTable.tsx
msgid "Total on storage"
msgstr "Ukupno na skladištu"

#: src/timber/components/generic/report/GenericRootShipments.tsx
msgid "Total Shipments"
msgstr "Ukupno pošiljki"

#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx
msgid "Total volume"
msgstr "Ukupni volumen"

#: src/timber/components/generic/report/GenericRootShipments.tsx
msgid "Total Volume"
msgstr "Ukupni volumen"

#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx
#: src/timber/components/treeMarking/TreeMarkingDetail/TreeMarkingDetail.tsx
#: src/timber/pages/treeMarking/TreeMarkingEntityPage.tsx
msgid "Tree Marking"
msgstr "Doznaka"

#: src/timber/hooks/useTreeMarking.ts
msgid "Tree Marking add error: "
msgstr "Pogreška pri dodavanju doznake:"

#: src/timber/hooks/useTreeMarking.ts
msgid "Tree Marking delete error: "
msgstr "Pogreška pri brisanju doznake:"

#: src/timber/hooks/useTreeMarking.ts
msgid "Tree Marking deleted"
msgstr "Doznaka je obrisana"

#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx
msgid "Tree Marking Report"
msgstr "Resport s doznakom"

#: src/timber/hooks/useTreeMarking.ts
msgid "Tree Marking update error: "
msgstr "Pogreška ažuriranja doznake:"

#: src/timber/hooks/useTreeMarking.ts
msgid "Tree Marking updated"
msgstr "Doznaka je ažurirarana"

#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx
msgid "Tree Marking volume"
msgstr "Volumen doznake"

#: src/app/mappers.tsx
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListHeader.tsx
msgid "Tree Markings"
msgstr "Doznake"

#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx
msgid "Tree Markings Report"
msgstr "Resport s doznakama"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Truck Registration Number"
msgstr "Registracijski broj kamiona"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Trucker Name"
msgstr "Ime vozača"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Trucker name at is required"
msgstr "Ime vozača je obavezno"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootTable.tsx
#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx
#: src/timber/components/history/HistoryList/HistoryListItem.tsx
msgid "Type"
msgstr "Vrsta"

#: src/share/components/chat/ChatInput.tsx
msgid "Type a message..."
msgstr "Upišite poruku..."

#: src/pages/UnauthorizedPage.tsx
msgid "Unauthorized"
msgstr "Neovlašteno"

#: src/pages/UnauthorizedPage.tsx
msgid "Unauthorized Page"
msgstr "Neovlaštena Stranica"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
msgid "Unmatched rows"
msgstr "Nepodudarni redovi"

#: src/timber/types/models/CuttingState.d.ts
#: src/timber/types/models/ShipmentState.d.ts
msgid "Upcoming"
msgstr "U pripremi"

#: src/address/components/address/AddressForm/AddressUpdateFormProvider.tsx
#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupUpdateFormProvider.tsx
#: src/auth/components/role/RoleForm/RoleUpdateFormProvider.tsx
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupUpdateFormProvider.tsx
#: src/auth/components/user/UserForm/UserUpdateFormProvider.tsx
#: src/auth/components/userSession/UserSessionForm/UserSessionUpdateFormProvider.tsx
#: src/location/components/location/LocationForm/LocationUpdateFormProvider.tsx
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserUpdateFormProvider.tsx
#: src/timber/components/buyer/BuyerForm/BuyerUpdateFormProvider.tsx
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserUpdateFormProvider.tsx
#: src/timber/components/contractor/ContractorForm/ContractorUpdateFormProvider.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateFormProvider.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateFormProvider.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateFormProvider.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerUpdateFormProvider.tsx
#: src/timber/components/log/LogForm/LogUpdateFormProvider.tsx
#: src/timber/components/price/PriceForm/PriceUpdateFormProvider.tsx
#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileUpdateFormProvider.tsx
#: src/timber/components/provider/ProviderForm/ProviderUpdateFormProvider.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserUpdateFormProvider.tsx
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierUpdateFormProvider.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateFormProvider.tsx
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateFormProvider.tsx
#: src/timber/components/timberClass/TimberClassForm/TimberClassUpdateFormProvider.tsx
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateFormProvider.tsx
#: src/timber/components/timberType/TimberTypeForm/TimberTypeUpdateFormProvider.tsx
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingUpdateFormProvider.tsx
msgid "Update"
msgstr "Ažuriraj"

#: src/timber/pages/accountingUser/AccountingUserUpdateEditPage.tsx
msgid "Update Accounting User"
msgstr "Ažuriraj računovođu"

#: src/address/pages/address/AddressUpdateEditPage.tsx
msgid "Update Address"
msgstr "Ažuriraj Adresu"

#: src/timber/pages/buyer/BuyerUpdateEditPage.tsx
msgid "Update Buyer"
msgstr "Ažuriraj Kupca"

#: src/timber/pages/buyerUser/BuyerUserUpdateEditPage.tsx
msgid "Update Buyer User"
msgstr "Ažuriraj Korisnika Kupca"

#: src/timber/pages/contractor/ContractorUpdateEditPage.tsx
msgid "Update Contractor"
msgstr "Ažuriraj Izvođača"

#: src/timber/pages/contractorUser/ContractorUserUpdateEditPage.tsx
msgid "Update Contractor User"
msgstr "Ažuriraj Korisnika Izvođača"

#: src/timber/pages/cordwood/CordwoodUpdateEditPage.tsx
msgid "Update Cordwood"
msgstr "Ažuriraj Višemetricu"

#: src/timber/pages/cordwoodHistory/CordwoodHistoryUpdateEditPage.tsx
msgid "Update Cordwood History"
msgstr "Ažuriraj Povijest Višemetrice"

#: src/timber/pages/cutting/CuttingUpdateEditPage.tsx
msgid "Update Cutting"
msgstr "Ažuriraj sječu"

#: src/timber/pages/driver/DriverUpdateEditPage.tsx
#~ msgid "Update Driver"
#~ msgstr "Ažuriraj Vozača"

#: src/address/hooks/useAddress.ts
#: src/auth/hooks/useMembersGroup.ts
#: src/auth/hooks/useRole.ts
#: src/auth/hooks/useScopeGroup.ts
#: src/auth/hooks/useUser.ts
#: src/auth/hooks/useUserSession.ts
#: src/location/hooks/useLocation.ts
#: src/timber/hooks/useAccountingUser.ts
#: src/timber/hooks/useBuyer.ts
#: src/timber/hooks/useBuyerUser.ts
#: src/timber/hooks/useContractor.ts
#: src/timber/hooks/useContractorUser.ts
#: src/timber/hooks/useCordwood.ts
#: src/timber/hooks/useCutting.ts
#: src/timber/hooks/useForestOwner.ts
#: src/timber/hooks/useLog.ts
#: src/timber/hooks/usePrice.ts
#: src/timber/hooks/usePricingProfile.ts
#: src/timber/hooks/useProvider.ts
#: src/timber/hooks/useProviderUser.ts
#: src/timber/hooks/useRoadCarrier.ts
#: src/timber/hooks/useShipment.ts
#: src/timber/hooks/useThicknessClass.ts
#: src/timber/hooks/useTimberClass.ts
#: src/timber/hooks/useTimberStorage.ts
#: src/timber/hooks/useTimberType.ts
#: src/timber/hooks/useTreeMarking.ts
msgid "Update error: "
msgstr "Greška pri ažuriranju: "

#: src/timber/pages/forestOwner/ForestOwnerUpdateEditPage.tsx
msgid "Update Forest Owner"
msgstr "Ažuriraj Vlasnika Šume"

#: src/location/pages/location/LocationUpdateEditPage.tsx
msgid "Update Location"
msgstr "Ažuriraj Lokaciju"

#: src/timber/pages/log/LogUpdateEditPage.tsx
msgid "Update Log"
msgstr "Ažuriraj Trupac"

#: src/timber/pages/logHistory/LogHistoryUpdateEditPage.tsx
msgid "Update Log History"
msgstr "Ažuriraj Povijest Trupca"

#: src/auth/pages/membersGroup/MembersGroupUpdateEditPage.tsx
msgid "Update Members Group"
msgstr "Ažuriraj Grupu Članova"

#: src/auth/pages/membersGroupUser/MembersGroupUserUpdateEditPage.tsx
msgid "Update Members Group User"
msgstr "Ažuriraj Korisnika Grupe Članova"

#: src/timber/pages/price/PriceUpdateEditPage.tsx
msgid "Update Price"
msgstr "Ažuriraj cijenu"

#: src/timber/pages/pricingProfile/PricingProfileUpdateEditPage.tsx
msgid "Update Pricing Profile"
msgstr "Ažuriraj cijenovni razred"

#: src/timber/pages/provider/ProviderUpdateEditPage.tsx
msgid "Update Provider"
msgstr "Ažuriraj pružatelja usluge"

#: src/timber/pages/providerUser/ProviderUserUpdateEditPage.tsx
msgid "Update Provider User"
msgstr "Ažuriraj Korisnika pružatelja usluge"

#: src/timber/pages/roadCarrier/RoadCarrierUpdateEditPage.tsx
msgid "Update Road Carrier"
msgstr "Promijeni prijevoznika"

#: src/auth/pages/role/RoleUpdateEditPage.tsx
msgid "Update Role"
msgstr "Ažuriraj Ulogu"

#: src/auth/pages/roleAssignment/RoleAssignmentUpdateEditPage.tsx
msgid "Update Role Assignment"
msgstr "Ažuriraj Dodjelu Uloge"

#: src/auth/pages/rolePermission/RolePermissionUpdateEditPage.tsx
msgid "Update Role Permission"
msgstr "Ažuriraj Dozvolu Uloge"

#: src/auth/pages/scopeGroup/ScopeGroupUpdateEditPage.tsx
msgid "Update Scope Group"
msgstr "Ažuriraj Grupni Domet"

#: src/timber/pages/shipment/ShipmentUpdateEditPage.tsx
msgid "Update Shipment"
msgstr "Ažuriraj Pošiljku"

#: src/timber/pages/shipmentHistory/ShipmentHistoryUpdateEditPage.tsx
msgid "Update Shipment History"
msgstr "Ažuriraj Povijest Pošiljke"

#: src/timber/pages/thicknessClass/ThicknessClassUpdateEditPage.tsx
msgid "Update Thickness Class"
msgstr "Ažuriraj Klase Debljine"

#: src/timber/pages/timberClass/TimberClassUpdateEditPage.tsx
msgid "Update Timber Class"
msgstr "Ažuriraj Klase Drva"

#: src/timber/pages/timberStorage/TimberStorageUpdateEditPage.tsx
msgid "Update Timber Storage"
msgstr "Ažuriraj Skladište Drva"

#: src/timber/pages/timberType/TimberTypeUpdateEditPage.tsx
msgid "Update Timber Type"
msgstr "Ažuriraj Vrstu Drva"

#: src/timber/pages/treeMarking/TreeMarkingUpdateEditPage.tsx
msgid "Update Tree Marking"
msgstr "Ažuriraj doznaku"

#: src/auth/pages/user/UserUpdateEditPage.tsx
msgid "Update User"
msgstr "Ažuriraj Korisnika"

#: src/address/pages/userAddress/UserAddressUpdateEditPage.tsx
msgid "Update User Address"
msgstr "Ažuriraj Korisničku Adresu"

#: src/auth/pages/userSession/UserSessionUpdateEditPage.tsx
msgid "Update User Session"
msgstr "Ažuriraj Korisničku Sesiju"

#: src/timber/components/history/HistoryList/HistoryListSearch.tsx
#: src/timber/types/models/MergedHistory.ts
msgid "Updated"
msgstr "Promijenjen"

#: src/auth/components/user/UserDetail/UserDetail.tsx
#: src/auth/components/userSession/UserSessionDetail/UserSessionDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx
msgid "Updated At"
msgstr "Ažurirano"

#: src/timber/components/history/HistoryList/HistoryListSearch.tsx
msgid "Updated From"
msgstr "Promjena od"

#: src/timber/components/history/HistoryList/HistoryListSearch.tsx
msgid "Updated To"
msgstr "Promjena do"

#: src/timber/components/shipment/ShipmentDetail/ShipmentTabs.tsx
msgid "Upload"
msgstr "Učitaj"

#: src/timber/components/shipment/ShipmentRegulator/LogShipmentUpload.tsx
msgid "Upload file"
msgstr "Učitaj datoteku"

#: src/address/components/userAddress/UserAddressDetail/UserAddressDetail.tsx
#: src/address/components/userAddress/UserAddressForm/UserAddressAddForm.tsx
#: src/address/components/userAddress/UserAddressList/UserAddressListItem.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserDetail/MembersGroupUserDetail.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListItem.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListSearch.tsx
#: src/auth/components/user/UserDetail/UserDetail.tsx
#: src/auth/components/userSession/UserSessionDetail/UserSessionDetail.tsx
#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx
#: src/auth/components/userSession/UserSessionList/UserSessionListItem.tsx
#: src/auth/pages/user/UserEntityPage.tsx
msgid "User"
msgstr "Korisnik"

#: src/auth/hooks/useUser.ts
msgid "User add error: "
msgstr "Greška pri dodavanju korisnika: "

#: src/address/components/userAddress/UserAddressDetail/UserAddressDetail.tsx
#: src/address/pages/userAddress/UserAddressEntityPage.tsx
msgid "User Address"
msgstr "Korisnička Adresa"

#: src/address/hooks/useUserAddress.ts
msgid "User Address add error: "
msgstr "Greška pri dodavanju korisničke adrese: "

#: src/address/hooks/useUserAddress.ts
msgid "User Address delete error: "
msgstr "Greška pri brisanju korisničke adrese: "

#: src/address/hooks/useUserAddress.ts
msgid "User Address deleted"
msgstr "Korisnička adresa je obrisana"

#: src/address/components/userAddress/UserAddressList/UserAddressListHeader.tsx
#: src/app/mappers.tsx
#: src/auth/components/user/UserDetail/UserTabs.tsx
msgid "User Addresses"
msgstr "Korisničke adrese"

#: src/auth/hooks/useUser.ts
msgid "User delete error: "
msgstr "Greška pri brisanju korisnika: "

#: src/auth/hooks/useUser.ts
msgid "User deleted"
msgstr "Korisnik je obrisan"

#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx
#: src/auth/types/models/GroupType.d.ts
msgid "User Group"
msgstr "Korisnička Grupa"

#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx
#~ msgid "User Group Id is required"
#~ msgstr "ID grupe korisnika je obavezan"

#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx
msgid "User Group is required"
msgstr "Grupa korisnika je obavezna"

#: src/address/components/userAddress/UserAddressForm/UserAddressAddForm.tsx
#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx
#~ msgid "User Id is required"
#~ msgstr "ID korisnika je obavezan"

#: src/address/components/userAddress/UserAddressForm/UserAddressAddForm.tsx
#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx
msgid "User is required"
msgstr "Korinik je obavezan"

#: src/auth/components/userSession/UserSessionDetail/UserSessionDetail.tsx
#: src/auth/pages/userSession/UserSessionEntityPage.tsx
msgid "User Session"
msgstr "Korisnička Sesija"

#: src/auth/hooks/useUserSession.ts
msgid "User Session add error: "
msgstr "Greška pri dodavanju korisničke sesije: "

#: src/auth/hooks/useUserSession.ts
msgid "User Session delete error: "
msgstr "Greška pri brisanju korisničke sesije: "

#: src/auth/hooks/useUserSession.ts
msgid "User Session deleted"
msgstr "Korisnička sesija je obrisana"

#: src/auth/hooks/useUserSession.ts
msgid "User Session update error: "
msgstr "Greška pri ažuriranju korisničke sesije: "

#: src/auth/hooks/useUserSession.ts
msgid "User Session updated"
msgstr "Korisnička sesija je ažurirana"

#: src/app/mappers.tsx
#: src/auth/components/user/UserDetail/UserTabs.tsx
#: src/auth/components/userSession/UserSessionList/UserSessionListHeader.tsx
msgid "User Sessions"
msgstr "Korisničke sesije"

#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListItem.tsx
#: src/timber/components/providerUser/ProviderUserDetail/ProviderUserDetail.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserUpdateForm.tsx
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListItem.tsx
msgid "User Type"
msgstr "Tip Korisnika"

#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserUpdateForm.tsx
msgid "User Type is required"
msgstr "Tip korisnika je obavezan"

#: src/auth/hooks/useUser.ts
msgid "User update error: "
msgstr "Greška pri ažuriranju korisnika: "

#: src/auth/hooks/useUser.ts
msgid "User updated"
msgstr "Korisnik je ažuriran"

#: src/app/mappers.tsx
#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupTabs.tsx
#: src/auth/components/user/UserList/UserListHeader.tsx
#: src/auth/pages/listItems.tsx
msgid "Users"
msgstr "Korisnici"

#: src/timber/components/buyer/BuyerDetail/BuyerDetail.tsx
#: src/timber/components/buyer/BuyerForm/BuyerAddForm.tsx
#: src/timber/components/buyer/BuyerForm/BuyerUpdateForm.tsx
#: src/timber/components/buyer/BuyerList/BuyerListItem.tsx
#: src/timber/components/contractor/ContractorDetail/ContractorDetail.tsx
#: src/timber/components/contractor/ContractorForm/ContractorAddForm.tsx
#: src/timber/components/contractor/ContractorForm/ContractorUpdateForm.tsx
#: src/timber/components/contractor/ContractorList/ContractorListItem.tsx
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerDetail.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerAddForm.tsx
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerUpdateForm.tsx
#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListItem.tsx
#: src/timber/components/provider/ProviderDetail/ProviderDetail.tsx
#: src/timber/components/provider/ProviderForm/ProviderAddForm.tsx
#: src/timber/components/provider/ProviderForm/ProviderUpdateForm.tsx
#: src/timber/components/provider/ProviderList/ProviderListItem.tsx
msgid "Vat Id"
msgstr "PDV ID"

#: src/share/components/footer/Copyright.tsx
msgid "Version"
msgstr "Verzija"

#: src/address/components/address/AddressList/AddressListItemTools.tsx
#: src/address/components/userAddress/UserAddressList/UserAddressListItemTools.tsx
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListItemTools.tsx
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListItemTools.tsx
#: src/auth/components/role/RoleList/RoleListItemTools.tsx
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListItemTools.tsx
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListItemTools.tsx
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListItemTools.tsx
#: src/auth/components/user/UserList/UserListItemTools.tsx
#: src/auth/components/userSession/UserSessionList/UserSessionListItemTools.tsx
#: src/location/components/location/LocationList/LocationListItemTools.tsx
#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListItemTools.tsx
#: src/timber/components/buyer/BuyerList/BuyerListItemTools.tsx
#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListItemTools.tsx
#: src/timber/components/contractor/ContractorList/ContractorListItemTools.tsx
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListItemTools.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListItemTools.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItemTools.tsx
#: src/timber/components/cutting/CuttingList/CuttingListItemTools.tsx
#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListItemTools.tsx
#: src/timber/components/log/LogList/LogListItemTools.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItemTools.tsx
#: src/timber/components/price/PriceList/PriceListItemTools.tsx
#: src/timber/components/pricingProfile/PricingProfileList/PricingProfileListItemTools.tsx
#: src/timber/components/provider/ProviderList/ProviderListItemTools.tsx
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListItemTools.tsx
#: src/timber/components/roadCarrier/RoadCarrierList/RoadCarrierListItemTools.tsx
#: src/timber/components/shipment/ShipmentList/ShipmentListItemTools.tsx
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItemTools.tsx
#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListItemTools.tsx
#: src/timber/components/timberClass/TimberClassList/TimberClassListItemTools.tsx
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListItemTools.tsx
#: src/timber/components/timberType/TimberTypeList/TimberTypeListItemTools.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListItemTools.tsx
#: src/timber/types/models/UserType.d.ts
msgid "View"
msgstr "Pregledaj"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx
#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx
#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemFromHistory.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx
msgid "Volume"
msgstr "Volumen"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddForm.tsx
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingUpdateForm.tsx
msgid "Volume (m&#xB3;)"
msgstr "Volumen (m³)"

#: src/timber/components/log/LogList/LogListSearch.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListSearch.tsx
msgid "Volume (m&#xB3;) From"
msgstr "Volumen (m³) Od"

#: src/timber/components/log/LogList/LogListSearch.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListSearch.tsx
msgid "Volume (m&#xB3;) To"
msgstr "Volumen (m³) Do"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx
#: src/timber/components/generic/report/GenericRootShipments.tsx
#: src/timber/components/generic/report/GenericRootTable.tsx
#: src/timber/components/log/LogDetail/LogDetail.tsx
#: src/timber/components/log/LogList/LogListItem.tsx
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx
#: src/timber/components/provider/ProviderDetail/ProviderSplitTab.tsx
#: src/timber/components/provider/ProviderList/ProviderListItem.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemFromHistory.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx
#: src/timber/components/treeMarking/TreeMarkingDetail/TreeMarkingDetail.tsx
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListItem.tsx
msgid "Volume (m³)"
msgstr "Volumen (m³)"

#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
msgid "Volume From"
msgstr "Volumen od"

#: src/timber/components/generic/report/ParetoChart.tsx
msgid "Volume of everything that was produced"
msgstr "Volumen svega što je proizvedeno"

#: src/timber/components/generic/report/ParetoChart.tsx
msgid "Volume of the timber that left the storage"
msgstr "Volumen drvne mase koja je otpremljena iz skladišta"

#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
msgid "Volume To"
msgstr "Volumen do"

#: src/timber/components/history/HistoryList/HistoryListItem.tsx
msgid "Volume/Type"
msgstr "Volumen/Tip"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
#~ msgid "Warehouse Location Id is required"
#~ msgstr "ID lokacije skladišta je obavezan"

#: src/pages/ForgotPasswordPage.tsx
msgid "We have sent you a password recovery email."
msgstr "Poslali smo vam email za oporavak lozinke."

#: src/pages/PrivacyPolicyPage.tsx
msgid "We respect your privacy. This application stores only the data necessary to provide the service and your account access. We do not use non-essential cookies or tracking without your consent."
msgstr "Poštujemo vašu privatnost. Ova aplikacija pohranjuje samo podatke potrebne za pružanje usluge i pristup vašem računu. Ne koristimo nebitne kolačiće ili praćenje bez vašeg pristanka."

#: src/share/components/gdpr/CookieConsent.tsx
msgid "We use necessary cookies to make this app work. We will not use non-essential cookies without your consent."
msgstr "Koristimo potrebne kolačiće kako bi ova aplikacija funkcionirala. Nećemo koristiti nebitne kolačiće bez vašeg pristanka."

#: src/pages/LoginPage.tsx
msgid "Welcome Back!"
msgstr "Dobrodošli nazad!"

#: src/share/components/chat/ChatThread.tsx
#~ msgid "Which buyers are active?"
#~ msgstr "Koji su kupci aktivni?"

#: src/share/components/chat/ChatHeader.tsx
msgid "Widen chat"
msgstr "Proširi chat"

#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx
msgid "Without shipment"
msgstr "Bez otpreme"

#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx
msgid "Work Order"
msgstr "Radni Nalog"

#: src/share/components/chat/ChatSpinner.tsx
msgid "Working"
msgstr "U tijeku"

#: src/share/components/chat/ChatToolView.tsx
msgid "yes"
msgstr "Da"

#: src/timber/components/history/HistoryList/HistoryListItemRow.tsx
msgid "Yes"
msgstr "Da"

#: src/share/components/chat/ConversationList.tsx
#: src/share/components/form/FormDateTime/FormDateRange.tsx
msgid "Yesterday"
msgstr "Jučer"

#: src/share/components/gdpr/CookieConsent.tsx
msgid "You declined the Terms and Policy. You cannot use the app until you accept them. Reset to start over."
msgstr "Odbili ste Uvjete i pravila. Ne možete koristiti aplikaciju dok ih ne prihvatite. Resetirajte za ispočetka."

#: src/pages/PrivacyPolicyPage.tsx
msgid "You may request an export of your personal data or request deletion of your account by visiting your Profile or contacting support."
msgstr "Možete zatražiti izvoz svojih osobnih podataka ili brisanje računa posjetom svom profilu ili kontaktiranjem podrške."

#: src/hooks/useAuth.ts
msgid "You successfully logged in"
msgstr "Uspješno ste se prijavili"
